
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3663"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3663"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ih19M", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kyM0p"));

});
parcelRegister("kyM0p", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $ef7c3885563104b0$export$ffb0004e005737fa; }, function (v) { return $ef7c3885563104b0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $ef7c3885563104b0$export$34b9dba7ce09269b; }, function (v) { return $ef7c3885563104b0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $ef7c3885563104b0$export$25062201e9e25d76; }, function (v) { return $ef7c3885563104b0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ef7c3885563104b0$export$ffb0004e005737fa;
var $ef7c3885563104b0$export$34b9dba7ce09269b;
var $ef7c3885563104b0$export$25062201e9e25d76;
"use strict";
var $ef7c3885563104b0$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $ef7c3885563104b0$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $ef7c3885563104b0$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $ef7c3885563104b0$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$ef7c3885563104b0$export$ffb0004e005737fa = $ef7c3885563104b0$var$REACT_FRAGMENT_TYPE;
$ef7c3885563104b0$export$34b9dba7ce09269b = $ef7c3885563104b0$var$jsxProd;
$ef7c3885563104b0$export$25062201e9e25d76 = $ef7c3885563104b0$var$jsxProd;

});


parcelRegister("bh6RR", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bjR3q"));

});
parcelRegister("bjR3q", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $83da9f8ce41d3d63$export$9c16c1426311996d; }, function (v) { return $83da9f8ce41d3d63$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $83da9f8ce41d3d63$export$dca3b0875bd9a954; }, function (v) { return $83da9f8ce41d3d63$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $83da9f8ce41d3d63$export$16fa2f45be04daa8; }, function (v) { return $83da9f8ce41d3d63$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $83da9f8ce41d3d63$export$ffb0004e005737fa; }, function (v) { return $83da9f8ce41d3d63$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $83da9f8ce41d3d63$export$e2c29f18771995cb; }, function (v) { return $83da9f8ce41d3d63$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $83da9f8ce41d3d63$export$221d75b3f55bb0bd; }, function (v) { return $83da9f8ce41d3d63$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $83da9f8ce41d3d63$export$5f8d39834fd61797; }, function (v) { return $83da9f8ce41d3d63$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $83da9f8ce41d3d63$export$74bf444e3cd11ea5; }, function (v) { return $83da9f8ce41d3d63$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $83da9f8ce41d3d63$export$1ced07cd6b1985ce; }, function (v) { return $83da9f8ce41d3d63$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $83da9f8ce41d3d63$export$abd8e32b826d7ea7; }, function (v) { return $83da9f8ce41d3d63$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $83da9f8ce41d3d63$export$69a3209f1a06c04d; }, function (v) { return $83da9f8ce41d3d63$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $83da9f8ce41d3d63$export$8c538325882c7eec; }, function (v) { return $83da9f8ce41d3d63$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $83da9f8ce41d3d63$export$e530037191fcd5d7; }, function (v) { return $83da9f8ce41d3d63$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $83da9f8ce41d3d63$export$fd42f52fd3ae1109; }, function (v) { return $83da9f8ce41d3d63$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $83da9f8ce41d3d63$export$c8a8987d4410bf2d; }, function (v) { return $83da9f8ce41d3d63$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $83da9f8ce41d3d63$export$7d1e3a5e95ceca43; }, function (v) { return $83da9f8ce41d3d63$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $83da9f8ce41d3d63$export$257a8862b851cb5b; }, function (v) { return $83da9f8ce41d3d63$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $83da9f8ce41d3d63$export$a8257692ac88316c; }, function (v) { return $83da9f8ce41d3d63$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $83da9f8ce41d3d63$export$488013bae63b21da; }, function (v) { return $83da9f8ce41d3d63$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $83da9f8ce41d3d63$export$7c73462e0d25e514; }, function (v) { return $83da9f8ce41d3d63$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $83da9f8ce41d3d63$export$7568632d0d33d16d; }, function (v) { return $83da9f8ce41d3d63$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $83da9f8ce41d3d63$export$f93f40ac0ca7e3a8; }, function (v) { return $83da9f8ce41d3d63$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $83da9f8ce41d3d63$export$1f96ae73734a86cc; }, function (v) { return $83da9f8ce41d3d63$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $83da9f8ce41d3d63$export$9a47ced3238df325; }, function (v) { return $83da9f8ce41d3d63$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $83da9f8ce41d3d63$export$35808ee640e87ca7; }, function (v) { return $83da9f8ce41d3d63$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $83da9f8ce41d3d63$export$fae74005e78b1a27; }, function (v) { return $83da9f8ce41d3d63$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $83da9f8ce41d3d63$export$dc8fbce3eb94dc1e; }, function (v) { return $83da9f8ce41d3d63$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $83da9f8ce41d3d63$export$6a7bc4e911dc01cf; }, function (v) { return $83da9f8ce41d3d63$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $83da9f8ce41d3d63$export$6d9c69b0de29b591; }, function (v) { return $83da9f8ce41d3d63$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $83da9f8ce41d3d63$export$7f54fc3180508a52; }, function (v) { return $83da9f8ce41d3d63$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $83da9f8ce41d3d63$export$f680877a34711e37; }, function (v) { return $83da9f8ce41d3d63$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $83da9f8ce41d3d63$export$d5a552a76deda3c2; }, function (v) { return $83da9f8ce41d3d63$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $83da9f8ce41d3d63$export$aaabe4eda9ed9969; }, function (v) { return $83da9f8ce41d3d63$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $83da9f8ce41d3d63$export$e5c5a5f917a5871c; }, function (v) { return $83da9f8ce41d3d63$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $83da9f8ce41d3d63$export$1538c33de8887b59; }, function (v) { return $83da9f8ce41d3d63$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $83da9f8ce41d3d63$export$fca7f784ae7a249a; }, function (v) { return $83da9f8ce41d3d63$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $83da9f8ce41d3d63$export$13e3392192263954; }, function (v) { return $83da9f8ce41d3d63$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $83da9f8ce41d3d63$export$b8f5890fc79d6aca; }, function (v) { return $83da9f8ce41d3d63$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $83da9f8ce41d3d63$export$60241385465d0a34; }, function (v) { return $83da9f8ce41d3d63$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $83da9f8ce41d3d63$export$306c0aa65ff9ec16; }, function (v) { return $83da9f8ce41d3d63$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $83da9f8ce41d3d63$export$7b286972b8d8ccbf; }, function (v) { return $83da9f8ce41d3d63$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $83da9f8ce41d3d63$export$83d89fbfd8236492; }, function (v) { return $83da9f8ce41d3d63$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $83da9f8ce41d3d63$export$9c16c1426311996d;
var $83da9f8ce41d3d63$export$dca3b0875bd9a954;
var $83da9f8ce41d3d63$export$16fa2f45be04daa8;
var $83da9f8ce41d3d63$export$ffb0004e005737fa;
var $83da9f8ce41d3d63$export$e2c29f18771995cb;
var $83da9f8ce41d3d63$export$221d75b3f55bb0bd;
var $83da9f8ce41d3d63$export$5f8d39834fd61797;
var $83da9f8ce41d3d63$export$74bf444e3cd11ea5;
var $83da9f8ce41d3d63$export$1ced07cd6b1985ce;
var $83da9f8ce41d3d63$export$abd8e32b826d7ea7;
var $83da9f8ce41d3d63$export$69a3209f1a06c04d;
var $83da9f8ce41d3d63$export$8c538325882c7eec;
var $83da9f8ce41d3d63$export$e530037191fcd5d7;
var $83da9f8ce41d3d63$export$fd42f52fd3ae1109;
var $83da9f8ce41d3d63$export$c8a8987d4410bf2d;
var $83da9f8ce41d3d63$export$7d1e3a5e95ceca43;
var $83da9f8ce41d3d63$export$257a8862b851cb5b;
var $83da9f8ce41d3d63$export$a8257692ac88316c;
var $83da9f8ce41d3d63$export$488013bae63b21da;
var $83da9f8ce41d3d63$export$7c73462e0d25e514;
var $83da9f8ce41d3d63$export$7568632d0d33d16d;
var $83da9f8ce41d3d63$export$f93f40ac0ca7e3a8;
var $83da9f8ce41d3d63$export$1f96ae73734a86cc;
var $83da9f8ce41d3d63$export$9a47ced3238df325;
var $83da9f8ce41d3d63$export$35808ee640e87ca7;
var $83da9f8ce41d3d63$export$fae74005e78b1a27;
var $83da9f8ce41d3d63$export$dc8fbce3eb94dc1e;
var $83da9f8ce41d3d63$export$6a7bc4e911dc01cf;
var $83da9f8ce41d3d63$export$6d9c69b0de29b591;
var $83da9f8ce41d3d63$export$7f54fc3180508a52;
var $83da9f8ce41d3d63$export$f680877a34711e37;
var $83da9f8ce41d3d63$export$d5a552a76deda3c2;
var $83da9f8ce41d3d63$export$aaabe4eda9ed9969;
var $83da9f8ce41d3d63$export$e5c5a5f917a5871c;
var $83da9f8ce41d3d63$export$1538c33de8887b59;
var $83da9f8ce41d3d63$export$fca7f784ae7a249a;
var $83da9f8ce41d3d63$export$13e3392192263954;
var $83da9f8ce41d3d63$export$b8f5890fc79d6aca;
var $83da9f8ce41d3d63$export$60241385465d0a34;
var $83da9f8ce41d3d63$export$306c0aa65ff9ec16;
var $83da9f8ce41d3d63$export$7b286972b8d8ccbf;
var $83da9f8ce41d3d63$export$83d89fbfd8236492;
"use strict";
var $83da9f8ce41d3d63$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $83da9f8ce41d3d63$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $83da9f8ce41d3d63$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $83da9f8ce41d3d63$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $83da9f8ce41d3d63$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $83da9f8ce41d3d63$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $83da9f8ce41d3d63$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $83da9f8ce41d3d63$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $83da9f8ce41d3d63$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $83da9f8ce41d3d63$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $83da9f8ce41d3d63$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $83da9f8ce41d3d63$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $83da9f8ce41d3d63$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $83da9f8ce41d3d63$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $83da9f8ce41d3d63$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$83da9f8ce41d3d63$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $83da9f8ce41d3d63$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $83da9f8ce41d3d63$var$assign = Object.assign, $83da9f8ce41d3d63$var$emptyObject = {};
function $83da9f8ce41d3d63$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $83da9f8ce41d3d63$var$emptyObject;
    this.updater = updater || $83da9f8ce41d3d63$var$ReactNoopUpdateQueue;
}
$83da9f8ce41d3d63$var$Component.prototype.isReactComponent = {};
$83da9f8ce41d3d63$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$83da9f8ce41d3d63$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $83da9f8ce41d3d63$var$ComponentDummy() {}
$83da9f8ce41d3d63$var$ComponentDummy.prototype = $83da9f8ce41d3d63$var$Component.prototype;
function $83da9f8ce41d3d63$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $83da9f8ce41d3d63$var$emptyObject;
    this.updater = updater || $83da9f8ce41d3d63$var$ReactNoopUpdateQueue;
}
var $83da9f8ce41d3d63$var$pureComponentPrototype = $83da9f8ce41d3d63$var$PureComponent.prototype = new $83da9f8ce41d3d63$var$ComponentDummy();
$83da9f8ce41d3d63$var$pureComponentPrototype.constructor = $83da9f8ce41d3d63$var$PureComponent;
$83da9f8ce41d3d63$var$assign($83da9f8ce41d3d63$var$pureComponentPrototype, $83da9f8ce41d3d63$var$Component.prototype);
$83da9f8ce41d3d63$var$pureComponentPrototype.isPureReactComponent = !0;
var $83da9f8ce41d3d63$var$isArrayImpl = Array.isArray;
function $83da9f8ce41d3d63$var$noop() {}
var $83da9f8ce41d3d63$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $83da9f8ce41d3d63$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $83da9f8ce41d3d63$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $83da9f8ce41d3d63$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $83da9f8ce41d3d63$var$cloneAndReplaceKey(oldElement, newKey) {
    return $83da9f8ce41d3d63$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $83da9f8ce41d3d63$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $83da9f8ce41d3d63$var$REACT_ELEMENT_TYPE;
}
function $83da9f8ce41d3d63$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $83da9f8ce41d3d63$var$userProvidedKeyEscapeRegex = /\/+/g;
function $83da9f8ce41d3d63$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $83da9f8ce41d3d63$var$escape("" + element.key) : index.toString(36);
}
function $83da9f8ce41d3d63$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($83da9f8ce41d3d63$var$noop, $83da9f8ce41d3d63$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $83da9f8ce41d3d63$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $83da9f8ce41d3d63$var$REACT_ELEMENT_TYPE:
                case $83da9f8ce41d3d63$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $83da9f8ce41d3d63$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $83da9f8ce41d3d63$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $83da9f8ce41d3d63$var$getElementKey(children, 0) : nameSoFar, $83da9f8ce41d3d63$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($83da9f8ce41d3d63$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $83da9f8ce41d3d63$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($83da9f8ce41d3d63$var$isValidElement(callback) && (callback = $83da9f8ce41d3d63$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($83da9f8ce41d3d63$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($83da9f8ce41d3d63$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $83da9f8ce41d3d63$var$getElementKey(nameSoFar, i), invokeCallback += $83da9f8ce41d3d63$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $83da9f8ce41d3d63$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $83da9f8ce41d3d63$var$getElementKey(nameSoFar, i++), invokeCallback += $83da9f8ce41d3d63$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $83da9f8ce41d3d63$var$mapIntoArray($83da9f8ce41d3d63$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $83da9f8ce41d3d63$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $83da9f8ce41d3d63$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $83da9f8ce41d3d63$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $83da9f8ce41d3d63$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $83da9f8ce41d3d63$var$Children = {
    map: $83da9f8ce41d3d63$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $83da9f8ce41d3d63$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $83da9f8ce41d3d63$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $83da9f8ce41d3d63$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$83da9f8ce41d3d63$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$83da9f8ce41d3d63$export$9c16c1426311996d = $83da9f8ce41d3d63$var$REACT_ACTIVITY_TYPE;
$83da9f8ce41d3d63$export$dca3b0875bd9a954 = $83da9f8ce41d3d63$var$Children;
$83da9f8ce41d3d63$export$16fa2f45be04daa8 = $83da9f8ce41d3d63$var$Component;
$83da9f8ce41d3d63$export$ffb0004e005737fa = $83da9f8ce41d3d63$var$REACT_FRAGMENT_TYPE;
$83da9f8ce41d3d63$export$e2c29f18771995cb = $83da9f8ce41d3d63$var$REACT_PROFILER_TYPE;
$83da9f8ce41d3d63$export$221d75b3f55bb0bd = $83da9f8ce41d3d63$var$PureComponent;
$83da9f8ce41d3d63$export$5f8d39834fd61797 = $83da9f8ce41d3d63$var$REACT_STRICT_MODE_TYPE;
$83da9f8ce41d3d63$export$74bf444e3cd11ea5 = $83da9f8ce41d3d63$var$REACT_SUSPENSE_TYPE;
$83da9f8ce41d3d63$export$1ced07cd6b1985ce = $83da9f8ce41d3d63$var$ReactSharedInternals;
$83da9f8ce41d3d63$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$83da9f8ce41d3d63$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$83da9f8ce41d3d63$export$8c538325882c7eec = function() {
    return null;
};
$83da9f8ce41d3d63$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $83da9f8ce41d3d63$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$83da9f8ce41d3d63$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $83da9f8ce41d3d63$var$ReactElement(element.type, key, props);
};
$83da9f8ce41d3d63$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $83da9f8ce41d3d63$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $83da9f8ce41d3d63$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$83da9f8ce41d3d63$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$83da9f8ce41d3d63$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $83da9f8ce41d3d63$var$ReactElement(type, key, props);
};
$83da9f8ce41d3d63$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$83da9f8ce41d3d63$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $83da9f8ce41d3d63$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$83da9f8ce41d3d63$export$a8257692ac88316c = $83da9f8ce41d3d63$var$isValidElement;
$83da9f8ce41d3d63$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $83da9f8ce41d3d63$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $83da9f8ce41d3d63$var$lazyInitializer
    };
};
$83da9f8ce41d3d63$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $83da9f8ce41d3d63$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$83da9f8ce41d3d63$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $83da9f8ce41d3d63$var$ReactSharedInternals.T, currentTransition = {};
    $83da9f8ce41d3d63$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $83da9f8ce41d3d63$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($83da9f8ce41d3d63$var$noop, $83da9f8ce41d3d63$var$reportGlobalError);
    } catch (error) {
        $83da9f8ce41d3d63$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $83da9f8ce41d3d63$var$ReactSharedInternals.T = prevTransition;
    }
};
$83da9f8ce41d3d63$export$f93f40ac0ca7e3a8 = function() {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useCacheRefresh();
};
$83da9f8ce41d3d63$export$1f96ae73734a86cc = function(usable) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.use(usable);
};
$83da9f8ce41d3d63$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$83da9f8ce41d3d63$export$35808ee640e87ca7 = function(callback, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$83da9f8ce41d3d63$export$fae74005e78b1a27 = function(Context) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useContext(Context);
};
$83da9f8ce41d3d63$export$dc8fbce3eb94dc1e = function() {};
$83da9f8ce41d3d63$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$83da9f8ce41d3d63$export$6d9c69b0de29b591 = function(create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useEffect(create, deps);
};
$83da9f8ce41d3d63$export$7f54fc3180508a52 = function(callback) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$83da9f8ce41d3d63$export$f680877a34711e37 = function() {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useId();
};
$83da9f8ce41d3d63$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$83da9f8ce41d3d63$export$aaabe4eda9ed9969 = function(create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$83da9f8ce41d3d63$export$e5c5a5f917a5871c = function(create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$83da9f8ce41d3d63$export$1538c33de8887b59 = function(create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useMemo(create, deps);
};
$83da9f8ce41d3d63$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$83da9f8ce41d3d63$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$83da9f8ce41d3d63$export$b8f5890fc79d6aca = function(initialValue) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useRef(initialValue);
};
$83da9f8ce41d3d63$export$60241385465d0a34 = function(initialState) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useState(initialState);
};
$83da9f8ce41d3d63$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$83da9f8ce41d3d63$export$7b286972b8d8ccbf = function() {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useTransition();
};
$83da9f8ce41d3d63$export$83d89fbfd8236492 = "19.2.7";

});


parcelRegister("jpRqs", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $e229cb5c8b2cd629$export$882461b6382ed46c; }, function (v) { return $e229cb5c8b2cd629$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e229cb5c8b2cd629$export$757ceba2d55c277e; }, function (v) { return $e229cb5c8b2cd629$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $e229cb5c8b2cd629$export$83d89fbfd8236492; }, function (v) { return $e229cb5c8b2cd629$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e229cb5c8b2cd629$export$882461b6382ed46c;
var $e229cb5c8b2cd629$export$757ceba2d55c277e;
var $e229cb5c8b2cd629$export$83d89fbfd8236492;
"use strict";

var $4LCdk = parcelRequire("4LCdk");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");
function $e229cb5c8b2cd629$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $e229cb5c8b2cd629$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $e229cb5c8b2cd629$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $e229cb5c8b2cd629$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $e229cb5c8b2cd629$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $e229cb5c8b2cd629$var$assertIsMounted(fiber) {
    if ($e229cb5c8b2cd629$var$getNearestMountedFiber(fiber) !== fiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
}
function $e229cb5c8b2cd629$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $e229cb5c8b2cd629$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $e229cb5c8b2cd629$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $e229cb5c8b2cd629$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $e229cb5c8b2cd629$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $e229cb5c8b2cd629$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $e229cb5c8b2cd629$var$assign = Object.assign, $e229cb5c8b2cd629$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $e229cb5c8b2cd629$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $e229cb5c8b2cd629$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $e229cb5c8b2cd629$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $e229cb5c8b2cd629$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $e229cb5c8b2cd629$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $e229cb5c8b2cd629$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $e229cb5c8b2cd629$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $e229cb5c8b2cd629$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $e229cb5c8b2cd629$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $e229cb5c8b2cd629$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $e229cb5c8b2cd629$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $e229cb5c8b2cd629$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $e229cb5c8b2cd629$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$e229cb5c8b2cd629$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $e229cb5c8b2cd629$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $e229cb5c8b2cd629$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $e229cb5c8b2cd629$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $e229cb5c8b2cd629$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $e229cb5c8b2cd629$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $e229cb5c8b2cd629$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $e229cb5c8b2cd629$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $e229cb5c8b2cd629$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $e229cb5c8b2cd629$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $e229cb5c8b2cd629$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $e229cb5c8b2cd629$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $e229cb5c8b2cd629$var$getComponentNameFromType(type.type) || "Memo";
        case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $e229cb5c8b2cd629$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $e229cb5c8b2cd629$var$isArrayImpl = Array.isArray, $e229cb5c8b2cd629$var$ReactSharedInternals = $bh6RR.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $e229cb5c8b2cd629$var$ReactDOMSharedInternals = $6afFj.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $e229cb5c8b2cd629$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $e229cb5c8b2cd629$var$valueStack = [], $e229cb5c8b2cd629$var$index = -1;
function $e229cb5c8b2cd629$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $e229cb5c8b2cd629$var$pop(cursor) {
    0 > $e229cb5c8b2cd629$var$index || (cursor.current = $e229cb5c8b2cd629$var$valueStack[$e229cb5c8b2cd629$var$index], $e229cb5c8b2cd629$var$valueStack[$e229cb5c8b2cd629$var$index] = null, $e229cb5c8b2cd629$var$index--);
}
function $e229cb5c8b2cd629$var$push(cursor, value) {
    $e229cb5c8b2cd629$var$index++;
    $e229cb5c8b2cd629$var$valueStack[$e229cb5c8b2cd629$var$index] = cursor.current;
    cursor.current = value;
}
var $e229cb5c8b2cd629$var$contextStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$contextFiberStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$rootInstanceStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$hostTransitionProviderCursor = $e229cb5c8b2cd629$var$createCursor(null);
function $e229cb5c8b2cd629$var$pushHostContainer(fiber, nextRootInstance) {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$rootInstanceStackCursor, nextRootInstance);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextFiberStackCursor, fiber);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $e229cb5c8b2cd629$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $e229cb5c8b2cd629$var$getOwnHostContext(nextRootInstance), fiber = $e229cb5c8b2cd629$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextStackCursor);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextStackCursor, fiber);
}
function $e229cb5c8b2cd629$var$popHostContainer() {
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextStackCursor);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextFiberStackCursor);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$rootInstanceStackCursor);
}
function $e229cb5c8b2cd629$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$hostTransitionProviderCursor, fiber);
    var context = $e229cb5c8b2cd629$var$contextStackCursor.current;
    var JSCompiler_inline_result = $e229cb5c8b2cd629$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextFiberStackCursor, fiber), $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextStackCursor, JSCompiler_inline_result));
}
function $e229cb5c8b2cd629$var$popHostContext(fiber) {
    $e229cb5c8b2cd629$var$contextFiberStackCursor.current === fiber && ($e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextStackCursor), $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextFiberStackCursor));
    $e229cb5c8b2cd629$var$hostTransitionProviderCursor.current === fiber && ($e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$hostTransitionProviderCursor), $e229cb5c8b2cd629$var$HostTransitionContext._currentValue = $e229cb5c8b2cd629$var$sharedNotPendingObject);
}
var $e229cb5c8b2cd629$var$prefix, $e229cb5c8b2cd629$var$suffix;
function $e229cb5c8b2cd629$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $e229cb5c8b2cd629$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $e229cb5c8b2cd629$var$prefix = match && match[1] || "";
        $e229cb5c8b2cd629$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $e229cb5c8b2cd629$var$prefix + name + $e229cb5c8b2cd629$var$suffix;
}
var $e229cb5c8b2cd629$var$reentry = !1;
function $e229cb5c8b2cd629$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $e229cb5c8b2cd629$var$reentry) return "";
    $e229cb5c8b2cd629$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $e229cb5c8b2cd629$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $e229cb5c8b2cd629$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $e229cb5c8b2cd629$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("Suspense Fallback") : $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $e229cb5c8b2cd629$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $e229cb5c8b2cd629$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $e229cb5c8b2cd629$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $e229cb5c8b2cd629$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $e229cb5c8b2cd629$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $e229cb5c8b2cd629$var$hasOwnProperty = Object.prototype.hasOwnProperty, $e229cb5c8b2cd629$var$scheduleCallback$3 = $4LCdk.unstable_scheduleCallback, $e229cb5c8b2cd629$var$cancelCallback$1 = $4LCdk.unstable_cancelCallback, $e229cb5c8b2cd629$var$shouldYield = $4LCdk.unstable_shouldYield, $e229cb5c8b2cd629$var$requestPaint = $4LCdk.unstable_requestPaint, $e229cb5c8b2cd629$var$now = $4LCdk.unstable_now, $e229cb5c8b2cd629$var$getCurrentPriorityLevel = $4LCdk.unstable_getCurrentPriorityLevel, $e229cb5c8b2cd629$var$ImmediatePriority = $4LCdk.unstable_ImmediatePriority, $e229cb5c8b2cd629$var$UserBlockingPriority = $4LCdk.unstable_UserBlockingPriority, $e229cb5c8b2cd629$var$NormalPriority$1 = $4LCdk.unstable_NormalPriority, $e229cb5c8b2cd629$var$LowPriority = $4LCdk.unstable_LowPriority, $e229cb5c8b2cd629$var$IdlePriority = $4LCdk.unstable_IdlePriority, $e229cb5c8b2cd629$var$log$1 = $4LCdk.log, $e229cb5c8b2cd629$var$unstable_setDisableYieldValue = $4LCdk.unstable_setDisableYieldValue, $e229cb5c8b2cd629$var$rendererID = null, $e229cb5c8b2cd629$var$injectedHook = null;
function $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $e229cb5c8b2cd629$var$log$1 && $e229cb5c8b2cd629$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($e229cb5c8b2cd629$var$injectedHook && "function" === typeof $e229cb5c8b2cd629$var$injectedHook.setStrictMode) try {
        $e229cb5c8b2cd629$var$injectedHook.setStrictMode($e229cb5c8b2cd629$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $e229cb5c8b2cd629$var$clz32 = Math.clz32 ? Math.clz32 : $e229cb5c8b2cd629$var$clz32Fallback, $e229cb5c8b2cd629$var$log = Math.log, $e229cb5c8b2cd629$var$LN2 = Math.LN2;
function $e229cb5c8b2cd629$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($e229cb5c8b2cd629$var$log(x) / $e229cb5c8b2cd629$var$LN2 | 0) | 0;
}
var $e229cb5c8b2cd629$var$nextTransitionUpdateLane = 256, $e229cb5c8b2cd629$var$nextTransitionDeferredLane = 262144, $e229cb5c8b2cd629$var$nextRetryLane = 4194304;
function $e229cb5c8b2cd629$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $e229cb5c8b2cd629$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $e229cb5c8b2cd629$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e229cb5c8b2cd629$var$claimNextRetryLane() {
    var lane = $e229cb5c8b2cd629$var$nextRetryLane;
    $e229cb5c8b2cd629$var$nextRetryLane <<= 1;
    0 === ($e229cb5c8b2cd629$var$nextRetryLane & 62914560) && ($e229cb5c8b2cd629$var$nextRetryLane = 4194304);
    return lane;
}
function $e229cb5c8b2cd629$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $e229cb5c8b2cd629$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $e229cb5c8b2cd629$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $e229cb5c8b2cd629$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $e229cb5c8b2cd629$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $e229cb5c8b2cd629$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $e229cb5c8b2cd629$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $e229cb5c8b2cd629$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $e229cb5c8b2cd629$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $e229cb5c8b2cd629$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $e229cb5c8b2cd629$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $e229cb5c8b2cd629$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $e229cb5c8b2cd629$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $e229cb5c8b2cd629$var$resolveUpdatePriority() {
    var updatePriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $e229cb5c8b2cd629$var$getEventPriority(updatePriority.type);
}
function $e229cb5c8b2cd629$var$runWithPriority(priority, fn) {
    var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    try {
        return $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $e229cb5c8b2cd629$var$randomKey = Math.random().toString(36).slice(2), $e229cb5c8b2cd629$var$internalInstanceKey = "__reactFiber$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalPropsKey = "__reactProps$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalContainerInstanceKey = "__reactContainer$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalEventHandlersKey = "__reactEvents$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalEventHandlerListenersKey = "__reactListeners$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalEventHandlesSetKey = "__reactHandles$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalRootNodeResourcesKey = "__reactResources$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalHoistableMarker = "__reactMarker$" + $e229cb5c8b2cd629$var$randomKey;
function $e229cb5c8b2cd629$var$detachDeletedInstance(node) {
    delete node[$e229cb5c8b2cd629$var$internalInstanceKey];
    delete node[$e229cb5c8b2cd629$var$internalPropsKey];
    delete node[$e229cb5c8b2cd629$var$internalEventHandlersKey];
    delete node[$e229cb5c8b2cd629$var$internalEventHandlerListenersKey];
    delete node[$e229cb5c8b2cd629$var$internalEventHandlesSetKey];
}
function $e229cb5c8b2cd629$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$e229cb5c8b2cd629$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$e229cb5c8b2cd629$var$internalContainerInstanceKey] || parentNode[$e229cb5c8b2cd629$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $e229cb5c8b2cd629$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$e229cb5c8b2cd629$var$internalInstanceKey]) return parentNode;
                targetNode = $e229cb5c8b2cd629$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $e229cb5c8b2cd629$var$getInstanceFromNode(node) {
    if (node = node[$e229cb5c8b2cd629$var$internalInstanceKey] || node[$e229cb5c8b2cd629$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $e229cb5c8b2cd629$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(33));
}
function $e229cb5c8b2cd629$var$getResourcesFromRoot(root) {
    var resources = root[$e229cb5c8b2cd629$var$internalRootNodeResourcesKey];
    resources || (resources = root[$e229cb5c8b2cd629$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $e229cb5c8b2cd629$var$markNodeAsHoistable(node) {
    node[$e229cb5c8b2cd629$var$internalHoistableMarker] = !0;
}
var $e229cb5c8b2cd629$var$allNativeEvents = new Set(), $e229cb5c8b2cd629$var$registrationNameDependencies = {};
function $e229cb5c8b2cd629$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $e229cb5c8b2cd629$var$registerDirectEvent(registrationName, dependencies);
    $e229cb5c8b2cd629$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $e229cb5c8b2cd629$var$registerDirectEvent(registrationName, dependencies) {
    $e229cb5c8b2cd629$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$e229cb5c8b2cd629$var$allNativeEvents.add(dependencies[registrationName]);
}
var $e229cb5c8b2cd629$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $e229cb5c8b2cd629$var$illegalAttributeNameCache = {}, $e229cb5c8b2cd629$var$validatedAttributeNameCache = {};
function $e229cb5c8b2cd629$var$isAttributeNameSafe(attributeName) {
    if ($e229cb5c8b2cd629$var$hasOwnProperty.call($e229cb5c8b2cd629$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($e229cb5c8b2cd629$var$hasOwnProperty.call($e229cb5c8b2cd629$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($e229cb5c8b2cd629$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $e229cb5c8b2cd629$var$validatedAttributeNameCache[attributeName] = !0;
    $e229cb5c8b2cd629$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $e229cb5c8b2cd629$var$setValueForAttribute(node, name, value) {
    if ($e229cb5c8b2cd629$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $e229cb5c8b2cd629$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $e229cb5c8b2cd629$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $e229cb5c8b2cd629$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $e229cb5c8b2cd629$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $e229cb5c8b2cd629$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $e229cb5c8b2cd629$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $e229cb5c8b2cd629$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $e229cb5c8b2cd629$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $e229cb5c8b2cd629$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $e229cb5c8b2cd629$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $e229cb5c8b2cd629$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $e229cb5c8b2cd629$var$getToStringValue(value);
        } else element.value !== "" + $e229cb5c8b2cd629$var$getToStringValue(value) && (element.value = "" + $e229cb5c8b2cd629$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $e229cb5c8b2cd629$var$setDefaultValue(element, type, $e229cb5c8b2cd629$var$getToStringValue(value)) : null != defaultValue ? $e229cb5c8b2cd629$var$setDefaultValue(element, type, $e229cb5c8b2cd629$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $e229cb5c8b2cd629$var$getToStringValue(name) : element.removeAttribute("name");
}
function $e229cb5c8b2cd629$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $e229cb5c8b2cd629$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $e229cb5c8b2cd629$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $e229cb5c8b2cd629$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $e229cb5c8b2cd629$var$track(element);
}
function $e229cb5c8b2cd629$var$setDefaultValue(node, type, value) {
    "number" === type && $e229cb5c8b2cd629$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $e229cb5c8b2cd629$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $e229cb5c8b2cd629$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $e229cb5c8b2cd629$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $e229cb5c8b2cd629$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $e229cb5c8b2cd629$var$getToStringValue(defaultValue) : "";
}
function $e229cb5c8b2cd629$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(92));
            if ($e229cb5c8b2cd629$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $e229cb5c8b2cd629$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $e229cb5c8b2cd629$var$track(element);
}
function $e229cb5c8b2cd629$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $e229cb5c8b2cd629$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $e229cb5c8b2cd629$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $e229cb5c8b2cd629$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $e229cb5c8b2cd629$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $e229cb5c8b2cd629$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $e229cb5c8b2cd629$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $e229cb5c8b2cd629$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e229cb5c8b2cd629$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $e229cb5c8b2cd629$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $e229cb5c8b2cd629$var$sanitizeURL(url) {
    return $e229cb5c8b2cd629$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $e229cb5c8b2cd629$var$noop$1() {}
var $e229cb5c8b2cd629$var$currentReplayingEvent = null;
function $e229cb5c8b2cd629$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $e229cb5c8b2cd629$var$restoreTarget = null, $e229cb5c8b2cd629$var$restoreQueue = null;
function $e229cb5c8b2cd629$var$restoreStateOfTarget(target) {
    var internalInstance = $e229cb5c8b2cd629$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$e229cb5c8b2cd629$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $e229cb5c8b2cd629$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$e229cb5c8b2cd629$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(90));
                            $e229cb5c8b2cd629$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $e229cb5c8b2cd629$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $e229cb5c8b2cd629$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $e229cb5c8b2cd629$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $e229cb5c8b2cd629$var$isInsideEventHandler = !1;
function $e229cb5c8b2cd629$var$batchedUpdates$1(fn, a, b) {
    if ($e229cb5c8b2cd629$var$isInsideEventHandler) return fn(a, b);
    $e229cb5c8b2cd629$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($e229cb5c8b2cd629$var$isInsideEventHandler = !1, null !== $e229cb5c8b2cd629$var$restoreTarget || null !== $e229cb5c8b2cd629$var$restoreQueue) {
            if ($e229cb5c8b2cd629$var$flushSyncWork$1(), $e229cb5c8b2cd629$var$restoreTarget && (a = $e229cb5c8b2cd629$var$restoreTarget, fn = $e229cb5c8b2cd629$var$restoreQueue, $e229cb5c8b2cd629$var$restoreQueue = $e229cb5c8b2cd629$var$restoreTarget = null, $e229cb5c8b2cd629$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$e229cb5c8b2cd629$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $e229cb5c8b2cd629$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$e229cb5c8b2cd629$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $e229cb5c8b2cd629$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e229cb5c8b2cd629$var$passiveBrowserEventsSupported = !1;
if ($e229cb5c8b2cd629$var$canUseDOM) try {
    var $e229cb5c8b2cd629$var$options = {};
    Object.defineProperty($e229cb5c8b2cd629$var$options, "passive", {
        get: function() {
            $e229cb5c8b2cd629$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $e229cb5c8b2cd629$var$options, $e229cb5c8b2cd629$var$options);
    window.removeEventListener("test", $e229cb5c8b2cd629$var$options, $e229cb5c8b2cd629$var$options);
} catch (e) {
    $e229cb5c8b2cd629$var$passiveBrowserEventsSupported = !1;
}
var $e229cb5c8b2cd629$var$root = null, $e229cb5c8b2cd629$var$startText = null, $e229cb5c8b2cd629$var$fallbackText = null;
function $e229cb5c8b2cd629$var$getData() {
    if ($e229cb5c8b2cd629$var$fallbackText) return $e229cb5c8b2cd629$var$fallbackText;
    var start, startValue = $e229cb5c8b2cd629$var$startText, startLength = startValue.length, end, endValue = "value" in $e229cb5c8b2cd629$var$root ? $e229cb5c8b2cd629$var$root.value : $e229cb5c8b2cd629$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $e229cb5c8b2cd629$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $e229cb5c8b2cd629$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $e229cb5c8b2cd629$var$functionThatReturnsTrue() {
    return !0;
}
function $e229cb5c8b2cd629$var$functionThatReturnsFalse() {
    return !1;
}
function $e229cb5c8b2cd629$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $e229cb5c8b2cd629$var$functionThatReturnsTrue : $e229cb5c8b2cd629$var$functionThatReturnsFalse;
        this.isPropagationStopped = $e229cb5c8b2cd629$var$functionThatReturnsFalse;
        return this;
    }
    $e229cb5c8b2cd629$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $e229cb5c8b2cd629$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $e229cb5c8b2cd629$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $e229cb5c8b2cd629$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $e229cb5c8b2cd629$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e229cb5c8b2cd629$var$SyntheticEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$EventInterface), $e229cb5c8b2cd629$var$UIEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    view: 0,
    detail: 0
}), $e229cb5c8b2cd629$var$SyntheticUIEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$UIEventInterface), $e229cb5c8b2cd629$var$lastMovementX, $e229cb5c8b2cd629$var$lastMovementY, $e229cb5c8b2cd629$var$lastMouseEvent, $e229cb5c8b2cd629$var$MouseEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e229cb5c8b2cd629$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $e229cb5c8b2cd629$var$lastMouseEvent && ($e229cb5c8b2cd629$var$lastMouseEvent && "mousemove" === event.type ? ($e229cb5c8b2cd629$var$lastMovementX = event.screenX - $e229cb5c8b2cd629$var$lastMouseEvent.screenX, $e229cb5c8b2cd629$var$lastMovementY = event.screenY - $e229cb5c8b2cd629$var$lastMouseEvent.screenY) : $e229cb5c8b2cd629$var$lastMovementY = $e229cb5c8b2cd629$var$lastMovementX = 0, $e229cb5c8b2cd629$var$lastMouseEvent = event);
        return $e229cb5c8b2cd629$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $e229cb5c8b2cd629$var$lastMovementY;
    }
}), $e229cb5c8b2cd629$var$SyntheticMouseEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$MouseEventInterface), $e229cb5c8b2cd629$var$DragEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$MouseEventInterface, {
    dataTransfer: 0
}), $e229cb5c8b2cd629$var$SyntheticDragEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$DragEventInterface), $e229cb5c8b2cd629$var$FocusEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$UIEventInterface, {
    relatedTarget: 0
}), $e229cb5c8b2cd629$var$SyntheticFocusEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$FocusEventInterface), $e229cb5c8b2cd629$var$AnimationEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e229cb5c8b2cd629$var$SyntheticAnimationEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$AnimationEventInterface), $e229cb5c8b2cd629$var$ClipboardEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $e229cb5c8b2cd629$var$SyntheticClipboardEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$ClipboardEventInterface), $e229cb5c8b2cd629$var$CompositionEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    data: 0
}), $e229cb5c8b2cd629$var$SyntheticCompositionEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$CompositionEventInterface), $e229cb5c8b2cd629$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e229cb5c8b2cd629$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e229cb5c8b2cd629$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e229cb5c8b2cd629$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $e229cb5c8b2cd629$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $e229cb5c8b2cd629$var$getEventModifierState() {
    return $e229cb5c8b2cd629$var$modifierStateGetter;
}
var $e229cb5c8b2cd629$var$KeyboardEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $e229cb5c8b2cd629$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $e229cb5c8b2cd629$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $e229cb5c8b2cd629$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e229cb5c8b2cd629$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $e229cb5c8b2cd629$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $e229cb5c8b2cd629$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $e229cb5c8b2cd629$var$SyntheticKeyboardEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$KeyboardEventInterface), $e229cb5c8b2cd629$var$PointerEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e229cb5c8b2cd629$var$SyntheticPointerEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$PointerEventInterface), $e229cb5c8b2cd629$var$TouchEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e229cb5c8b2cd629$var$getEventModifierState
}), $e229cb5c8b2cd629$var$SyntheticTouchEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$TouchEventInterface), $e229cb5c8b2cd629$var$TransitionEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e229cb5c8b2cd629$var$SyntheticTransitionEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$TransitionEventInterface), $e229cb5c8b2cd629$var$WheelEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e229cb5c8b2cd629$var$SyntheticWheelEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$WheelEventInterface), $e229cb5c8b2cd629$var$ToggleEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $e229cb5c8b2cd629$var$SyntheticToggleEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$ToggleEventInterface), $e229cb5c8b2cd629$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $e229cb5c8b2cd629$var$canUseCompositionEvent = $e229cb5c8b2cd629$var$canUseDOM && "CompositionEvent" in window, $e229cb5c8b2cd629$var$documentMode = null;
$e229cb5c8b2cd629$var$canUseDOM && "documentMode" in document && ($e229cb5c8b2cd629$var$documentMode = document.documentMode);
var $e229cb5c8b2cd629$var$canUseTextInputEvent = $e229cb5c8b2cd629$var$canUseDOM && "TextEvent" in window && !$e229cb5c8b2cd629$var$documentMode, $e229cb5c8b2cd629$var$useFallbackCompositionData = $e229cb5c8b2cd629$var$canUseDOM && (!$e229cb5c8b2cd629$var$canUseCompositionEvent || $e229cb5c8b2cd629$var$documentMode && 8 < $e229cb5c8b2cd629$var$documentMode && 11 >= $e229cb5c8b2cd629$var$documentMode), $e229cb5c8b2cd629$var$SPACEBAR_CHAR = String.fromCharCode(32), $e229cb5c8b2cd629$var$hasSpaceKeypress = !1;
function $e229cb5c8b2cd629$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $e229cb5c8b2cd629$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e229cb5c8b2cd629$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $e229cb5c8b2cd629$var$isComposing = !1;
function $e229cb5c8b2cd629$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $e229cb5c8b2cd629$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $e229cb5c8b2cd629$var$hasSpaceKeypress = !0;
            return $e229cb5c8b2cd629$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $e229cb5c8b2cd629$var$SPACEBAR_CHAR && $e229cb5c8b2cd629$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $e229cb5c8b2cd629$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($e229cb5c8b2cd629$var$isComposing) return "compositionend" === domEventName || !$e229cb5c8b2cd629$var$canUseCompositionEvent && $e229cb5c8b2cd629$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $e229cb5c8b2cd629$var$getData(), $e229cb5c8b2cd629$var$fallbackText = $e229cb5c8b2cd629$var$startText = $e229cb5c8b2cd629$var$root = null, $e229cb5c8b2cd629$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $e229cb5c8b2cd629$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $e229cb5c8b2cd629$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e229cb5c8b2cd629$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$e229cb5c8b2cd629$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $e229cb5c8b2cd629$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $e229cb5c8b2cd629$var$restoreTarget ? $e229cb5c8b2cd629$var$restoreQueue ? $e229cb5c8b2cd629$var$restoreQueue.push(target) : $e229cb5c8b2cd629$var$restoreQueue = [
        target
    ] : $e229cb5c8b2cd629$var$restoreTarget = target;
    inst = $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $e229cb5c8b2cd629$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $e229cb5c8b2cd629$var$activeElement$1 = null, $e229cb5c8b2cd629$var$activeElementInst$1 = null;
function $e229cb5c8b2cd629$var$runEventInBatch(dispatchQueue) {
    $e229cb5c8b2cd629$var$processDispatchQueue(dispatchQueue, 0);
}
function $e229cb5c8b2cd629$var$getInstIfValueChanged(targetInst) {
    var targetNode = $e229cb5c8b2cd629$var$getNodeFromInstance(targetInst);
    if ($e229cb5c8b2cd629$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $e229cb5c8b2cd629$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $e229cb5c8b2cd629$var$isInputEventSupported = !1;
if ($e229cb5c8b2cd629$var$canUseDOM) {
    var $e229cb5c8b2cd629$var$JSCompiler_inline_result$jscomp$286;
    if ($e229cb5c8b2cd629$var$canUseDOM) {
        var $e229cb5c8b2cd629$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$e229cb5c8b2cd629$var$isSupported$jscomp$inline_427) {
            var $e229cb5c8b2cd629$var$element$jscomp$inline_428 = document.createElement("div");
            $e229cb5c8b2cd629$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $e229cb5c8b2cd629$var$isSupported$jscomp$inline_427 = "function" === typeof $e229cb5c8b2cd629$var$element$jscomp$inline_428.oninput;
        }
        $e229cb5c8b2cd629$var$JSCompiler_inline_result$jscomp$286 = $e229cb5c8b2cd629$var$isSupported$jscomp$inline_427;
    } else $e229cb5c8b2cd629$var$JSCompiler_inline_result$jscomp$286 = !1;
    $e229cb5c8b2cd629$var$isInputEventSupported = $e229cb5c8b2cd629$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $e229cb5c8b2cd629$var$stopWatchingForValueChange() {
    $e229cb5c8b2cd629$var$activeElement$1 && ($e229cb5c8b2cd629$var$activeElement$1.detachEvent("onpropertychange", $e229cb5c8b2cd629$var$handlePropertyChange), $e229cb5c8b2cd629$var$activeElementInst$1 = $e229cb5c8b2cd629$var$activeElement$1 = null);
}
function $e229cb5c8b2cd629$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $e229cb5c8b2cd629$var$getInstIfValueChanged($e229cb5c8b2cd629$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $e229cb5c8b2cd629$var$createAndAccumulateChangeEvent(dispatchQueue, $e229cb5c8b2cd629$var$activeElementInst$1, nativeEvent, $e229cb5c8b2cd629$var$getEventTarget(nativeEvent));
        $e229cb5c8b2cd629$var$batchedUpdates$1($e229cb5c8b2cd629$var$runEventInBatch, dispatchQueue);
    }
}
function $e229cb5c8b2cd629$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($e229cb5c8b2cd629$var$stopWatchingForValueChange(), $e229cb5c8b2cd629$var$activeElement$1 = target, $e229cb5c8b2cd629$var$activeElementInst$1 = targetInst, $e229cb5c8b2cd629$var$activeElement$1.attachEvent("onpropertychange", $e229cb5c8b2cd629$var$handlePropertyChange)) : "focusout" === domEventName && $e229cb5c8b2cd629$var$stopWatchingForValueChange();
}
function $e229cb5c8b2cd629$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $e229cb5c8b2cd629$var$getInstIfValueChanged($e229cb5c8b2cd629$var$activeElementInst$1);
}
function $e229cb5c8b2cd629$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $e229cb5c8b2cd629$var$getInstIfValueChanged(targetInst);
}
function $e229cb5c8b2cd629$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $e229cb5c8b2cd629$var$getInstIfValueChanged(targetInst);
}
function $e229cb5c8b2cd629$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $e229cb5c8b2cd629$var$objectIs = "function" === typeof Object.is ? Object.is : $e229cb5c8b2cd629$var$is;
function $e229cb5c8b2cd629$var$shallowEqual(objA, objB) {
    if ($e229cb5c8b2cd629$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$e229cb5c8b2cd629$var$hasOwnProperty.call(objB, currentKey) || !$e229cb5c8b2cd629$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $e229cb5c8b2cd629$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $e229cb5c8b2cd629$var$getNodeForCharacterOffset(root, offset) {
    var node = $e229cb5c8b2cd629$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $e229cb5c8b2cd629$var$getLeafNode(node);
    }
}
function $e229cb5c8b2cd629$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $e229cb5c8b2cd629$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $e229cb5c8b2cd629$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $e229cb5c8b2cd629$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $e229cb5c8b2cd629$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $e229cb5c8b2cd629$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $e229cb5c8b2cd629$var$skipSelectionChangeEvent = $e229cb5c8b2cd629$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $e229cb5c8b2cd629$var$activeElement = null, $e229cb5c8b2cd629$var$activeElementInst = null, $e229cb5c8b2cd629$var$lastSelection = null, $e229cb5c8b2cd629$var$mouseDown = !1;
function $e229cb5c8b2cd629$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $e229cb5c8b2cd629$var$mouseDown || null == $e229cb5c8b2cd629$var$activeElement || $e229cb5c8b2cd629$var$activeElement !== $e229cb5c8b2cd629$var$getActiveElement(doc) || (doc = $e229cb5c8b2cd629$var$activeElement, "selectionStart" in doc && $e229cb5c8b2cd629$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $e229cb5c8b2cd629$var$lastSelection && $e229cb5c8b2cd629$var$shallowEqual($e229cb5c8b2cd629$var$lastSelection, doc) || ($e229cb5c8b2cd629$var$lastSelection = doc, doc = $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners($e229cb5c8b2cd629$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $e229cb5c8b2cd629$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $e229cb5c8b2cd629$var$activeElement)));
}
function $e229cb5c8b2cd629$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $e229cb5c8b2cd629$var$vendorPrefixes = {
    animationend: $e229cb5c8b2cd629$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $e229cb5c8b2cd629$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $e229cb5c8b2cd629$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $e229cb5c8b2cd629$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $e229cb5c8b2cd629$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $e229cb5c8b2cd629$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $e229cb5c8b2cd629$var$makePrefixMap("Transition", "TransitionEnd")
}, $e229cb5c8b2cd629$var$prefixedEventNames = {}, $e229cb5c8b2cd629$var$style = {};
$e229cb5c8b2cd629$var$canUseDOM && ($e229cb5c8b2cd629$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $e229cb5c8b2cd629$var$vendorPrefixes.animationend.animation, delete $e229cb5c8b2cd629$var$vendorPrefixes.animationiteration.animation, delete $e229cb5c8b2cd629$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $e229cb5c8b2cd629$var$vendorPrefixes.transitionend.transition);
function $e229cb5c8b2cd629$var$getVendorPrefixedEventName(eventName) {
    if ($e229cb5c8b2cd629$var$prefixedEventNames[eventName]) return $e229cb5c8b2cd629$var$prefixedEventNames[eventName];
    if (!$e229cb5c8b2cd629$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $e229cb5c8b2cd629$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $e229cb5c8b2cd629$var$style) return $e229cb5c8b2cd629$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $e229cb5c8b2cd629$var$ANIMATION_END = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("animationend"), $e229cb5c8b2cd629$var$ANIMATION_ITERATION = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("animationiteration"), $e229cb5c8b2cd629$var$ANIMATION_START = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("animationstart"), $e229cb5c8b2cd629$var$TRANSITION_RUN = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("transitionrun"), $e229cb5c8b2cd629$var$TRANSITION_START = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("transitionstart"), $e229cb5c8b2cd629$var$TRANSITION_CANCEL = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("transitioncancel"), $e229cb5c8b2cd629$var$TRANSITION_END = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("transitionend"), $e229cb5c8b2cd629$var$topLevelEventsToReactNames = new Map(), $e229cb5c8b2cd629$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$e229cb5c8b2cd629$var$simpleEventPluginEvents.push("scrollEnd");
function $e229cb5c8b2cd629$var$registerSimpleEvent(domEventName, reactName) {
    $e229cb5c8b2cd629$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $e229cb5c8b2cd629$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $e229cb5c8b2cd629$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $e229cb5c8b2cd629$var$concurrentQueues = [], $e229cb5c8b2cd629$var$concurrentQueuesIndex = 0, $e229cb5c8b2cd629$var$concurrentlyUpdatedLanes = 0;
function $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $e229cb5c8b2cd629$var$concurrentQueuesIndex, i = $e229cb5c8b2cd629$var$concurrentlyUpdatedLanes = $e229cb5c8b2cd629$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $e229cb5c8b2cd629$var$concurrentQueues[i];
        $e229cb5c8b2cd629$var$concurrentQueues[i++] = null;
        var queue = $e229cb5c8b2cd629$var$concurrentQueues[i];
        $e229cb5c8b2cd629$var$concurrentQueues[i++] = null;
        var update = $e229cb5c8b2cd629$var$concurrentQueues[i];
        $e229cb5c8b2cd629$var$concurrentQueues[i++] = null;
        var lane = $e229cb5c8b2cd629$var$concurrentQueues[i];
        $e229cb5c8b2cd629$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $e229cb5c8b2cd629$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $e229cb5c8b2cd629$var$concurrentQueues[$e229cb5c8b2cd629$var$concurrentQueuesIndex++] = fiber;
    $e229cb5c8b2cd629$var$concurrentQueues[$e229cb5c8b2cd629$var$concurrentQueuesIndex++] = queue;
    $e229cb5c8b2cd629$var$concurrentQueues[$e229cb5c8b2cd629$var$concurrentQueuesIndex++] = update;
    $e229cb5c8b2cd629$var$concurrentQueues[$e229cb5c8b2cd629$var$concurrentQueuesIndex++] = lane;
    $e229cb5c8b2cd629$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $e229cb5c8b2cd629$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $e229cb5c8b2cd629$var$getRootForUpdatedFiber(fiber);
}
function $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, null, null, lane);
    return $e229cb5c8b2cd629$var$getRootForUpdatedFiber(fiber);
}
function $e229cb5c8b2cd629$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $e229cb5c8b2cd629$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $e229cb5c8b2cd629$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $e229cb5c8b2cd629$var$nestedUpdateCount) throw $e229cb5c8b2cd629$var$nestedUpdateCount = 0, $e229cb5c8b2cd629$var$rootWithNestedUpdates = null, Error($e229cb5c8b2cd629$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $e229cb5c8b2cd629$var$emptyContextObject = {};
function $e229cb5c8b2cd629$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e229cb5c8b2cd629$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $e229cb5c8b2cd629$var$FiberNode(tag, pendingProps, key, mode);
}
function $e229cb5c8b2cd629$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $e229cb5c8b2cd629$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $e229cb5c8b2cd629$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $e229cb5c8b2cd629$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $e229cb5c8b2cd629$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $e229cb5c8b2cd629$var$isHostHoistableType(type, pendingProps, $e229cb5c8b2cd629$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $e229cb5c8b2cd629$var$REACT_ACTIVITY_TYPE:
            return type = $e229cb5c8b2cd629$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $e229cb5c8b2cd629$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE:
            return $e229cb5c8b2cd629$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $e229cb5c8b2cd629$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $e229cb5c8b2cd629$var$REACT_PROFILER_TYPE:
            return type = $e229cb5c8b2cd629$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $e229cb5c8b2cd629$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $e229cb5c8b2cd629$var$REACT_SUSPENSE_TYPE:
            return type = $e229cb5c8b2cd629$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $e229cb5c8b2cd629$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $e229cb5c8b2cd629$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $e229cb5c8b2cd629$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $e229cb5c8b2cd629$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $e229cb5c8b2cd629$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $e229cb5c8b2cd629$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $e229cb5c8b2cd629$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $e229cb5c8b2cd629$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $e229cb5c8b2cd629$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $e229cb5c8b2cd629$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $e229cb5c8b2cd629$var$createFiberFromText(content, mode, lanes) {
    content = $e229cb5c8b2cd629$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $e229cb5c8b2cd629$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $e229cb5c8b2cd629$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $e229cb5c8b2cd629$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $e229cb5c8b2cd629$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $e229cb5c8b2cd629$var$CapturedStacks = new WeakMap();
function $e229cb5c8b2cd629$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $e229cb5c8b2cd629$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $e229cb5c8b2cd629$var$getStackByFiberInDevAndProd(source)
        };
        $e229cb5c8b2cd629$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $e229cb5c8b2cd629$var$getStackByFiberInDevAndProd(source)
    };
}
var $e229cb5c8b2cd629$var$forkStack = [], $e229cb5c8b2cd629$var$forkStackIndex = 0, $e229cb5c8b2cd629$var$treeForkProvider = null, $e229cb5c8b2cd629$var$treeForkCount = 0, $e229cb5c8b2cd629$var$idStack = [], $e229cb5c8b2cd629$var$idStackIndex = 0, $e229cb5c8b2cd629$var$treeContextProvider = null, $e229cb5c8b2cd629$var$treeContextId = 1, $e229cb5c8b2cd629$var$treeContextOverflow = "";
function $e229cb5c8b2cd629$var$pushTreeFork(workInProgress, totalChildren) {
    $e229cb5c8b2cd629$var$forkStack[$e229cb5c8b2cd629$var$forkStackIndex++] = $e229cb5c8b2cd629$var$treeForkCount;
    $e229cb5c8b2cd629$var$forkStack[$e229cb5c8b2cd629$var$forkStackIndex++] = $e229cb5c8b2cd629$var$treeForkProvider;
    $e229cb5c8b2cd629$var$treeForkProvider = workInProgress;
    $e229cb5c8b2cd629$var$treeForkCount = totalChildren;
}
function $e229cb5c8b2cd629$var$pushTreeId(workInProgress, totalChildren, index) {
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextId;
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextOverflow;
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextProvider;
    $e229cb5c8b2cd629$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $e229cb5c8b2cd629$var$treeContextId;
    workInProgress = $e229cb5c8b2cd629$var$treeContextOverflow;
    var baseLength = 32 - $e229cb5c8b2cd629$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $e229cb5c8b2cd629$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $e229cb5c8b2cd629$var$treeContextId = 1 << 32 - $e229cb5c8b2cd629$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $e229cb5c8b2cd629$var$treeContextOverflow = length + workInProgress;
    } else $e229cb5c8b2cd629$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $e229cb5c8b2cd629$var$treeContextOverflow = workInProgress;
}
function $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($e229cb5c8b2cd629$var$pushTreeFork(workInProgress, 1), $e229cb5c8b2cd629$var$pushTreeId(workInProgress, 1, 0));
}
function $e229cb5c8b2cd629$var$popTreeContext(workInProgress) {
    for(; workInProgress === $e229cb5c8b2cd629$var$treeForkProvider;)$e229cb5c8b2cd629$var$treeForkProvider = $e229cb5c8b2cd629$var$forkStack[--$e229cb5c8b2cd629$var$forkStackIndex], $e229cb5c8b2cd629$var$forkStack[$e229cb5c8b2cd629$var$forkStackIndex] = null, $e229cb5c8b2cd629$var$treeForkCount = $e229cb5c8b2cd629$var$forkStack[--$e229cb5c8b2cd629$var$forkStackIndex], $e229cb5c8b2cd629$var$forkStack[$e229cb5c8b2cd629$var$forkStackIndex] = null;
    for(; workInProgress === $e229cb5c8b2cd629$var$treeContextProvider;)$e229cb5c8b2cd629$var$treeContextProvider = $e229cb5c8b2cd629$var$idStack[--$e229cb5c8b2cd629$var$idStackIndex], $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex] = null, $e229cb5c8b2cd629$var$treeContextOverflow = $e229cb5c8b2cd629$var$idStack[--$e229cb5c8b2cd629$var$idStackIndex], $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex] = null, $e229cb5c8b2cd629$var$treeContextId = $e229cb5c8b2cd629$var$idStack[--$e229cb5c8b2cd629$var$idStackIndex], $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex] = null;
}
function $e229cb5c8b2cd629$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextId;
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextOverflow;
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextProvider;
    $e229cb5c8b2cd629$var$treeContextId = suspendedContext.id;
    $e229cb5c8b2cd629$var$treeContextOverflow = suspendedContext.overflow;
    $e229cb5c8b2cd629$var$treeContextProvider = workInProgress;
}
var $e229cb5c8b2cd629$var$hydrationParentFiber = null, $e229cb5c8b2cd629$var$nextHydratableInstance = null, $e229cb5c8b2cd629$var$isHydrating = !1, $e229cb5c8b2cd629$var$hydrationErrors = null, $e229cb5c8b2cd629$var$rootOrSingletonContext = !1, $e229cb5c8b2cd629$var$HydrationMismatchException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(519));
function $e229cb5c8b2cd629$var$throwOnHydrationMismatch(fiber) {
    var error = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $e229cb5c8b2cd629$var$queueHydrationError($e229cb5c8b2cd629$var$createCapturedValueAtFiber(error, fiber));
    throw $e229cb5c8b2cd629$var$HydrationMismatchException;
}
function $e229cb5c8b2cd629$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$e229cb5c8b2cd629$var$internalInstanceKey] = fiber;
    instance[$e229cb5c8b2cd629$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("cancel", instance);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $e229cb5c8b2cd629$var$mediaEventTypes.length; type++)$e229cb5c8b2cd629$var$listenToNonDelegatedEvent($e229cb5c8b2cd629$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", instance);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", instance);
            $e229cb5c8b2cd629$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", instance), $e229cb5c8b2cd629$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $e229cb5c8b2cd629$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($e229cb5c8b2cd629$var$listenToNonDelegatedEvent("beforetoggle", instance), $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $e229cb5c8b2cd629$var$noop$1), instance = !0) : instance = !1;
    instance || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(fiber, !0);
}
function $e229cb5c8b2cd629$var$popToNextHostParent(fiber) {
    for($e229cb5c8b2cd629$var$hydrationParentFiber = fiber.return; $e229cb5c8b2cd629$var$hydrationParentFiber;)switch($e229cb5c8b2cd629$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $e229cb5c8b2cd629$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $e229cb5c8b2cd629$var$rootOrSingletonContext = !0;
            return;
        default:
            $e229cb5c8b2cd629$var$hydrationParentFiber = $e229cb5c8b2cd629$var$hydrationParentFiber.return;
    }
}
function $e229cb5c8b2cd629$var$popHydrationState(fiber) {
    if (fiber !== $e229cb5c8b2cd629$var$hydrationParentFiber) return !1;
    if (!$e229cb5c8b2cd629$var$isHydrating) return $e229cb5c8b2cd629$var$popToNextHostParent(fiber), $e229cb5c8b2cd629$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $e229cb5c8b2cd629$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $e229cb5c8b2cd629$var$nextHydratableInstance && $e229cb5c8b2cd629$var$throwOnHydrationMismatch(fiber);
    $e229cb5c8b2cd629$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(317));
        $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(317));
        $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $e229cb5c8b2cd629$var$nextHydratableInstance, $e229cb5c8b2cd629$var$isSingletonScope(fiber.type) ? (fiber = $e229cb5c8b2cd629$var$previousHydratableOnEnteringScopedSingleton, $e229cb5c8b2cd629$var$previousHydratableOnEnteringScopedSingleton = null, $e229cb5c8b2cd629$var$nextHydratableInstance = fiber) : $e229cb5c8b2cd629$var$nextHydratableInstance = tag) : $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$hydrationParentFiber ? $e229cb5c8b2cd629$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $e229cb5c8b2cd629$var$resetHydrationState() {
    $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$hydrationParentFiber = null;
    $e229cb5c8b2cd629$var$isHydrating = !1;
}
function $e229cb5c8b2cd629$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $e229cb5c8b2cd629$var$hydrationErrors;
    null !== queuedErrors && (null === $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors ? $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = queuedErrors : $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors.push.apply($e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors, queuedErrors), $e229cb5c8b2cd629$var$hydrationErrors = null);
    return queuedErrors;
}
function $e229cb5c8b2cd629$var$queueHydrationError(error) {
    null === $e229cb5c8b2cd629$var$hydrationErrors ? $e229cb5c8b2cd629$var$hydrationErrors = [
        error
    ] : $e229cb5c8b2cd629$var$hydrationErrors.push(error);
}
var $e229cb5c8b2cd629$var$valueCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null, $e229cb5c8b2cd629$var$lastContextDependency = null;
function $e229cb5c8b2cd629$var$pushProvider(providerFiber, context, nextValue) {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $e229cb5c8b2cd629$var$popProvider(context) {
    context._currentValue = $e229cb5c8b2cd629$var$valueCursor.current;
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$valueCursor);
}
function $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $e229cb5c8b2cd629$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $e229cb5c8b2cd629$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $e229cb5c8b2cd629$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($e229cb5c8b2cd629$var$HostTransitionContext) : current = [
                $e229cb5c8b2cd629$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $e229cb5c8b2cd629$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $e229cb5c8b2cd629$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$e229cb5c8b2cd629$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress) {
    $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = workInProgress;
    $e229cb5c8b2cd629$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $e229cb5c8b2cd629$var$readContext(context) {
    return $e229cb5c8b2cd629$var$readContextForConsumer($e229cb5c8b2cd629$var$currentlyRenderingFiber$1, context);
}
function $e229cb5c8b2cd629$var$readContextDuringReconciliation(consumer, context) {
    null === $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 && $e229cb5c8b2cd629$var$prepareToReadContext(consumer);
    return $e229cb5c8b2cd629$var$readContextForConsumer(consumer, context);
}
function $e229cb5c8b2cd629$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $e229cb5c8b2cd629$var$lastContextDependency) {
        if (null === consumer) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(308));
        $e229cb5c8b2cd629$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$lastContextDependency.next = context;
    return value;
}
var $e229cb5c8b2cd629$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $e229cb5c8b2cd629$var$scheduleCallback$2 = $4LCdk.unstable_scheduleCallback, $e229cb5c8b2cd629$var$NormalPriority = $4LCdk.unstable_NormalPriority, $e229cb5c8b2cd629$var$CacheContext = {
    $$typeof: $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $e229cb5c8b2cd629$var$createCache() {
    return {
        controller: new $e229cb5c8b2cd629$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $e229cb5c8b2cd629$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $e229cb5c8b2cd629$var$scheduleCallback$2($e229cb5c8b2cd629$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $e229cb5c8b2cd629$var$currentEntangledListeners = null, $e229cb5c8b2cd629$var$currentEntangledPendingCount = 0, $e229cb5c8b2cd629$var$currentEntangledLane = 0, $e229cb5c8b2cd629$var$currentEntangledActionThenable = null;
function $e229cb5c8b2cd629$var$entangleAsyncAction(transition, thenable) {
    if (null === $e229cb5c8b2cd629$var$currentEntangledListeners) {
        var entangledListeners = $e229cb5c8b2cd629$var$currentEntangledListeners = [];
        $e229cb5c8b2cd629$var$currentEntangledPendingCount = 0;
        $e229cb5c8b2cd629$var$currentEntangledLane = $e229cb5c8b2cd629$var$requestTransitionLane();
        $e229cb5c8b2cd629$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $e229cb5c8b2cd629$var$currentEntangledPendingCount++;
    thenable.then($e229cb5c8b2cd629$var$pingEngtangledActionScope, $e229cb5c8b2cd629$var$pingEngtangledActionScope);
    return thenable;
}
function $e229cb5c8b2cd629$var$pingEngtangledActionScope() {
    if (0 === --$e229cb5c8b2cd629$var$currentEntangledPendingCount && null !== $e229cb5c8b2cd629$var$currentEntangledListeners) {
        null !== $e229cb5c8b2cd629$var$currentEntangledActionThenable && ($e229cb5c8b2cd629$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $e229cb5c8b2cd629$var$currentEntangledListeners;
        $e229cb5c8b2cd629$var$currentEntangledListeners = null;
        $e229cb5c8b2cd629$var$currentEntangledLane = 0;
        $e229cb5c8b2cd629$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $e229cb5c8b2cd629$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $e229cb5c8b2cd629$var$prevOnStartTransitionFinish = $e229cb5c8b2cd629$var$ReactSharedInternals.S;
$e229cb5c8b2cd629$var$ReactSharedInternals.S = function(transition, returnValue) {
    $e229cb5c8b2cd629$var$globalMostRecentTransitionTime = $e229cb5c8b2cd629$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $e229cb5c8b2cd629$var$entangleAsyncAction(transition, returnValue);
    null !== $e229cb5c8b2cd629$var$prevOnStartTransitionFinish && $e229cb5c8b2cd629$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $e229cb5c8b2cd629$var$resumedCache = $e229cb5c8b2cd629$var$createCursor(null);
function $e229cb5c8b2cd629$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $e229cb5c8b2cd629$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $e229cb5c8b2cd629$var$workInProgressRoot.pooledCache;
}
function $e229cb5c8b2cd629$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$resumedCache, $e229cb5c8b2cd629$var$resumedCache.current) : $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$resumedCache, prevCachePool.pool);
}
function $e229cb5c8b2cd629$var$getSuspendedCache() {
    var cacheFromPool = $e229cb5c8b2cd629$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $e229cb5c8b2cd629$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $e229cb5c8b2cd629$var$SuspenseException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(460)), $e229cb5c8b2cd629$var$SuspenseyCommitException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(474)), $e229cb5c8b2cd629$var$SuspenseActionException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(542)), $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $e229cb5c8b2cd629$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $e229cb5c8b2cd629$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($e229cb5c8b2cd629$var$noop$1, $e229cb5c8b2cd629$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $e229cb5c8b2cd629$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($e229cb5c8b2cd629$var$noop$1, $e229cb5c8b2cd629$var$noop$1);
            else {
                thenableState = $e229cb5c8b2cd629$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $e229cb5c8b2cd629$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $e229cb5c8b2cd629$var$suspendedThenable = thenable;
            throw $e229cb5c8b2cd629$var$SuspenseException;
    }
}
function $e229cb5c8b2cd629$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $e229cb5c8b2cd629$var$suspendedThenable = x, $e229cb5c8b2cd629$var$SuspenseException;
        throw x;
    }
}
var $e229cb5c8b2cd629$var$suspendedThenable = null;
function $e229cb5c8b2cd629$var$getSuspendedThenable() {
    if (null === $e229cb5c8b2cd629$var$suspendedThenable) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(459));
    var thenable = $e229cb5c8b2cd629$var$suspendedThenable;
    $e229cb5c8b2cd629$var$suspendedThenable = null;
    return thenable;
}
function $e229cb5c8b2cd629$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $e229cb5c8b2cd629$var$SuspenseException || rejectedReason === $e229cb5c8b2cd629$var$SuspenseActionException) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(483));
}
var $e229cb5c8b2cd629$var$thenableState$1 = null, $e229cb5c8b2cd629$var$thenableIndexCounter$1 = 0;
function $e229cb5c8b2cd629$var$unwrapThenable(thenable) {
    var index = $e229cb5c8b2cd629$var$thenableIndexCounter$1;
    $e229cb5c8b2cd629$var$thenableIndexCounter$1 += 1;
    null === $e229cb5c8b2cd629$var$thenableState$1 && ($e229cb5c8b2cd629$var$thenableState$1 = []);
    return $e229cb5c8b2cd629$var$trackUsedThenable($e229cb5c8b2cd629$var$thenableState$1, thenable, index);
}
function $e229cb5c8b2cd629$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $e229cb5c8b2cd629$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $e229cb5c8b2cd629$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $e229cb5c8b2cd629$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $e229cb5c8b2cd629$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $e229cb5c8b2cd629$var$REACT_LAZY_TYPE && $e229cb5c8b2cd629$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $e229cb5c8b2cd629$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $e229cb5c8b2cd629$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $e229cb5c8b2cd629$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $e229cb5c8b2cd629$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $e229cb5c8b2cd629$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE:
                    return lanes = $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $e229cb5c8b2cd629$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
                    return newChild = $e229cb5c8b2cd629$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    return newChild = $e229cb5c8b2cd629$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($e229cb5c8b2cd629$var$isArrayImpl(newChild) || $e229cb5c8b2cd629$var$getIteratorFn(newChild)) return newChild = $e229cb5c8b2cd629$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $e229cb5c8b2cd629$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $e229cb5c8b2cd629$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e229cb5c8b2cd629$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    return newChild = $e229cb5c8b2cd629$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($e229cb5c8b2cd629$var$isArrayImpl(newChild) || $e229cb5c8b2cd629$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $e229cb5c8b2cd629$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $e229cb5c8b2cd629$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e229cb5c8b2cd629$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    return newChild = $e229cb5c8b2cd629$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($e229cb5c8b2cd629$var$isArrayImpl(newChild) || $e229cb5c8b2cd629$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $e229cb5c8b2cd629$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $e229cb5c8b2cd629$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e229cb5c8b2cd629$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $e229cb5c8b2cd629$var$REACT_LAZY_TYPE && $e229cb5c8b2cd629$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $e229cb5c8b2cd629$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE ? (lanes = $e229cb5c8b2cd629$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $e229cb5c8b2cd629$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $e229cb5c8b2cd629$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    return newChild = $e229cb5c8b2cd629$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($e229cb5c8b2cd629$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($e229cb5c8b2cd629$var$getIteratorFn(newChild)) {
                key = $e229cb5c8b2cd629$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $e229cb5c8b2cd629$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $e229cb5c8b2cd629$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e229cb5c8b2cd629$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $e229cb5c8b2cd629$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $e229cb5c8b2cd629$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $e229cb5c8b2cd629$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $e229cb5c8b2cd629$var$SuspenseException || x === $e229cb5c8b2cd629$var$SuspenseActionException) throw x;
            var fiber = $e229cb5c8b2cd629$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $e229cb5c8b2cd629$var$reconcileChildFibers = $e229cb5c8b2cd629$var$createChildReconciler(!0), $e229cb5c8b2cd629$var$mountChildFibers = $e229cb5c8b2cd629$var$createChildReconciler(!1), $e229cb5c8b2cd629$var$hasForceUpdate = !1;
function $e229cb5c8b2cd629$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $e229cb5c8b2cd629$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $e229cb5c8b2cd629$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e229cb5c8b2cd629$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($e229cb5c8b2cd629$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $e229cb5c8b2cd629$var$getRootForUpdatedFiber(fiber);
        $e229cb5c8b2cd629$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $e229cb5c8b2cd629$var$getRootForUpdatedFiber(fiber);
}
function $e229cb5c8b2cd629$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $e229cb5c8b2cd629$var$markRootEntangled(root, lane);
    }
}
function $e229cb5c8b2cd629$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $e229cb5c8b2cd629$var$didReadFromEntangledAsyncAction = !1;
function $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($e229cb5c8b2cd629$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $e229cb5c8b2cd629$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $e229cb5c8b2cd629$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $e229cb5c8b2cd629$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $e229cb5c8b2cd629$var$currentEntangledLane && ($e229cb5c8b2cd629$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $e229cb5c8b2cd629$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $e229cb5c8b2cd629$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $e229cb5c8b2cd629$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $e229cb5c8b2cd629$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$e229cb5c8b2cd629$var$callCallback(callbacks[updateQueue], context);
}
var $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor = $e229cb5c8b2cd629$var$createCursor(0);
function $e229cb5c8b2cd629$var$pushHiddenContext(fiber, context) {
    fiber = $e229cb5c8b2cd629$var$entangledRenderLanes;
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor, fiber);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$currentTreeHiddenStackCursor, context);
    $e229cb5c8b2cd629$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $e229cb5c8b2cd629$var$reuseHiddenContextOnStack() {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor, $e229cb5c8b2cd629$var$entangledRenderLanes);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$currentTreeHiddenStackCursor, $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor.current);
}
function $e229cb5c8b2cd629$var$popHiddenContext() {
    $e229cb5c8b2cd629$var$entangledRenderLanes = $e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor.current;
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$currentTreeHiddenStackCursor);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor);
}
var $e229cb5c8b2cd629$var$suspenseHandlerStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$shellBoundary = null;
function $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current & 1);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, handler);
    null === $e229cb5c8b2cd629$var$shellBoundary && (null === current || null !== $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor.current ? $e229cb5c8b2cd629$var$shellBoundary = handler : null !== current.memoizedState && ($e229cb5c8b2cd629$var$shellBoundary = handler));
}
function $e229cb5c8b2cd629$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, fiber);
    null === $e229cb5c8b2cd629$var$shellBoundary && ($e229cb5c8b2cd629$var$shellBoundary = fiber);
}
function $e229cb5c8b2cd629$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current), $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, fiber), null === $e229cb5c8b2cd629$var$shellBoundary && ($e229cb5c8b2cd629$var$shellBoundary = fiber)) : $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(fiber);
}
function $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack() {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current);
}
function $e229cb5c8b2cd629$var$popSuspenseHandler(fiber) {
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseHandlerStackCursor);
    $e229cb5c8b2cd629$var$shellBoundary === fiber && ($e229cb5c8b2cd629$var$shellBoundary = null);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseStackCursor);
}
var $e229cb5c8b2cd629$var$suspenseStackCursor = $e229cb5c8b2cd629$var$createCursor(0);
function $e229cb5c8b2cd629$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $e229cb5c8b2cd629$var$isSuspenseInstancePending(state) || $e229cb5c8b2cd629$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $e229cb5c8b2cd629$var$renderLanes = 0, $e229cb5c8b2cd629$var$currentlyRenderingFiber = null, $e229cb5c8b2cd629$var$currentHook = null, $e229cb5c8b2cd629$var$workInProgressHook = null, $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate = !1, $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $e229cb5c8b2cd629$var$localIdCounter = 0, $e229cb5c8b2cd629$var$thenableIndexCounter = 0, $e229cb5c8b2cd629$var$thenableState = null, $e229cb5c8b2cd629$var$globalClientIdCounter = 0;
function $e229cb5c8b2cd629$var$throwInvalidHookError() {
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(321));
}
function $e229cb5c8b2cd629$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$e229cb5c8b2cd629$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $e229cb5c8b2cd629$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $e229cb5c8b2cd629$var$renderLanes = nextRenderLanes;
    $e229cb5c8b2cd629$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $e229cb5c8b2cd629$var$HooksDispatcherOnMount : $e229cb5c8b2cd629$var$HooksDispatcherOnUpdate;
    $e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $e229cb5c8b2cd629$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $e229cb5c8b2cd629$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $e229cb5c8b2cd629$var$finishRenderingHooks(current) {
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = $e229cb5c8b2cd629$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $e229cb5c8b2cd629$var$currentHook && null !== $e229cb5c8b2cd629$var$currentHook.next;
    $e229cb5c8b2cd629$var$renderLanes = 0;
    $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$currentHook = $e229cb5c8b2cd629$var$currentlyRenderingFiber = null;
    $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate = !1;
    $e229cb5c8b2cd629$var$thenableIndexCounter = 0;
    $e229cb5c8b2cd629$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(300));
    null === current || $e229cb5c8b2cd629$var$didReceiveUpdate || (current = current.dependencies, null !== current && $e229cb5c8b2cd629$var$checkIfContextChanged(current) && ($e229cb5c8b2cd629$var$didReceiveUpdate = !0));
}
function $e229cb5c8b2cd629$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $e229cb5c8b2cd629$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass && ($e229cb5c8b2cd629$var$thenableState = null);
        $e229cb5c8b2cd629$var$thenableIndexCounter = 0;
        $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $e229cb5c8b2cd629$var$ReactSharedInternals.H = $e229cb5c8b2cd629$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $e229cb5c8b2cd629$var$TransitionAwareHostComponent() {
    var dispatcher = $e229cb5c8b2cd629$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $e229cb5c8b2cd629$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $e229cb5c8b2cd629$var$currentHook ? $e229cb5c8b2cd629$var$currentHook.memoizedState : null) !== dispatcher && ($e229cb5c8b2cd629$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $e229cb5c8b2cd629$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $e229cb5c8b2cd629$var$localIdCounter;
    $e229cb5c8b2cd629$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $e229cb5c8b2cd629$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $e229cb5c8b2cd629$var$resetHooksOnUnwind(workInProgress) {
    if ($e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate = !1;
    }
    $e229cb5c8b2cd629$var$renderLanes = 0;
    $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$currentHook = $e229cb5c8b2cd629$var$currentlyRenderingFiber = null;
    $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $e229cb5c8b2cd629$var$thenableIndexCounter = $e229cb5c8b2cd629$var$localIdCounter = 0;
    $e229cb5c8b2cd629$var$thenableState = null;
}
function $e229cb5c8b2cd629$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e229cb5c8b2cd629$var$workInProgressHook ? $e229cb5c8b2cd629$var$currentlyRenderingFiber.memoizedState = $e229cb5c8b2cd629$var$workInProgressHook = hook : $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$workInProgressHook.next = hook;
    return $e229cb5c8b2cd629$var$workInProgressHook;
}
function $e229cb5c8b2cd629$var$updateWorkInProgressHook() {
    if (null === $e229cb5c8b2cd629$var$currentHook) {
        var nextCurrentHook = $e229cb5c8b2cd629$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $e229cb5c8b2cd629$var$currentHook.next;
    var nextWorkInProgressHook = null === $e229cb5c8b2cd629$var$workInProgressHook ? $e229cb5c8b2cd629$var$currentlyRenderingFiber.memoizedState : $e229cb5c8b2cd629$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $e229cb5c8b2cd629$var$workInProgressHook = nextWorkInProgressHook, $e229cb5c8b2cd629$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $e229cb5c8b2cd629$var$currentlyRenderingFiber.alternate) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(467));
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(310));
        }
        $e229cb5c8b2cd629$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $e229cb5c8b2cd629$var$currentHook.memoizedState,
            baseState: $e229cb5c8b2cd629$var$currentHook.baseState,
            baseQueue: $e229cb5c8b2cd629$var$currentHook.baseQueue,
            queue: $e229cb5c8b2cd629$var$currentHook.queue,
            next: null
        };
        null === $e229cb5c8b2cd629$var$workInProgressHook ? $e229cb5c8b2cd629$var$currentlyRenderingFiber.memoizedState = $e229cb5c8b2cd629$var$workInProgressHook = nextCurrentHook : $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$workInProgressHook.next = nextCurrentHook;
    }
    return $e229cb5c8b2cd629$var$workInProgressHook;
}
function $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $e229cb5c8b2cd629$var$useThenable(thenable) {
    var index = $e229cb5c8b2cd629$var$thenableIndexCounter;
    $e229cb5c8b2cd629$var$thenableIndexCounter += 1;
    null === $e229cb5c8b2cd629$var$thenableState && ($e229cb5c8b2cd629$var$thenableState = []);
    thenable = $e229cb5c8b2cd629$var$trackUsedThenable($e229cb5c8b2cd629$var$thenableState, thenable, index);
    index = $e229cb5c8b2cd629$var$currentlyRenderingFiber;
    null === (null === $e229cb5c8b2cd629$var$workInProgressHook ? index.memoizedState : $e229cb5c8b2cd629$var$workInProgressHook.next) && (index = index.alternate, $e229cb5c8b2cd629$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $e229cb5c8b2cd629$var$HooksDispatcherOnMount : $e229cb5c8b2cd629$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $e229cb5c8b2cd629$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $e229cb5c8b2cd629$var$useThenable(usable);
        if (usable.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return $e229cb5c8b2cd629$var$readContext(usable);
    }
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(438, String(usable)));
}
function $e229cb5c8b2cd629$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $e229cb5c8b2cd629$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue(), $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $e229cb5c8b2cd629$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $e229cb5c8b2cd629$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $e229cb5c8b2cd629$var$updateReducer(reducer) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    return $e229cb5c8b2cd629$var$updateReducerImpl(hook, $e229cb5c8b2cd629$var$currentHook, reducer);
}
function $e229cb5c8b2cd629$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($e229cb5c8b2cd629$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $e229cb5c8b2cd629$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($e229cb5c8b2cd629$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $e229cb5c8b2cd629$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $e229cb5c8b2cd629$var$currentlyRenderingFiber.lanes |= revertLane, $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $e229cb5c8b2cd629$var$currentlyRenderingFiber.lanes |= updateLane, $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$e229cb5c8b2cd629$var$objectIs(pendingQueue, hook.memoizedState) && ($e229cb5c8b2cd629$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $e229cb5c8b2cd629$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $e229cb5c8b2cd629$var$rerenderReducer(reducer) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $e229cb5c8b2cd629$var$objectIs(newState, hook.memoizedState) || ($e229cb5c8b2cd629$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $e229cb5c8b2cd629$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $e229cb5c8b2cd629$var$currentlyRenderingFiber, hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $e229cb5c8b2cd629$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$e229cb5c8b2cd629$var$objectIs(($e229cb5c8b2cd629$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $e229cb5c8b2cd629$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $e229cb5c8b2cd629$var$updateEffect($e229cb5c8b2cd629$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $e229cb5c8b2cd629$var$workInProgressHook && $e229cb5c8b2cd629$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $e229cb5c8b2cd629$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $e229cb5c8b2cd629$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $e229cb5c8b2cd629$var$workInProgressRoot) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($e229cb5c8b2cd629$var$renderLanes & 127) || $e229cb5c8b2cd629$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $e229cb5c8b2cd629$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue(), $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $e229cb5c8b2cd629$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $e229cb5c8b2cd629$var$checkIfSnapshotChanged(inst) && $e229cb5c8b2cd629$var$forceStoreRerender(fiber);
}
function $e229cb5c8b2cd629$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $e229cb5c8b2cd629$var$checkIfSnapshotChanged(inst) && $e229cb5c8b2cd629$var$forceStoreRerender(fiber);
    });
}
function $e229cb5c8b2cd629$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$e229cb5c8b2cd629$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $e229cb5c8b2cd629$var$forceStoreRerender(fiber) {
    var root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $e229cb5c8b2cd629$var$mountStateImpl(initialState) {
    var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e229cb5c8b2cd629$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $e229cb5c8b2cd629$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $e229cb5c8b2cd629$var$updateReducerImpl(hook, $e229cb5c8b2cd629$var$currentHook, "function" === typeof reducer ? reducer : $e229cb5c8b2cd629$var$basicStateReducer);
}
function $e229cb5c8b2cd629$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $e229cb5c8b2cd629$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $e229cb5c8b2cd629$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $e229cb5c8b2cd629$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T, currentTransition = {};
        $e229cb5c8b2cd629$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $e229cb5c8b2cd629$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $e229cb5c8b2cd629$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $e229cb5c8b2cd629$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $e229cb5c8b2cd629$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $e229cb5c8b2cd629$var$onActionError(actionQueue, node, error$66);
    }
}
function $e229cb5c8b2cd629$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $e229cb5c8b2cd629$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $e229cb5c8b2cd629$var$onActionError(actionQueue, node, error);
    }) : $e229cb5c8b2cd629$var$onActionSuccess(actionQueue, node, returnValue);
}
function $e229cb5c8b2cd629$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $e229cb5c8b2cd629$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $e229cb5c8b2cd629$var$runActionStateAction(actionQueue, nextState)));
}
function $e229cb5c8b2cd629$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $e229cb5c8b2cd629$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $e229cb5c8b2cd629$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $e229cb5c8b2cd629$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $e229cb5c8b2cd629$var$mountActionState(action, initialStateProp) {
    if ($e229cb5c8b2cd629$var$isHydrating) {
        var ssrFormState = $e229cb5c8b2cd629$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $e229cb5c8b2cd629$var$currentlyRenderingFiber;
                if ($e229cb5c8b2cd629$var$isHydrating) {
                    if ($e229cb5c8b2cd629$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $e229cb5c8b2cd629$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $e229cb5c8b2cd629$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $e229cb5c8b2cd629$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $e229cb5c8b2cd629$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e229cb5c8b2cd629$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $e229cb5c8b2cd629$var$dispatchSetState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $e229cb5c8b2cd629$var$mountStateImpl(!1);
    inRootOrSingleton = $e229cb5c8b2cd629$var$dispatchOptimisticSetState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $e229cb5c8b2cd629$var$dispatchActionState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $e229cb5c8b2cd629$var$updateActionState(action) {
    var stateHook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    return $e229cb5c8b2cd629$var$updateActionStateImpl(stateHook, $e229cb5c8b2cd629$var$currentHook, action);
}
function $e229cb5c8b2cd629$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $e229cb5c8b2cd629$var$updateReducerImpl(stateHook, currentStateHook, $e229cb5c8b2cd629$var$actionStateReducer)[0];
    stateHook = $e229cb5c8b2cd629$var$updateReducer($e229cb5c8b2cd629$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $e229cb5c8b2cd629$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $e229cb5c8b2cd629$var$SuspenseException) throw $e229cb5c8b2cd629$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($e229cb5c8b2cd629$var$currentlyRenderingFiber.flags |= 2048, $e229cb5c8b2cd629$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $e229cb5c8b2cd629$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $e229cb5c8b2cd629$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $e229cb5c8b2cd629$var$rerenderActionState(action) {
    var stateHook = $e229cb5c8b2cd629$var$updateWorkInProgressHook(), currentStateHook = $e229cb5c8b2cd629$var$currentHook;
    if (null !== currentStateHook) return $e229cb5c8b2cd629$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $e229cb5c8b2cd629$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue(), $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $e229cb5c8b2cd629$var$updateRef() {
    return $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
}
function $e229cb5c8b2cd629$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    $e229cb5c8b2cd629$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $e229cb5c8b2cd629$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $e229cb5c8b2cd629$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $e229cb5c8b2cd629$var$currentHook && null !== deps && $e229cb5c8b2cd629$var$areHookInputsEqual(deps, $e229cb5c8b2cd629$var$currentHook.memoizedState.deps) ? hook.memoizedState = $e229cb5c8b2cd629$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($e229cb5c8b2cd629$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $e229cb5c8b2cd629$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $e229cb5c8b2cd629$var$mountEffect(create, deps) {
    $e229cb5c8b2cd629$var$mountEffectImpl(8390656, 8, create, deps);
}
function $e229cb5c8b2cd629$var$updateEffect(create, deps) {
    $e229cb5c8b2cd629$var$updateEffectImpl(2048, 8, create, deps);
}
function $e229cb5c8b2cd629$var$useEffectEventImpl(payload) {
    $e229cb5c8b2cd629$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue(), $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $e229cb5c8b2cd629$var$updateEvent(callback) {
    var ref = $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
    $e229cb5c8b2cd629$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($e229cb5c8b2cd629$var$executionContext & 2)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $e229cb5c8b2cd629$var$updateInsertionEffect(create, deps) {
    return $e229cb5c8b2cd629$var$updateEffectImpl(4, 2, create, deps);
}
function $e229cb5c8b2cd629$var$updateLayoutEffect(create, deps) {
    return $e229cb5c8b2cd629$var$updateEffectImpl(4, 4, create, deps);
}
function $e229cb5c8b2cd629$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $e229cb5c8b2cd629$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $e229cb5c8b2cd629$var$updateEffectImpl(4, 4, $e229cb5c8b2cd629$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $e229cb5c8b2cd629$var$mountDebugValue() {}
function $e229cb5c8b2cd629$var$updateCallback(callback, deps) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $e229cb5c8b2cd629$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $e229cb5c8b2cd629$var$updateMemo(nextCreate, deps) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $e229cb5c8b2cd629$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $e229cb5c8b2cd629$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($e229cb5c8b2cd629$var$renderLanes & 1073741824) && 0 === ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $e229cb5c8b2cd629$var$requestDeferredLane();
    $e229cb5c8b2cd629$var$currentlyRenderingFiber.lanes |= hook;
    $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $e229cb5c8b2cd629$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($e229cb5c8b2cd629$var$objectIs(value, prevValue)) return value;
    if (null !== $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor.current) return hook = $e229cb5c8b2cd629$var$mountDeferredValueImpl(hook, value, initialValue), $e229cb5c8b2cd629$var$objectIs(hook, prevValue) || ($e229cb5c8b2cd629$var$didReceiveUpdate = !0), hook;
    if (0 === ($e229cb5c8b2cd629$var$renderLanes & 42) || 0 !== ($e229cb5c8b2cd629$var$renderLanes & 1073741824) && 0 === ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 261930)) return $e229cb5c8b2cd629$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $e229cb5c8b2cd629$var$requestDeferredLane();
    $e229cb5c8b2cd629$var$currentlyRenderingFiber.lanes |= hook;
    $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $e229cb5c8b2cd629$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T, currentTransition = {};
    $e229cb5c8b2cd629$var$ReactSharedInternals.T = currentTransition;
    $e229cb5c8b2cd629$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $e229cb5c8b2cd629$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $e229cb5c8b2cd629$var$chainThenableValue(returnValue, finishedState);
            $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $e229cb5c8b2cd629$var$requestUpdateLane(fiber));
        } else $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, finishedState, $e229cb5c8b2cd629$var$requestUpdateLane(fiber));
    } catch (error) {
        $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $e229cb5c8b2cd629$var$requestUpdateLane());
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition;
    }
}
function $e229cb5c8b2cd629$var$noop() {}
function $e229cb5c8b2cd629$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(476));
    var queue = $e229cb5c8b2cd629$var$ensureFormComponentIsStateful(formFiber).queue;
    $e229cb5c8b2cd629$var$startTransition(formFiber, queue, pendingState, $e229cb5c8b2cd629$var$sharedNotPendingObject, null === action ? $e229cb5c8b2cd629$var$noop : function() {
        $e229cb5c8b2cd629$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $e229cb5c8b2cd629$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $e229cb5c8b2cd629$var$sharedNotPendingObject,
        baseState: $e229cb5c8b2cd629$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $e229cb5c8b2cd629$var$basicStateReducer,
            lastRenderedState: $e229cb5c8b2cd629$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $e229cb5c8b2cd629$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $e229cb5c8b2cd629$var$requestFormReset$1(formFiber) {
    var stateHook = $e229cb5c8b2cd629$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $e229cb5c8b2cd629$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $e229cb5c8b2cd629$var$requestUpdateLane());
}
function $e229cb5c8b2cd629$var$useHostTransitionStatus() {
    return $e229cb5c8b2cd629$var$readContext($e229cb5c8b2cd629$var$HostTransitionContext);
}
function $e229cb5c8b2cd629$var$updateId() {
    return $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
}
function $e229cb5c8b2cd629$var$updateRefresh() {
    return $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
}
function $e229cb5c8b2cd629$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $e229cb5c8b2cd629$var$requestUpdateLane();
                fiber = $e229cb5c8b2cd629$var$createUpdate(lane);
                var root$69 = $e229cb5c8b2cd629$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root$69, provider, lane), $e229cb5c8b2cd629$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $e229cb5c8b2cd629$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $e229cb5c8b2cd629$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $e229cb5c8b2cd629$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber) ? $e229cb5c8b2cd629$var$enqueueRenderPhaseUpdate(queue, action) : (action = $e229cb5c8b2cd629$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(action, fiber, lane), $e229cb5c8b2cd629$var$entangleTransitionUpdate(action, queue, lane)));
}
function $e229cb5c8b2cd629$var$dispatchSetState(fiber, queue, action) {
    var lane = $e229cb5c8b2cd629$var$requestUpdateLane();
    $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber)) $e229cb5c8b2cd629$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($e229cb5c8b2cd629$var$objectIs(eagerState, currentState)) return $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, queue, update, 0), null === $e229cb5c8b2cd629$var$workInProgressRoot && $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $e229cb5c8b2cd629$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(action, fiber, lane), $e229cb5c8b2cd629$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $e229cb5c8b2cd629$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $e229cb5c8b2cd629$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $e229cb5c8b2cd629$var$currentlyRenderingFiber || null !== alternate && alternate === $e229cb5c8b2cd629$var$currentlyRenderingFiber;
}
function $e229cb5c8b2cd629$var$enqueueRenderPhaseUpdate(queue, update) {
    $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass = $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $e229cb5c8b2cd629$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $e229cb5c8b2cd629$var$markRootEntangled(root, lane);
    }
}
var $e229cb5c8b2cd629$var$ContextOnlyDispatcher = {
    readContext: $e229cb5c8b2cd629$var$readContext,
    use: $e229cb5c8b2cd629$var$use,
    useCallback: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useContext: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useEffect: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useImperativeHandle: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useLayoutEffect: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useInsertionEffect: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useMemo: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useReducer: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useRef: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useState: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useDebugValue: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useDeferredValue: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useTransition: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useSyncExternalStore: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useId: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useHostTransitionStatus: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useFormState: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useActionState: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useOptimistic: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useMemoCache: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useCacheRefresh: $e229cb5c8b2cd629$var$throwInvalidHookError
};
$e229cb5c8b2cd629$var$ContextOnlyDispatcher.useEffectEvent = $e229cb5c8b2cd629$var$throwInvalidHookError;
var $e229cb5c8b2cd629$var$HooksDispatcherOnMount = {
    readContext: $e229cb5c8b2cd629$var$readContext,
    use: $e229cb5c8b2cd629$var$use,
    useCallback: function(callback, deps) {
        $e229cb5c8b2cd629$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $e229cb5c8b2cd629$var$readContext,
    useEffect: $e229cb5c8b2cd629$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $e229cb5c8b2cd629$var$mountEffectImpl(4194308, 4, $e229cb5c8b2cd629$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $e229cb5c8b2cd629$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $e229cb5c8b2cd629$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $e229cb5c8b2cd629$var$dispatchReducerAction.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $e229cb5c8b2cd629$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $e229cb5c8b2cd629$var$dispatchSetState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $e229cb5c8b2cd629$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        return $e229cb5c8b2cd629$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $e229cb5c8b2cd629$var$mountStateImpl(!1);
        stateHook = $e229cb5c8b2cd629$var$startTransition.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $e229cb5c8b2cd629$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $e229cb5c8b2cd629$var$currentlyRenderingFiber, hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        if ($e229cb5c8b2cd629$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $e229cb5c8b2cd629$var$workInProgressRoot) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(349));
            0 !== ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 127) || $e229cb5c8b2cd629$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $e229cb5c8b2cd629$var$mountEffect($e229cb5c8b2cd629$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $e229cb5c8b2cd629$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $e229cb5c8b2cd629$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook(), identifierPrefix = $e229cb5c8b2cd629$var$workInProgressRoot.identifierPrefix;
        if ($e229cb5c8b2cd629$var$isHydrating) {
            var JSCompiler_inline_result = $e229cb5c8b2cd629$var$treeContextOverflow;
            var idWithLeadingBit = $e229cb5c8b2cd629$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $e229cb5c8b2cd629$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $e229cb5c8b2cd629$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $e229cb5c8b2cd629$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $e229cb5c8b2cd629$var$useHostTransitionStatus,
    useFormState: $e229cb5c8b2cd629$var$mountActionState,
    useActionState: $e229cb5c8b2cd629$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $e229cb5c8b2cd629$var$dispatchOptimisticSetState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $e229cb5c8b2cd629$var$useMemoCache,
    useCacheRefresh: function() {
        return $e229cb5c8b2cd629$var$mountWorkInProgressHook().memoizedState = $e229cb5c8b2cd629$var$refreshCache.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($e229cb5c8b2cd629$var$executionContext & 2)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $e229cb5c8b2cd629$var$HooksDispatcherOnUpdate = {
    readContext: $e229cb5c8b2cd629$var$readContext,
    use: $e229cb5c8b2cd629$var$use,
    useCallback: $e229cb5c8b2cd629$var$updateCallback,
    useContext: $e229cb5c8b2cd629$var$readContext,
    useEffect: $e229cb5c8b2cd629$var$updateEffect,
    useImperativeHandle: $e229cb5c8b2cd629$var$updateImperativeHandle,
    useInsertionEffect: $e229cb5c8b2cd629$var$updateInsertionEffect,
    useLayoutEffect: $e229cb5c8b2cd629$var$updateLayoutEffect,
    useMemo: $e229cb5c8b2cd629$var$updateMemo,
    useReducer: $e229cb5c8b2cd629$var$updateReducer,
    useRef: $e229cb5c8b2cd629$var$updateRef,
    useState: function() {
        return $e229cb5c8b2cd629$var$updateReducer($e229cb5c8b2cd629$var$basicStateReducer);
    },
    useDebugValue: $e229cb5c8b2cd629$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
        return $e229cb5c8b2cd629$var$updateDeferredValueImpl(hook, $e229cb5c8b2cd629$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $e229cb5c8b2cd629$var$updateReducer($e229cb5c8b2cd629$var$basicStateReducer)[0], start = $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $e229cb5c8b2cd629$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $e229cb5c8b2cd629$var$updateSyncExternalStore,
    useId: $e229cb5c8b2cd629$var$updateId,
    useHostTransitionStatus: $e229cb5c8b2cd629$var$useHostTransitionStatus,
    useFormState: $e229cb5c8b2cd629$var$updateActionState,
    useActionState: $e229cb5c8b2cd629$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
        return $e229cb5c8b2cd629$var$updateOptimisticImpl(hook, $e229cb5c8b2cd629$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $e229cb5c8b2cd629$var$useMemoCache,
    useCacheRefresh: $e229cb5c8b2cd629$var$updateRefresh
};
$e229cb5c8b2cd629$var$HooksDispatcherOnUpdate.useEffectEvent = $e229cb5c8b2cd629$var$updateEvent;
var $e229cb5c8b2cd629$var$HooksDispatcherOnRerender = {
    readContext: $e229cb5c8b2cd629$var$readContext,
    use: $e229cb5c8b2cd629$var$use,
    useCallback: $e229cb5c8b2cd629$var$updateCallback,
    useContext: $e229cb5c8b2cd629$var$readContext,
    useEffect: $e229cb5c8b2cd629$var$updateEffect,
    useImperativeHandle: $e229cb5c8b2cd629$var$updateImperativeHandle,
    useInsertionEffect: $e229cb5c8b2cd629$var$updateInsertionEffect,
    useLayoutEffect: $e229cb5c8b2cd629$var$updateLayoutEffect,
    useMemo: $e229cb5c8b2cd629$var$updateMemo,
    useReducer: $e229cb5c8b2cd629$var$rerenderReducer,
    useRef: $e229cb5c8b2cd629$var$updateRef,
    useState: function() {
        return $e229cb5c8b2cd629$var$rerenderReducer($e229cb5c8b2cd629$var$basicStateReducer);
    },
    useDebugValue: $e229cb5c8b2cd629$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
        return null === $e229cb5c8b2cd629$var$currentHook ? $e229cb5c8b2cd629$var$mountDeferredValueImpl(hook, value, initialValue) : $e229cb5c8b2cd629$var$updateDeferredValueImpl(hook, $e229cb5c8b2cd629$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $e229cb5c8b2cd629$var$rerenderReducer($e229cb5c8b2cd629$var$basicStateReducer)[0], start = $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $e229cb5c8b2cd629$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $e229cb5c8b2cd629$var$updateSyncExternalStore,
    useId: $e229cb5c8b2cd629$var$updateId,
    useHostTransitionStatus: $e229cb5c8b2cd629$var$useHostTransitionStatus,
    useFormState: $e229cb5c8b2cd629$var$rerenderActionState,
    useActionState: $e229cb5c8b2cd629$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
        if (null !== $e229cb5c8b2cd629$var$currentHook) return $e229cb5c8b2cd629$var$updateOptimisticImpl(hook, $e229cb5c8b2cd629$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $e229cb5c8b2cd629$var$useMemoCache,
    useCacheRefresh: $e229cb5c8b2cd629$var$updateRefresh
};
$e229cb5c8b2cd629$var$HooksDispatcherOnRerender.useEffectEvent = $e229cb5c8b2cd629$var$updateEvent;
function $e229cb5c8b2cd629$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $e229cb5c8b2cd629$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $e229cb5c8b2cd629$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $e229cb5c8b2cd629$var$requestUpdateLane(), update = $e229cb5c8b2cd629$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $e229cb5c8b2cd629$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(payload, inst, lane), $e229cb5c8b2cd629$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $e229cb5c8b2cd629$var$requestUpdateLane(), update = $e229cb5c8b2cd629$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $e229cb5c8b2cd629$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(payload, inst, lane), $e229cb5c8b2cd629$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $e229cb5c8b2cd629$var$requestUpdateLane(), update = $e229cb5c8b2cd629$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $e229cb5c8b2cd629$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(callback, inst, lane), $e229cb5c8b2cd629$var$entangleTransitions(callback, inst, lane));
    }
};
function $e229cb5c8b2cd629$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$e229cb5c8b2cd629$var$shallowEqual(oldProps, newProps) || !$e229cb5c8b2cd629$var$shallowEqual(oldState, newState) : !0;
}
function $e229cb5c8b2cd629$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $e229cb5c8b2cd629$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $e229cb5c8b2cd629$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $e229cb5c8b2cd629$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $e229cb5c8b2cd629$var$defaultOnUncaughtError(error) {
    $e229cb5c8b2cd629$var$reportGlobalError(error);
}
function $e229cb5c8b2cd629$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $e229cb5c8b2cd629$var$defaultOnRecoverableError(error) {
    $e229cb5c8b2cd629$var$reportGlobalError(error);
}
function $e229cb5c8b2cd629$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $e229cb5c8b2cd629$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $e229cb5c8b2cd629$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $e229cb5c8b2cd629$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $e229cb5c8b2cd629$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $e229cb5c8b2cd629$var$createClassErrorUpdate(lane) {
    lane = $e229cb5c8b2cd629$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $e229cb5c8b2cd629$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $e229cb5c8b2cd629$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $e229cb5c8b2cd629$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed ? $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $e229cb5c8b2cd629$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $e229cb5c8b2cd629$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $e229cb5c8b2cd629$var$shellBoundary ? $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $e229cb5c8b2cd629$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $e229cb5c8b2cd629$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $e229cb5c8b2cd629$var$attachPingListener(root, value, rootRenderLanes);
        $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($e229cb5c8b2cd629$var$isHydrating) return returnFiber = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $e229cb5c8b2cd629$var$HydrationMismatchException && (root = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(422), {
        cause: value
    }), $e229cb5c8b2cd629$var$queueHydrationError($e229cb5c8b2cd629$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $e229cb5c8b2cd629$var$HydrationMismatchException && (returnFiber = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(423), {
        cause: value
    }), $e229cb5c8b2cd629$var$queueHydrationError($e229cb5c8b2cd629$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $e229cb5c8b2cd629$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $e229cb5c8b2cd629$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors ? $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $e229cb5c8b2cd629$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $e229cb5c8b2cd629$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed || !$e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $e229cb5c8b2cd629$var$createClassErrorUpdate(rootRenderLanes), $e229cb5c8b2cd629$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $e229cb5c8b2cd629$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $e229cb5c8b2cd629$var$SelectiveHydrationException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(461)), $e229cb5c8b2cd629$var$didReceiveUpdate = !1;
function $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $e229cb5c8b2cd629$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $e229cb5c8b2cd629$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress);
    nextProps = $e229cb5c8b2cd629$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $e229cb5c8b2cd629$var$checkDidRenderIdHook();
    if (null !== current && !$e229cb5c8b2cd629$var$didReceiveUpdate) return $e229cb5c8b2cd629$var$bailoutHooks(current, workInProgress, renderLanes), $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $e229cb5c8b2cd629$var$isHydrating && key && $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$e229cb5c8b2cd629$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $e229cb5c8b2cd629$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$e229cb5c8b2cd629$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $e229cb5c8b2cd629$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $e229cb5c8b2cd629$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $e229cb5c8b2cd629$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($e229cb5c8b2cd629$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($e229cb5c8b2cd629$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $e229cb5c8b2cd629$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($e229cb5c8b2cd629$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $e229cb5c8b2cd629$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $e229cb5c8b2cd629$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $e229cb5c8b2cd629$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $e229cb5c8b2cd629$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $e229cb5c8b2cd629$var$pushHiddenContext(workInProgress, prevState) : $e229cb5c8b2cd629$var$reuseHiddenContextOnStack(), $e229cb5c8b2cd629$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $e229cb5c8b2cd629$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($e229cb5c8b2cd629$var$pushTransition(workInProgress, prevState.cachePool), $e229cb5c8b2cd629$var$pushHiddenContext(workInProgress, prevState), $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $e229cb5c8b2cd629$var$pushTransition(workInProgress, null), $e229cb5c8b2cd629$var$reuseHiddenContextOnStack(), $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress));
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $e229cb5c8b2cd629$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $e229cb5c8b2cd629$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $e229cb5c8b2cd629$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $e229cb5c8b2cd629$var$pushTransition(workInProgress, null);
    $e229cb5c8b2cd629$var$reuseHiddenContextOnStack();
    $e229cb5c8b2cd629$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $e229cb5c8b2cd629$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $e229cb5c8b2cd629$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $e229cb5c8b2cd629$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $e229cb5c8b2cd629$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($e229cb5c8b2cd629$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $e229cb5c8b2cd629$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $e229cb5c8b2cd629$var$bailoutOffscreenComponent(null, current);
            $e229cb5c8b2cd629$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $e229cb5c8b2cd629$var$nextHydratableInstance) ? (current = $e229cb5c8b2cd629$var$canHydrateHydrationBoundary(current, $e229cb5c8b2cd629$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $e229cb5c8b2cd629$var$treeContextProvider ? {
                    id: $e229cb5c8b2cd629$var$treeContextId,
                    overflow: $e229cb5c8b2cd629$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $e229cb5c8b2cd629$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $e229cb5c8b2cd629$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $e229cb5c8b2cd629$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $e229cb5c8b2cd629$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(558));
        } else if ($e229cb5c8b2cd629$var$didReceiveUpdate || $e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $e229cb5c8b2cd629$var$didReceiveUpdate || didSuspend) {
            nextProps = $e229cb5c8b2cd629$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $e229cb5c8b2cd629$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(current, dehydrated), $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $e229cb5c8b2cd629$var$SelectiveHydrationException;
            $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible();
            workInProgress = $e229cb5c8b2cd629$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(dehydrated.nextSibling), $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$isHydrating = !0, $e229cb5c8b2cd629$var$hydrationErrors = null, $e229cb5c8b2cd629$var$rootOrSingletonContext = !1, null !== current && $e229cb5c8b2cd629$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $e229cb5c8b2cd629$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $e229cb5c8b2cd629$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $e229cb5c8b2cd629$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $e229cb5c8b2cd629$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress);
    Component = $e229cb5c8b2cd629$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $e229cb5c8b2cd629$var$checkDidRenderIdHook();
    if (null !== current && !$e229cb5c8b2cd629$var$didReceiveUpdate) return $e229cb5c8b2cd629$var$bailoutHooks(current, workInProgress, renderLanes), $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $e229cb5c8b2cd629$var$isHydrating && nextProps && $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $e229cb5c8b2cd629$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $e229cb5c8b2cd629$var$finishRenderingHooks(current);
    Component = $e229cb5c8b2cd629$var$checkDidRenderIdHook();
    if (null !== current && !$e229cb5c8b2cd629$var$didReceiveUpdate) return $e229cb5c8b2cd629$var$bailoutHooks(current, workInProgress, renderLanes), $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $e229cb5c8b2cd629$var$isHydrating && Component && $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $e229cb5c8b2cd629$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $e229cb5c8b2cd629$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $e229cb5c8b2cd629$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $e229cb5c8b2cd629$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $e229cb5c8b2cd629$var$readContext(contextType) : $e229cb5c8b2cd629$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($e229cb5c8b2cd629$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $e229cb5c8b2cd629$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $e229cb5c8b2cd629$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $e229cb5c8b2cd629$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $e229cb5c8b2cd629$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $e229cb5c8b2cd629$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $e229cb5c8b2cd629$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $e229cb5c8b2cd629$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($e229cb5c8b2cd629$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $e229cb5c8b2cd629$var$hasForceUpdate || $e229cb5c8b2cd629$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $e229cb5c8b2cd629$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $e229cb5c8b2cd629$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $e229cb5c8b2cd629$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $e229cb5c8b2cd629$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $e229cb5c8b2cd629$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $e229cb5c8b2cd629$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $e229cb5c8b2cd629$var$hasForceUpdate || null !== current && null !== current.dependencies && $e229cb5c8b2cd629$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($e229cb5c8b2cd629$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $e229cb5c8b2cd629$var$hasForceUpdate || $e229cb5c8b2cd629$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $e229cb5c8b2cd629$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $e229cb5c8b2cd629$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $e229cb5c8b2cd629$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $e229cb5c8b2cd629$var$resetHydrationState();
    workInProgress.flags |= 256;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $e229cb5c8b2cd629$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $e229cb5c8b2cd629$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $e229cb5c8b2cd629$var$getSuspendedCache()
    };
}
function $e229cb5c8b2cd629$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $e229cb5c8b2cd629$var$workInProgressDeferredLane);
    return current;
}
function $e229cb5c8b2cd629$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($e229cb5c8b2cd629$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($e229cb5c8b2cd629$var$isHydrating) {
            showFallback ? $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $e229cb5c8b2cd629$var$nextHydratableInstance) ? (current = $e229cb5c8b2cd629$var$canHydrateHydrationBoundary(current, $e229cb5c8b2cd629$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $e229cb5c8b2cd629$var$treeContextProvider ? {
                    id: $e229cb5c8b2cd629$var$treeContextId,
                    overflow: $e229cb5c8b2cd629$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $e229cb5c8b2cd629$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress);
            $e229cb5c8b2cd629$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $e229cb5c8b2cd629$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $e229cb5c8b2cd629$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $e229cb5c8b2cd629$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $e229cb5c8b2cd629$var$SUSPENDED_MARKER, $e229cb5c8b2cd629$var$bailoutOffscreenComponent(null, nextProps);
        $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $e229cb5c8b2cd629$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $e229cb5c8b2cd629$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $e229cb5c8b2cd629$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $e229cb5c8b2cd629$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $e229cb5c8b2cd629$var$SUSPENDED_MARKER, workInProgress = $e229cb5c8b2cd629$var$bailoutOffscreenComponent(null, nextProps));
        else if ($e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress), $e229cb5c8b2cd629$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $e229cb5c8b2cd629$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($e229cb5c8b2cd629$var$didReceiveUpdate || $e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $e229cb5c8b2cd629$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $e229cb5c8b2cd629$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $e229cb5c8b2cd629$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(current, nextProps), $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $e229cb5c8b2cd629$var$SelectiveHydrationException;
            $e229cb5c8b2cd629$var$isSuspenseInstancePending(nextPrimaryChildren) || $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible();
            workInProgress = $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $e229cb5c8b2cd629$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(nextPrimaryChildren.nextSibling), $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$isHydrating = !0, $e229cb5c8b2cd629$var$hydrationErrors = null, $e229cb5c8b2cd629$var$rootOrSingletonContext = !1, null !== current && $e229cb5c8b2cd629$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $e229cb5c8b2cd629$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $e229cb5c8b2cd629$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $e229cb5c8b2cd629$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $e229cb5c8b2cd629$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $e229cb5c8b2cd629$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $e229cb5c8b2cd629$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $e229cb5c8b2cd629$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $e229cb5c8b2cd629$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $e229cb5c8b2cd629$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $e229cb5c8b2cd629$var$SUSPENDED_MARKER, $e229cb5c8b2cd629$var$bailoutOffscreenComponent(current.child, nextProps);
    $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $e229cb5c8b2cd629$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $e229cb5c8b2cd629$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $e229cb5c8b2cd629$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $e229cb5c8b2cd629$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $e229cb5c8b2cd629$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $e229cb5c8b2cd629$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $e229cb5c8b2cd629$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, suspenseContext);
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $e229cb5c8b2cd629$var$isHydrating ? $e229cb5c8b2cd629$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $e229cb5c8b2cd629$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $e229cb5c8b2cd629$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $e229cb5c8b2cd629$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $e229cb5c8b2cd629$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $e229cb5c8b2cd629$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $e229cb5c8b2cd629$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $e229cb5c8b2cd629$var$checkIfContextChanged(current) ? !0 : !1;
}
function $e229cb5c8b2cd629$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $e229cb5c8b2cd629$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, current.memoizedState.cache);
            $e229cb5c8b2cd629$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $e229cb5c8b2cd629$var$pushHostContext(workInProgress);
            break;
        case 4:
            $e229cb5c8b2cd629$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $e229cb5c8b2cd629$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $e229cb5c8b2cd629$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $e229cb5c8b2cd629$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $e229cb5c8b2cd629$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $e229cb5c8b2cd629$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, current.memoizedState.cache);
    }
    return $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $e229cb5c8b2cd629$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $e229cb5c8b2cd629$var$didReceiveUpdate = !0;
        else {
            if (!$e229cb5c8b2cd629$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $e229cb5c8b2cd629$var$didReceiveUpdate = !1, $e229cb5c8b2cd629$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $e229cb5c8b2cd629$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $e229cb5c8b2cd629$var$didReceiveUpdate = !1, $e229cb5c8b2cd629$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $e229cb5c8b2cd629$var$pushTreeId(workInProgress, $e229cb5c8b2cd629$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $e229cb5c8b2cd629$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $e229cb5c8b2cd629$var$shouldConstruct(current) ? (props = $e229cb5c8b2cd629$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $e229cb5c8b2cd629$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $e229cb5c8b2cd629$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $e229cb5c8b2cd629$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $e229cb5c8b2cd629$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $e229cb5c8b2cd629$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $e229cb5c8b2cd629$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $e229cb5c8b2cd629$var$getComponentNameFromType(current) || current;
                    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $e229cb5c8b2cd629$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $e229cb5c8b2cd629$var$resolveClassComponentProps(props, workInProgress.pendingProps), $e229cb5c8b2cd629$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $e229cb5c8b2cd629$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $e229cb5c8b2cd629$var$cloneUpdateQueue(current, workInProgress);
                $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, props);
                props !== prevState.cache && $e229cb5c8b2cd629$var$propagateContextChanges(workInProgress, [
                    $e229cb5c8b2cd629$var$CacheContext
                ], renderLanes, !0);
                $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $e229cb5c8b2cd629$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(Error($e229cb5c8b2cd629$var$formatProdErrorMessage(424)), workInProgress);
                        $e229cb5c8b2cd629$var$queueHydrationError($$typeof);
                        workInProgress = $e229cb5c8b2cd629$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(current.firstChild);
                        $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress;
                        $e229cb5c8b2cd629$var$isHydrating = !0;
                        $e229cb5c8b2cd629$var$hydrationErrors = null;
                        $e229cb5c8b2cd629$var$rootOrSingletonContext = !0;
                        renderLanes = $e229cb5c8b2cd629$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $e229cb5c8b2cd629$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $e229cb5c8b2cd629$var$markRef(current, workInProgress), null === current ? (renderLanes = $e229cb5c8b2cd629$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $e229cb5c8b2cd629$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer($e229cb5c8b2cd629$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress, props[$e229cb5c8b2cd629$var$internalPropsKey] = current, $e229cb5c8b2cd629$var$setInitialProperties(props, renderLanes, current), $e229cb5c8b2cd629$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $e229cb5c8b2cd629$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $e229cb5c8b2cd629$var$pushHostContext(workInProgress), null === current && $e229cb5c8b2cd629$var$isHydrating && (props = workInProgress.stateNode = $e229cb5c8b2cd629$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $e229cb5c8b2cd629$var$rootInstanceStackCursor.current), $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$rootOrSingletonContext = !0, $$typeof = $e229cb5c8b2cd629$var$nextHydratableInstance, $e229cb5c8b2cd629$var$isSingletonScope(workInProgress.type) ? ($e229cb5c8b2cd629$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(props.firstChild)) : $e229cb5c8b2cd629$var$nextHydratableInstance = $$typeof), $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $e229cb5c8b2cd629$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $e229cb5c8b2cd629$var$isHydrating) {
                if ($$typeof = props = $e229cb5c8b2cd629$var$nextHydratableInstance) props = $e229cb5c8b2cd629$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $e229cb5c8b2cd629$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(props.firstChild), $e229cb5c8b2cd629$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress);
            }
            $e229cb5c8b2cd629$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $e229cb5c8b2cd629$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $e229cb5c8b2cd629$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $e229cb5c8b2cd629$var$renderWithHooks(current, workInProgress, $e229cb5c8b2cd629$var$TransitionAwareHostComponent, null, null, renderLanes), $e229cb5c8b2cd629$var$HostTransitionContext._currentValue = $$typeof);
            $e229cb5c8b2cd629$var$markRef(current, workInProgress);
            $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $e229cb5c8b2cd629$var$isHydrating) {
                if (current = renderLanes = $e229cb5c8b2cd629$var$nextHydratableInstance) renderLanes = $e229cb5c8b2cd629$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $e229cb5c8b2cd629$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $e229cb5c8b2cd629$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $e229cb5c8b2cd629$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $e229cb5c8b2cd629$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $e229cb5c8b2cd629$var$pushProvider(workInProgress, workInProgress.type, props.value), $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress), $$typeof = $e229cb5c8b2cd629$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $e229cb5c8b2cd629$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $e229cb5c8b2cd629$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $e229cb5c8b2cd629$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $e229cb5c8b2cd629$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $e229cb5c8b2cd629$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress), props = $e229cb5c8b2cd629$var$readContext($e229cb5c8b2cd629$var$CacheContext), null === current ? ($$typeof = $e229cb5c8b2cd629$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $e229cb5c8b2cd629$var$workInProgressRoot, prevState = $e229cb5c8b2cd629$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $e229cb5c8b2cd629$var$initializeUpdateQueue(workInProgress), $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($e229cb5c8b2cd629$var$cloneUpdateQueue(current, workInProgress), $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, null, null, renderLanes), $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, props)) : (props = prevState.cache, $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, props), props !== $$typeof.cache && $e229cb5c8b2cd629$var$propagateContextChanges(workInProgress, [
                $e229cb5c8b2cd629$var$CacheContext
            ], renderLanes, !0))), $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $e229cb5c8b2cd629$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $e229cb5c8b2cd629$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($e229cb5c8b2cd629$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $e229cb5c8b2cd629$var$suspendedThenable = $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable, $e229cb5c8b2cd629$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $e229cb5c8b2cd629$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$e229cb5c8b2cd629$var$preloadResource(resource)) {
        if ($e229cb5c8b2cd629$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $e229cb5c8b2cd629$var$suspendedThenable = $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable, $e229cb5c8b2cd629$var$SuspenseyCommitException;
    }
}
function $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $e229cb5c8b2cd629$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $e229cb5c8b2cd629$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$e229cb5c8b2cd629$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $e229cb5c8b2cd629$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $e229cb5c8b2cd629$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $e229cb5c8b2cd629$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 1:
            return $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext);
            $e229cb5c8b2cd629$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $e229cb5c8b2cd629$var$popHydrationState(workInProgress) ? $e229cb5c8b2cd629$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $e229cb5c8b2cd629$var$upgradeHydrationErrorsToRecoverable());
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($e229cb5c8b2cd629$var$markUpdate(workInProgress), null !== nextResource ? ($e229cb5c8b2cd629$var$bubbleProperties(workInProgress), $e229cb5c8b2cd629$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($e229cb5c8b2cd629$var$bubbleProperties(workInProgress), $e229cb5c8b2cd629$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($e229cb5c8b2cd629$var$markUpdate(workInProgress), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), $e229cb5c8b2cd629$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($e229cb5c8b2cd629$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), $e229cb5c8b2cd629$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $e229cb5c8b2cd629$var$popHostContext(workInProgress);
            renderLanes = $e229cb5c8b2cd629$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(166));
                    $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $e229cb5c8b2cd629$var$contextStackCursor.current;
                $e229cb5c8b2cd629$var$popHydrationState(workInProgress) ? $e229cb5c8b2cd629$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $e229cb5c8b2cd629$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $e229cb5c8b2cd629$var$markUpdate(workInProgress));
            }
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $e229cb5c8b2cd629$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(166));
                    $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $e229cb5c8b2cd629$var$contextStackCursor.current;
                if ($e229cb5c8b2cd629$var$popHydrationState(workInProgress)) $e229cb5c8b2cd629$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer($e229cb5c8b2cd629$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress;
                    nextResource[$e229cb5c8b2cd629$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($e229cb5c8b2cd629$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress);
                }
            }
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            $e229cb5c8b2cd629$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(166));
                current = $e229cb5c8b2cd629$var$rootInstanceStackCursor.current;
                if ($e229cb5c8b2cd629$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $e229cb5c8b2cd629$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $e229cb5c8b2cd629$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $e229cb5c8b2cd629$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(557));
                        current[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress;
                    } else $e229cb5c8b2cd629$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $e229cb5c8b2cd629$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress), workInProgress;
                    $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(558));
            }
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $e229cb5c8b2cd629$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(317));
                        type[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress;
                    } else $e229cb5c8b2cd629$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $e229cb5c8b2cd629$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress), workInProgress;
                    $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $e229cb5c8b2cd629$var$popHostContainer(), null === current && $e229cb5c8b2cd629$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 10:
            return $e229cb5c8b2cd629$var$popProvider(workInProgress.type), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 19:
            $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $e229cb5c8b2cd629$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $e229cb5c8b2cd629$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $e229cb5c8b2cd629$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $e229cb5c8b2cd629$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$e229cb5c8b2cd629$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current & 1 | 2);
                            $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $e229cb5c8b2cd629$var$now() > $e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $e229cb5c8b2cd629$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $e229cb5c8b2cd629$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, current), $e229cb5c8b2cd629$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$e229cb5c8b2cd629$var$isHydrating) return $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
                    } else 2 * $e229cb5c8b2cd629$var$now() - newProps.renderingStartTime > $e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $e229cb5c8b2cd629$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $e229cb5c8b2cd629$var$now(), current.sibling = null, renderLanes = $e229cb5c8b2cd629$var$suspenseStackCursor.current, $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress), $e229cb5c8b2cd629$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($e229cb5c8b2cd629$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $e229cb5c8b2cd629$var$unwindWork(current, workInProgress) {
    $e229cb5c8b2cd629$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext), $e229cb5c8b2cd629$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $e229cb5c8b2cd629$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(340));
                $e229cb5c8b2cd629$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(340));
                $e229cb5c8b2cd629$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseStackCursor), null;
        case 4:
            return $e229cb5c8b2cd629$var$popHostContainer(), null;
        case 10:
            return $e229cb5c8b2cd629$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress), $e229cb5c8b2cd629$var$popHiddenContext(), null !== current && $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $e229cb5c8b2cd629$var$unwindInterruptedWork(current, interruptedWork) {
    $e229cb5c8b2cd629$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext);
            $e229cb5c8b2cd629$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $e229cb5c8b2cd629$var$popHostContext(interruptedWork);
            break;
        case 4:
            $e229cb5c8b2cd629$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $e229cb5c8b2cd629$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $e229cb5c8b2cd629$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseStackCursor);
            break;
        case 10:
            $e229cb5c8b2cd629$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $e229cb5c8b2cd629$var$popSuspenseHandler(interruptedWork);
            $e229cb5c8b2cd629$var$popHiddenContext();
            null !== current && $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$resumedCache);
            break;
        case 24:
            $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext);
    }
}
function $e229cb5c8b2cd629$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $e229cb5c8b2cd629$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $e229cb5c8b2cd629$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $e229cb5c8b2cd629$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $e229cb5c8b2cd629$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $e229cb5c8b2cd629$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $e229cb5c8b2cd629$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $e229cb5c8b2cd629$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $e229cb5c8b2cd629$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$e229cb5c8b2cd629$var$internalPropsKey] = newProps;
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $e229cb5c8b2cd629$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $e229cb5c8b2cd629$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $e229cb5c8b2cd629$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $e229cb5c8b2cd629$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $e229cb5c8b2cd629$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $e229cb5c8b2cd629$var$noop$1));
    else if (4 !== tag && (27 === tag && $e229cb5c8b2cd629$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($e229cb5c8b2cd629$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$e229cb5c8b2cd629$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $e229cb5c8b2cd629$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $e229cb5c8b2cd629$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($e229cb5c8b2cd629$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$e229cb5c8b2cd629$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $e229cb5c8b2cd629$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $e229cb5c8b2cd629$var$setInitialProperties(singleton, type, props);
        singleton[$e229cb5c8b2cd629$var$internalInstanceKey] = finishedWork;
        singleton[$e229cb5c8b2cd629$var$internalPropsKey] = props;
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = !1, $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = !1, $e229cb5c8b2cd629$var$needsFormReset = !1, $e229cb5c8b2cd629$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $e229cb5c8b2cd629$var$nextEffect = null;
function $e229cb5c8b2cd629$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $e229cb5c8b2cd629$var$eventsEnabled = $e229cb5c8b2cd629$var$_enabled;
    root = $e229cb5c8b2cd629$var$getActiveElementDeep(root);
    if ($e229cb5c8b2cd629$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $e229cb5c8b2cd629$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $e229cb5c8b2cd629$var$_enabled = !1;
    for($e229cb5c8b2cd629$var$nextEffect = firstChild; null !== $e229cb5c8b2cd629$var$nextEffect;)if (firstChild = $e229cb5c8b2cd629$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $e229cb5c8b2cd629$var$nextEffect = root;
    else for(; null !== $e229cb5c8b2cd629$var$nextEffect;){
        firstChild = $e229cb5c8b2cd629$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $e229cb5c8b2cd629$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $e229cb5c8b2cd629$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $e229cb5c8b2cd629$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $e229cb5c8b2cd629$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $e229cb5c8b2cd629$var$nextEffect = root;
            break;
        }
        $e229cb5c8b2cd629$var$nextEffect = firstChild.return;
    }
}
function $e229cb5c8b2cd629$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $e229cb5c8b2cd629$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $e229cb5c8b2cd629$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $e229cb5c8b2cd629$var$commitClassCallbacks(finishedWork);
            flags & 512 && $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $e229cb5c8b2cd629$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $e229cb5c8b2cd629$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $e229cb5c8b2cd629$var$commitHostMount(finishedWork);
            flags & 512 && $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $e229cb5c8b2cd629$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $e229cb5c8b2cd629$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $e229cb5c8b2cd629$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $e229cb5c8b2cd629$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden;
                prevProps = $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden;
                $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = flags;
                ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = prevProps;
                $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $e229cb5c8b2cd629$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $e229cb5c8b2cd629$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $e229cb5c8b2cd629$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $e229cb5c8b2cd629$var$hostParent = null, $e229cb5c8b2cd629$var$hostParentIsContainer = !1;
function $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$e229cb5c8b2cd629$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $e229cb5c8b2cd629$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($e229cb5c8b2cd629$var$injectedHook && "function" === typeof $e229cb5c8b2cd629$var$injectedHook.onCommitFiberUnmount) try {
        $e229cb5c8b2cd629$var$injectedHook.onCommitFiberUnmount($e229cb5c8b2cd629$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $e229cb5c8b2cd629$var$hostParent, prevHostParentIsContainer = $e229cb5c8b2cd629$var$hostParentIsContainer;
            $e229cb5c8b2cd629$var$isSingletonScope(deletedFiber.type) && ($e229cb5c8b2cd629$var$hostParent = deletedFiber.stateNode, $e229cb5c8b2cd629$var$hostParentIsContainer = !1);
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e229cb5c8b2cd629$var$releaseSingletonInstance(deletedFiber.stateNode);
            $e229cb5c8b2cd629$var$hostParent = prevHostParent;
            $e229cb5c8b2cd629$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $e229cb5c8b2cd629$var$hostParent;
            prevHostParentIsContainer = $e229cb5c8b2cd629$var$hostParentIsContainer;
            $e229cb5c8b2cd629$var$hostParent = null;
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e229cb5c8b2cd629$var$hostParent = prevHostParent;
            $e229cb5c8b2cd629$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $e229cb5c8b2cd629$var$hostParent) {
                if ($e229cb5c8b2cd629$var$hostParentIsContainer) try {
                    (9 === $e229cb5c8b2cd629$var$hostParent.nodeType ? $e229cb5c8b2cd629$var$hostParent.body : "HTML" === $e229cb5c8b2cd629$var$hostParent.nodeName ? $e229cb5c8b2cd629$var$hostParent.ownerDocument.body : $e229cb5c8b2cd629$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $e229cb5c8b2cd629$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $e229cb5c8b2cd629$var$hostParent && ($e229cb5c8b2cd629$var$hostParentIsContainer ? (finishedRoot = $e229cb5c8b2cd629$var$hostParent, $e229cb5c8b2cd629$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $e229cb5c8b2cd629$var$retryIfBlockedOn(finishedRoot)) : $e229cb5c8b2cd629$var$clearHydrationBoundary($e229cb5c8b2cd629$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $e229cb5c8b2cd629$var$hostParent;
            prevHostParentIsContainer = $e229cb5c8b2cd629$var$hostParentIsContainer;
            $e229cb5c8b2cd629$var$hostParent = deletedFiber.stateNode.containerInfo;
            $e229cb5c8b2cd629$var$hostParentIsContainer = !0;
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e229cb5c8b2cd629$var$hostParent = prevHostParent;
            $e229cb5c8b2cd629$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $e229cb5c8b2cd629$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || ($e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $e229cb5c8b2cd629$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = (prevHostParent = $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $e229cb5c8b2cd629$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $e229cb5c8b2cd629$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $e229cb5c8b2cd629$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $e229cb5c8b2cd629$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $e229cb5c8b2cd629$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $e229cb5c8b2cd629$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $e229cb5c8b2cd629$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $e229cb5c8b2cd629$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($e229cb5c8b2cd629$var$isSingletonScope(parent.type)) {
                        $e229cb5c8b2cd629$var$hostParent = parent.stateNode;
                        $e229cb5c8b2cd629$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $e229cb5c8b2cd629$var$hostParent = parent.stateNode;
                    $e229cb5c8b2cd629$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $e229cb5c8b2cd629$var$hostParent = parent.stateNode.containerInfo;
                    $e229cb5c8b2cd629$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $e229cb5c8b2cd629$var$hostParent) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(160));
        $e229cb5c8b2cd629$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $e229cb5c8b2cd629$var$hostParent = null;
        $e229cb5c8b2cd629$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $e229cb5c8b2cd629$var$currentHoistableRoot = null;
function $e229cb5c8b2cd629$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($e229cb5c8b2cd629$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $e229cb5c8b2cd629$var$commitHookEffectListMount(3, finishedWork), $e229cb5c8b2cd629$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            flags & 64 && $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $e229cb5c8b2cd629$var$currentHoistableRoot;
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$e229cb5c8b2cd629$var$internalHoistableMarker] || currentResource[$e229cb5c8b2cd629$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $e229cb5c8b2cd629$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$e229cb5c8b2cd629$var$internalInstanceKey] = finishedWork;
                                        $e229cb5c8b2cd629$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $e229cb5c8b2cd629$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $e229cb5c8b2cd629$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $e229cb5c8b2cd629$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $e229cb5c8b2cd629$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$e229cb5c8b2cd629$var$internalInstanceKey] = finishedWork;
                                $e229cb5c8b2cd629$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $e229cb5c8b2cd629$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $e229cb5c8b2cd629$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $e229cb5c8b2cd629$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $e229cb5c8b2cd629$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $e229cb5c8b2cd629$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $e229cb5c8b2cd629$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $e229cb5c8b2cd629$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $e229cb5c8b2cd629$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($e229cb5c8b2cd629$var$needsFormReset = !0);
            break;
        case 6:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $e229cb5c8b2cd629$var$tagCaches = null;
            hoistableRoot = $e229cb5c8b2cd629$var$currentHoistableRoot;
            $e229cb5c8b2cd629$var$currentHoistableRoot = $e229cb5c8b2cd629$var$getHoistableRoot(root.containerInfo);
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$currentHoistableRoot = hoistableRoot;
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $e229cb5c8b2cd629$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $e229cb5c8b2cd629$var$needsFormReset && ($e229cb5c8b2cd629$var$needsFormReset = !1, $e229cb5c8b2cd629$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $e229cb5c8b2cd629$var$currentHoistableRoot;
            $e229cb5c8b2cd629$var$currentHoistableRoot = $e229cb5c8b2cd629$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            $e229cb5c8b2cd629$var$currentHoistableRoot = flags;
            break;
        case 12:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($e229cb5c8b2cd629$var$globalMostRecentFallbackTime = $e229cb5c8b2cd629$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden;
            $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden || $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $e229cb5c8b2cd629$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $e229cb5c8b2cd629$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $e229cb5c8b2cd629$var$hideOrUnhideDehydratedBoundary(instance, !0) : $e229cb5c8b2cd629$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $e229cb5c8b2cd629$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork), $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
    }
}
function $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($e229cb5c8b2cd629$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $e229cb5c8b2cd629$var$getHostSibling(finishedWork);
                    $e229cb5c8b2cd629$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($e229cb5c8b2cd629$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $e229cb5c8b2cd629$var$getHostSibling(finishedWork);
                    $e229cb5c8b2cd629$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $e229cb5c8b2cd629$var$getHostSibling(finishedWork);
                    $e229cb5c8b2cd629$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $e229cb5c8b2cd629$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $e229cb5c8b2cd629$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $e229cb5c8b2cd629$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $e229cb5c8b2cd629$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $e229cb5c8b2cd629$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $e229cb5c8b2cd629$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $e229cb5c8b2cd629$var$safelyDetachRef(finishedWork, finishedWork.return);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $e229cb5c8b2cd629$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$e229cb5c8b2cd629$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $e229cb5c8b2cd629$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $e229cb5c8b2cd629$var$commitClassCallbacks(finishedWork);
                $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $e229cb5c8b2cd629$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $e229cb5c8b2cd629$var$commitHostMount(finishedWork);
                $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $e229cb5c8b2cd629$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $e229cb5c8b2cd629$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $e229cb5c8b2cd629$var$releaseCache(previousCache));
}
function $e229cb5c8b2cd629$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $e229cb5c8b2cd629$var$releaseCache(current));
}
function $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $e229cb5c8b2cd629$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $e229cb5c8b2cd629$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $e229cb5c8b2cd629$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $e229cb5c8b2cd629$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $e229cb5c8b2cd629$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $e229cb5c8b2cd629$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $e229cb5c8b2cd629$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $e229cb5c8b2cd629$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $e229cb5c8b2cd629$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $e229cb5c8b2cd629$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $e229cb5c8b2cd629$var$suspenseyCommitFlag = 8192;
function $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $e229cb5c8b2cd629$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $e229cb5c8b2cd629$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $e229cb5c8b2cd629$var$suspenseyCommitFlag && null !== fiber.memoizedState && $e229cb5c8b2cd629$var$suspendResource(suspendedState, $e229cb5c8b2cd629$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $e229cb5c8b2cd629$var$currentHoistableRoot;
            $e229cb5c8b2cd629$var$currentHoistableRoot = $e229cb5c8b2cd629$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $e229cb5c8b2cd629$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $e229cb5c8b2cd629$var$suspenseyCommitFlag, $e229cb5c8b2cd629$var$suspenseyCommitFlag = 16777216, $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $e229cb5c8b2cd629$var$suspenseyCommitFlag = previousHoistableRoot) : $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $e229cb5c8b2cd629$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $e229cb5c8b2cd629$var$nextEffect = childToDelete;
            $e229cb5c8b2cd629$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $e229cb5c8b2cd629$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $e229cb5c8b2cd629$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $e229cb5c8b2cd629$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $e229cb5c8b2cd629$var$nextEffect = childToDelete;
            $e229cb5c8b2cd629$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $e229cb5c8b2cd629$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $e229cb5c8b2cd629$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $e229cb5c8b2cd629$var$nextEffect;){
        var fiber = $e229cb5c8b2cd629$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $e229cb5c8b2cd629$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $e229cb5c8b2cd629$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $e229cb5c8b2cd629$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $e229cb5c8b2cd629$var$nextEffect;){
            cache = $e229cb5c8b2cd629$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $e229cb5c8b2cd629$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $e229cb5c8b2cd629$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $e229cb5c8b2cd629$var$nextEffect = sibling;
                break a;
            }
            $e229cb5c8b2cd629$var$nextEffect = returnFiber;
        }
    }
}
var $e229cb5c8b2cd629$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $e229cb5c8b2cd629$var$readContext($e229cb5c8b2cd629$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $e229cb5c8b2cd629$var$readContext($e229cb5c8b2cd629$var$CacheContext).controller.signal;
    }
}, $e229cb5c8b2cd629$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $e229cb5c8b2cd629$var$executionContext = 0, $e229cb5c8b2cd629$var$workInProgressRoot = null, $e229cb5c8b2cd629$var$workInProgress = null, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = 0, $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0, $e229cb5c8b2cd629$var$workInProgressThrownValue = null, $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings = !1, $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering = !1, $e229cb5c8b2cd629$var$workInProgressRootDidAttachPingListener = !1, $e229cb5c8b2cd629$var$entangledRenderLanes = 0, $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 0, $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes = 0, $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes = 0, $e229cb5c8b2cd629$var$workInProgressRootPingedLanes = 0, $e229cb5c8b2cd629$var$workInProgressDeferredLane = 0, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes = 0, $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors = null, $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = null, $e229cb5c8b2cd629$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $e229cb5c8b2cd629$var$globalMostRecentFallbackTime = 0, $e229cb5c8b2cd629$var$globalMostRecentTransitionTime = 0, $e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime = Infinity, $e229cb5c8b2cd629$var$workInProgressTransitions = null, $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed = null, $e229cb5c8b2cd629$var$pendingEffectsStatus = 0, $e229cb5c8b2cd629$var$pendingEffectsRoot = null, $e229cb5c8b2cd629$var$pendingFinishedWork = null, $e229cb5c8b2cd629$var$pendingEffectsLanes = 0, $e229cb5c8b2cd629$var$pendingEffectsRemainingLanes = 0, $e229cb5c8b2cd629$var$pendingPassiveTransitions = null, $e229cb5c8b2cd629$var$pendingRecoverableErrors = null, $e229cb5c8b2cd629$var$nestedUpdateCount = 0, $e229cb5c8b2cd629$var$rootWithNestedUpdates = null;
function $e229cb5c8b2cd629$var$requestUpdateLane() {
    return 0 !== ($e229cb5c8b2cd629$var$executionContext & 2) && 0 !== $e229cb5c8b2cd629$var$workInProgressRootRenderLanes ? $e229cb5c8b2cd629$var$workInProgressRootRenderLanes & -$e229cb5c8b2cd629$var$workInProgressRootRenderLanes : null !== $e229cb5c8b2cd629$var$ReactSharedInternals.T ? $e229cb5c8b2cd629$var$requestTransitionLane() : $e229cb5c8b2cd629$var$resolveUpdatePriority();
}
function $e229cb5c8b2cd629$var$requestDeferredLane() {
    if (0 === $e229cb5c8b2cd629$var$workInProgressDeferredLane) {
        if (0 === ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 536870912) || $e229cb5c8b2cd629$var$isHydrating) {
            var lane = $e229cb5c8b2cd629$var$nextTransitionDeferredLane;
            $e229cb5c8b2cd629$var$nextTransitionDeferredLane <<= 1;
            0 === ($e229cb5c8b2cd629$var$nextTransitionDeferredLane & 3932160) && ($e229cb5c8b2cd629$var$nextTransitionDeferredLane = 262144);
            $e229cb5c8b2cd629$var$workInProgressDeferredLane = lane;
        } else $e229cb5c8b2cd629$var$workInProgressDeferredLane = 536870912;
    }
    lane = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $e229cb5c8b2cd629$var$workInProgressDeferredLane;
}
function $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $e229cb5c8b2cd629$var$workInProgressRoot && (2 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason || 9 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $e229cb5c8b2cd629$var$prepareFreshStack(root, 0), $e229cb5c8b2cd629$var$markRootSuspended(root, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !1);
    $e229cb5c8b2cd629$var$markRootUpdated$1(root, lane);
    if (0 === ($e229cb5c8b2cd629$var$executionContext & 2) || root !== $e229cb5c8b2cd629$var$workInProgressRoot) root === $e229cb5c8b2cd629$var$workInProgressRoot && (0 === ($e229cb5c8b2cd629$var$executionContext & 2) && ($e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus && $e229cb5c8b2cd629$var$markRootSuspended(root, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !1)), $e229cb5c8b2cd629$var$ensureRootIsScheduled(root);
}
function $e229cb5c8b2cd629$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($e229cb5c8b2cd629$var$executionContext & 6)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $e229cb5c8b2cd629$var$renderRootConcurrent(root$jscomp$0, lanes) : $e229cb5c8b2cd629$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $e229cb5c8b2cd629$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$e229cb5c8b2cd629$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $e229cb5c8b2cd629$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($e229cb5c8b2cd629$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $e229cb5c8b2cd629$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($e229cb5c8b2cd629$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors;
                            $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors ? $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors.push.apply($e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $e229cb5c8b2cd629$var$prepareFreshStack(root$jscomp$0, 0);
                $e229cb5c8b2cd629$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $e229cb5c8b2cd629$var$markRootSuspended(shouldTimeSlice, lanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !$e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $e229cb5c8b2cd629$var$globalMostRecentFallbackTime + 300 - $e229cb5c8b2cd629$var$now(), 10 < exitStatus)) {
                    $e229cb5c8b2cd629$var$markRootSuspended(shouldTimeSlice, lanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !$e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $e229cb5c8b2cd629$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $e229cb5c8b2cd629$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $e229cb5c8b2cd629$var$scheduleTimeout($e229cb5c8b2cd629$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors, $e229cb5c8b2cd629$var$workInProgressTransitions, $e229cb5c8b2cd629$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes, $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $e229cb5c8b2cd629$var$commitRootWhenReady(shouldTimeSlice, forceSync, $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors, $e229cb5c8b2cd629$var$workInProgressTransitions, $e229cb5c8b2cd629$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes, $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $e229cb5c8b2cd629$var$ensureRootIsScheduled(root$jscomp$0);
}
function $e229cb5c8b2cd629$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $e229cb5c8b2cd629$var$noop$1
        };
        $e229cb5c8b2cd629$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $e229cb5c8b2cd629$var$globalMostRecentFallbackTime - $e229cb5c8b2cd629$var$now() : (lanes & 4194048) === lanes ? $e229cb5c8b2cd629$var$globalMostRecentTransitionTime - $e229cb5c8b2cd629$var$now() : 0;
        timeoutOffset = $e229cb5c8b2cd629$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $e229cb5c8b2cd629$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($e229cb5c8b2cd629$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $e229cb5c8b2cd629$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $e229cb5c8b2cd629$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $e229cb5c8b2cd629$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$e229cb5c8b2cd629$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $e229cb5c8b2cd629$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$e229cb5c8b2cd629$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $e229cb5c8b2cd629$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $e229cb5c8b2cd629$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $e229cb5c8b2cd629$var$flushSyncWork$1() {
    return 0 === ($e229cb5c8b2cd629$var$executionContext & 6) ? ($e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $e229cb5c8b2cd629$var$resetWorkInProgressStack() {
    if (null !== $e229cb5c8b2cd629$var$workInProgress) {
        if (0 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason) var interruptedWork = $e229cb5c8b2cd629$var$workInProgress.return;
        else interruptedWork = $e229cb5c8b2cd629$var$workInProgress, $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null, $e229cb5c8b2cd629$var$resetHooksOnUnwind(interruptedWork), $e229cb5c8b2cd629$var$thenableState$1 = null, $e229cb5c8b2cd629$var$thenableIndexCounter$1 = 0, interruptedWork = $e229cb5c8b2cd629$var$workInProgress;
        for(; null !== interruptedWork;)$e229cb5c8b2cd629$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $e229cb5c8b2cd629$var$workInProgress = null;
    }
}
function $e229cb5c8b2cd629$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $e229cb5c8b2cd629$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $e229cb5c8b2cd629$var$pendingEffectsLanes = 0;
    $e229cb5c8b2cd629$var$resetWorkInProgressStack();
    $e229cb5c8b2cd629$var$workInProgressRoot = root;
    $e229cb5c8b2cd629$var$workInProgress = timeoutHandle = $e229cb5c8b2cd629$var$createWorkInProgress(root.current, null);
    $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = lanes;
    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
    $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering = $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root, lanes);
    $e229cb5c8b2cd629$var$workInProgressRootDidAttachPingListener = !1;
    $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes = $e229cb5c8b2cd629$var$workInProgressDeferredLane = $e229cb5c8b2cd629$var$workInProgressRootPingedLanes = $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes = $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes = $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 0;
    $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors = null;
    $e229cb5c8b2cd629$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $e229cb5c8b2cd629$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $e229cb5c8b2cd629$var$entangledRenderLanes = lanes;
    $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $e229cb5c8b2cd629$var$handleThrow(root, thrownValue) {
    $e229cb5c8b2cd629$var$currentlyRenderingFiber = null;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = $e229cb5c8b2cd629$var$ContextOnlyDispatcher;
    thrownValue === $e229cb5c8b2cd629$var$SuspenseException || thrownValue === $e229cb5c8b2cd629$var$SuspenseActionException ? (thrownValue = $e229cb5c8b2cd629$var$getSuspendedThenable(), $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 3) : thrownValue === $e229cb5c8b2cd629$var$SuspenseyCommitException ? (thrownValue = $e229cb5c8b2cd629$var$getSuspendedThenable(), $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 4) : $e229cb5c8b2cd629$var$workInProgressSuspendedReason = thrownValue === $e229cb5c8b2cd629$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $e229cb5c8b2cd629$var$workInProgressThrownValue = thrownValue;
    null === $e229cb5c8b2cd629$var$workInProgress && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 1, $e229cb5c8b2cd629$var$logUncaughtError(root, $e229cb5c8b2cd629$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $e229cb5c8b2cd629$var$shouldRemainOnPreviousScreen() {
    var handler = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 4194048) === $e229cb5c8b2cd629$var$workInProgressRootRenderLanes ? null === $e229cb5c8b2cd629$var$shellBoundary ? !0 : !1 : ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 62914560) === $e229cb5c8b2cd629$var$workInProgressRootRenderLanes || 0 !== ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 536870912) ? handler === $e229cb5c8b2cd629$var$shellBoundary : !1;
}
function $e229cb5c8b2cd629$var$pushDispatcher() {
    var prevDispatcher = $e229cb5c8b2cd629$var$ReactSharedInternals.H;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = $e229cb5c8b2cd629$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $e229cb5c8b2cd629$var$ContextOnlyDispatcher : prevDispatcher;
}
function $e229cb5c8b2cd629$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $e229cb5c8b2cd629$var$ReactSharedInternals.A;
    $e229cb5c8b2cd629$var$ReactSharedInternals.A = $e229cb5c8b2cd629$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible() {
    $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 4;
    $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings || ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 4194048) !== $e229cb5c8b2cd629$var$workInProgressRootRenderLanes && null !== $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current || ($e229cb5c8b2cd629$var$workInProgressRootIsPrerendering = !0);
    0 === ($e229cb5c8b2cd629$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $e229cb5c8b2cd629$var$workInProgressRoot || $e229cb5c8b2cd629$var$markRootSuspended($e229cb5c8b2cd629$var$workInProgressRoot, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !1);
}
function $e229cb5c8b2cd629$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
    $e229cb5c8b2cd629$var$executionContext |= 2;
    var prevDispatcher = $e229cb5c8b2cd629$var$pushDispatcher(), prevAsyncDispatcher = $e229cb5c8b2cd629$var$pushAsyncDispatcher();
    if ($e229cb5c8b2cd629$var$workInProgressRoot !== root || $e229cb5c8b2cd629$var$workInProgressRootRenderLanes !== lanes) $e229cb5c8b2cd629$var$workInProgressTransitions = null, $e229cb5c8b2cd629$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $e229cb5c8b2cd629$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $e229cb5c8b2cd629$var$workInProgressSuspendedReason && null !== $e229cb5c8b2cd629$var$workInProgress) {
            var unitOfWork = $e229cb5c8b2cd629$var$workInProgress, thrownValue = $e229cb5c8b2cd629$var$workInProgressThrownValue;
            switch($e229cb5c8b2cd629$var$workInProgressSuspendedReason){
                case 8:
                    $e229cb5c8b2cd629$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $e229cb5c8b2cd629$var$workInProgressSuspendedReason;
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                    $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $e229cb5c8b2cd629$var$workInProgressSuspendedReason, $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0, $e229cb5c8b2cd629$var$workInProgressThrownValue = null, $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $e229cb5c8b2cd629$var$workLoopSync();
        exitStatus = $e229cb5c8b2cd629$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $e229cb5c8b2cd629$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null;
    $e229cb5c8b2cd629$var$executionContext = prevExecutionContext;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = prevDispatcher;
    $e229cb5c8b2cd629$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $e229cb5c8b2cd629$var$workInProgress && ($e229cb5c8b2cd629$var$workInProgressRoot = null, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = 0, $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $e229cb5c8b2cd629$var$workLoopSync() {
    for(; null !== $e229cb5c8b2cd629$var$workInProgress;)$e229cb5c8b2cd629$var$performUnitOfWork($e229cb5c8b2cd629$var$workInProgress);
}
function $e229cb5c8b2cd629$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
    $e229cb5c8b2cd629$var$executionContext |= 2;
    var prevDispatcher = $e229cb5c8b2cd629$var$pushDispatcher(), prevAsyncDispatcher = $e229cb5c8b2cd629$var$pushAsyncDispatcher();
    $e229cb5c8b2cd629$var$workInProgressRoot !== root || $e229cb5c8b2cd629$var$workInProgressRootRenderLanes !== lanes ? ($e229cb5c8b2cd629$var$workInProgressTransitions = null, $e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime = $e229cb5c8b2cd629$var$now() + 500, $e229cb5c8b2cd629$var$prepareFreshStack(root, lanes)) : $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering = $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $e229cb5c8b2cd629$var$workInProgressSuspendedReason && null !== $e229cb5c8b2cd629$var$workInProgress) {
            lanes = $e229cb5c8b2cd629$var$workInProgress;
            var thrownValue = $e229cb5c8b2cd629$var$workInProgressThrownValue;
            b: switch($e229cb5c8b2cd629$var$workInProgressSuspendedReason){
                case 1:
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                    $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($e229cb5c8b2cd629$var$isThenableResolved(thrownValue)) {
                        $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                        $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                        $e229cb5c8b2cd629$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $e229cb5c8b2cd629$var$workInProgressSuspendedReason && 9 !== $e229cb5c8b2cd629$var$workInProgressSuspendedReason || $e229cb5c8b2cd629$var$workInProgressRoot !== root || ($e229cb5c8b2cd629$var$workInProgressSuspendedReason = 7);
                        $e229cb5c8b2cd629$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $e229cb5c8b2cd629$var$isThenableResolved(thrownValue) ? ($e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0, $e229cb5c8b2cd629$var$workInProgressThrownValue = null, $e229cb5c8b2cd629$var$replaySuspendedUnitOfWork(lanes)) : ($e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0, $e229cb5c8b2cd629$var$workInProgressThrownValue = null, $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($e229cb5c8b2cd629$var$workInProgress.tag){
                        case 26:
                            resource = $e229cb5c8b2cd629$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $e229cb5c8b2cd629$var$workInProgress;
                            if (resource ? $e229cb5c8b2cd629$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                                $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $e229cb5c8b2cd629$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($e229cb5c8b2cd629$var$workInProgress = returnFiber, $e229cb5c8b2cd629$var$completeUnitOfWork(returnFiber)) : $e229cb5c8b2cd629$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                    $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                    $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $e229cb5c8b2cd629$var$resetWorkInProgressStack();
                    $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(462));
            }
        }
        $e229cb5c8b2cd629$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $e229cb5c8b2cd629$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = prevDispatcher;
    $e229cb5c8b2cd629$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $e229cb5c8b2cd629$var$executionContext = prevExecutionContext;
    if (null !== $e229cb5c8b2cd629$var$workInProgress) return 0;
    $e229cb5c8b2cd629$var$workInProgressRoot = null;
    $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = 0;
    $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates();
    return $e229cb5c8b2cd629$var$workInProgressRootExitStatus;
}
function $e229cb5c8b2cd629$var$workLoopConcurrentByScheduler() {
    for(; null !== $e229cb5c8b2cd629$var$workInProgress && !$e229cb5c8b2cd629$var$shouldYield();)$e229cb5c8b2cd629$var$performUnitOfWork($e229cb5c8b2cd629$var$workInProgress);
}
function $e229cb5c8b2cd629$var$performUnitOfWork(unitOfWork) {
    var next = $e229cb5c8b2cd629$var$beginWork(unitOfWork.alternate, unitOfWork, $e229cb5c8b2cd629$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $e229cb5c8b2cd629$var$completeUnitOfWork(unitOfWork) : $e229cb5c8b2cd629$var$workInProgress = next;
}
function $e229cb5c8b2cd629$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $e229cb5c8b2cd629$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $e229cb5c8b2cd629$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $e229cb5c8b2cd629$var$resetHooksOnUnwind(next);
        default:
            $e229cb5c8b2cd629$var$unwindInterruptedWork(current, next), next = $e229cb5c8b2cd629$var$workInProgress = $e229cb5c8b2cd629$var$resetWorkInProgress(next, $e229cb5c8b2cd629$var$entangledRenderLanes), next = $e229cb5c8b2cd629$var$beginWork(current, next, $e229cb5c8b2cd629$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $e229cb5c8b2cd629$var$completeUnitOfWork(unitOfWork) : $e229cb5c8b2cd629$var$workInProgress = next;
}
function $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null;
    $e229cb5c8b2cd629$var$resetHooksOnUnwind(unitOfWork);
    $e229cb5c8b2cd629$var$thenableState$1 = null;
    $e229cb5c8b2cd629$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($e229cb5c8b2cd629$var$throwException(root, returnFiber, unitOfWork, thrownValue, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes)) {
            $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 1;
            $e229cb5c8b2cd629$var$logUncaughtError(root, $e229cb5c8b2cd629$var$createCapturedValueAtFiber(thrownValue, root.current));
            $e229cb5c8b2cd629$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $e229cb5c8b2cd629$var$workInProgress = returnFiber, error;
        $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 1;
        $e229cb5c8b2cd629$var$logUncaughtError(root, $e229cb5c8b2cd629$var$createCapturedValueAtFiber(thrownValue, root.current));
        $e229cb5c8b2cd629$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($e229cb5c8b2cd629$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($e229cb5c8b2cd629$var$workInProgressRootIsPrerendering || 0 !== ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $e229cb5c8b2cd629$var$unwindUnitOfWork(unitOfWork, root);
    } else $e229cb5c8b2cd629$var$completeUnitOfWork(unitOfWork);
}
function $e229cb5c8b2cd629$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $e229cb5c8b2cd629$var$unwindUnitOfWork(completedWork, $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $e229cb5c8b2cd629$var$completeWork(completedWork.alternate, completedWork, $e229cb5c8b2cd629$var$entangledRenderLanes);
        if (null !== next) {
            $e229cb5c8b2cd629$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $e229cb5c8b2cd629$var$workInProgress = completedWork;
            return;
        }
        $e229cb5c8b2cd629$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 5);
}
function $e229cb5c8b2cd629$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $e229cb5c8b2cd629$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $e229cb5c8b2cd629$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $e229cb5c8b2cd629$var$workInProgress = unitOfWork;
            return;
        }
        $e229cb5c8b2cd629$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 6;
    $e229cb5c8b2cd629$var$workInProgress = null;
}
function $e229cb5c8b2cd629$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $e229cb5c8b2cd629$var$flushPendingEffects();
    while (0 !== $e229cb5c8b2cd629$var$pendingEffectsStatus);
    if (0 !== ($e229cb5c8b2cd629$var$executionContext & 6)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $e229cb5c8b2cd629$var$concurrentlyUpdatedLanes;
        $e229cb5c8b2cd629$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $e229cb5c8b2cd629$var$workInProgressRoot && ($e229cb5c8b2cd629$var$workInProgress = $e229cb5c8b2cd629$var$workInProgressRoot = null, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = 0);
        $e229cb5c8b2cd629$var$pendingFinishedWork = finishedWork;
        $e229cb5c8b2cd629$var$pendingEffectsRoot = root;
        $e229cb5c8b2cd629$var$pendingEffectsLanes = lanes;
        $e229cb5c8b2cd629$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $e229cb5c8b2cd629$var$pendingPassiveTransitions = transitions;
        $e229cb5c8b2cd629$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $e229cb5c8b2cd629$var$scheduleCallback$1($e229cb5c8b2cd629$var$NormalPriority$1, function() {
            $e229cb5c8b2cd629$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
            $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
            transitions = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
            $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $e229cb5c8b2cd629$var$executionContext;
            $e229cb5c8b2cd629$var$executionContext |= 4;
            try {
                $e229cb5c8b2cd629$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $e229cb5c8b2cd629$var$executionContext = spawnedLane, $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = transitions, $e229cb5c8b2cd629$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 1;
        $e229cb5c8b2cd629$var$flushMutationEffects();
        $e229cb5c8b2cd629$var$flushLayoutEffects();
        $e229cb5c8b2cd629$var$flushSpawnedWork();
    }
}
function $e229cb5c8b2cd629$var$flushMutationEffects() {
    if (1 === $e229cb5c8b2cd629$var$pendingEffectsStatus) {
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 0;
        var root = $e229cb5c8b2cd629$var$pendingEffectsRoot, finishedWork = $e229cb5c8b2cd629$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
            $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
            var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
            $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
            $e229cb5c8b2cd629$var$executionContext |= 4;
            try {
                $e229cb5c8b2cd629$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $e229cb5c8b2cd629$var$selectionInformation, curFocusedElem = $e229cb5c8b2cd629$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $e229cb5c8b2cd629$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $e229cb5c8b2cd629$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $e229cb5c8b2cd629$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $e229cb5c8b2cd629$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $e229cb5c8b2cd629$var$_enabled = !!$e229cb5c8b2cd629$var$eventsEnabled;
                $e229cb5c8b2cd629$var$selectionInformation = $e229cb5c8b2cd629$var$eventsEnabled = null;
            } finally{
                $e229cb5c8b2cd629$var$executionContext = prevExecutionContext, $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 2;
    }
}
function $e229cb5c8b2cd629$var$flushLayoutEffects() {
    if (2 === $e229cb5c8b2cd629$var$pendingEffectsStatus) {
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 0;
        var root = $e229cb5c8b2cd629$var$pendingEffectsRoot, finishedWork = $e229cb5c8b2cd629$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
            $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
            var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
            $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
            $e229cb5c8b2cd629$var$executionContext |= 4;
            try {
                $e229cb5c8b2cd629$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $e229cb5c8b2cd629$var$executionContext = prevExecutionContext, $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 3;
    }
}
function $e229cb5c8b2cd629$var$flushSpawnedWork() {
    if (4 === $e229cb5c8b2cd629$var$pendingEffectsStatus || 3 === $e229cb5c8b2cd629$var$pendingEffectsStatus) {
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 0;
        $e229cb5c8b2cd629$var$requestPaint();
        var root = $e229cb5c8b2cd629$var$pendingEffectsRoot, finishedWork = $e229cb5c8b2cd629$var$pendingFinishedWork, lanes = $e229cb5c8b2cd629$var$pendingEffectsLanes, recoverableErrors = $e229cb5c8b2cd629$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $e229cb5c8b2cd629$var$pendingEffectsStatus = 5 : ($e229cb5c8b2cd629$var$pendingEffectsStatus = 0, $e229cb5c8b2cd629$var$pendingFinishedWork = $e229cb5c8b2cd629$var$pendingEffectsRoot = null, $e229cb5c8b2cd629$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $e229cb5c8b2cd629$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($e229cb5c8b2cd629$var$injectedHook && "function" === typeof $e229cb5c8b2cd629$var$injectedHook.onCommitFiberRoot) try {
            $e229cb5c8b2cd629$var$injectedHook.onCommitFiberRoot($e229cb5c8b2cd629$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
            remainingLanes = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
            $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2;
            $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $e229cb5c8b2cd629$var$ReactSharedInternals.T = finishedWork, $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($e229cb5c8b2cd629$var$pendingEffectsLanes & 3) && $e229cb5c8b2cd629$var$flushPendingEffects();
        $e229cb5c8b2cd629$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $e229cb5c8b2cd629$var$rootWithNestedUpdates ? $e229cb5c8b2cd629$var$nestedUpdateCount++ : ($e229cb5c8b2cd629$var$nestedUpdateCount = 0, $e229cb5c8b2cd629$var$rootWithNestedUpdates = root) : $e229cb5c8b2cd629$var$nestedUpdateCount = 0;
        $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $e229cb5c8b2cd629$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $e229cb5c8b2cd629$var$releaseCache(remainingLanes)));
}
function $e229cb5c8b2cd629$var$flushPendingEffects() {
    $e229cb5c8b2cd629$var$flushMutationEffects();
    $e229cb5c8b2cd629$var$flushLayoutEffects();
    $e229cb5c8b2cd629$var$flushSpawnedWork();
    return $e229cb5c8b2cd629$var$flushPassiveEffects();
}
function $e229cb5c8b2cd629$var$flushPassiveEffects() {
    if (5 !== $e229cb5c8b2cd629$var$pendingEffectsStatus) return !1;
    var root = $e229cb5c8b2cd629$var$pendingEffectsRoot, remainingLanes = $e229cb5c8b2cd629$var$pendingEffectsRemainingLanes;
    $e229cb5c8b2cd629$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $e229cb5c8b2cd629$var$lanesToEventPriority($e229cb5c8b2cd629$var$pendingEffectsLanes), prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T, previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    try {
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
        renderPriority = $e229cb5c8b2cd629$var$pendingPassiveTransitions;
        $e229cb5c8b2cd629$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $e229cb5c8b2cd629$var$pendingEffectsRoot, lanes = $e229cb5c8b2cd629$var$pendingEffectsLanes;
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 0;
        $e229cb5c8b2cd629$var$pendingFinishedWork = $e229cb5c8b2cd629$var$pendingEffectsRoot = null;
        $e229cb5c8b2cd629$var$pendingEffectsLanes = 0;
        if (0 !== ($e229cb5c8b2cd629$var$executionContext & 6)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(331));
        var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
        $e229cb5c8b2cd629$var$executionContext |= 4;
        $e229cb5c8b2cd629$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $e229cb5c8b2cd629$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $e229cb5c8b2cd629$var$executionContext = prevExecutionContext;
        $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($e229cb5c8b2cd629$var$injectedHook && "function" === typeof $e229cb5c8b2cd629$var$injectedHook.onPostCommitFiberRoot) try {
            $e229cb5c8b2cd629$var$injectedHook.onPostCommitFiberRoot($e229cb5c8b2cd629$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition, $e229cb5c8b2cd629$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $e229cb5c8b2cd629$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $e229cb5c8b2cd629$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $e229cb5c8b2cd629$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($e229cb5c8b2cd629$var$markRootUpdated$1(rootFiber, 2), $e229cb5c8b2cd629$var$ensureRootIsScheduled(rootFiber));
}
function $e229cb5c8b2cd629$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $e229cb5c8b2cd629$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $e229cb5c8b2cd629$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed || !$e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $e229cb5c8b2cd629$var$createClassErrorUpdate(2);
                instance = $e229cb5c8b2cd629$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($e229cb5c8b2cd629$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $e229cb5c8b2cd629$var$markRootUpdated$1(instance, 2), $e229cb5c8b2cd629$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $e229cb5c8b2cd629$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $e229cb5c8b2cd629$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($e229cb5c8b2cd629$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $e229cb5c8b2cd629$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $e229cb5c8b2cd629$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $e229cb5c8b2cd629$var$workInProgressRoot === root && ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus || 3 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 62914560) === $e229cb5c8b2cd629$var$workInProgressRootRenderLanes && 300 > $e229cb5c8b2cd629$var$now() - $e229cb5c8b2cd629$var$globalMostRecentFallbackTime ? 0 === ($e229cb5c8b2cd629$var$executionContext & 2) && $e229cb5c8b2cd629$var$prepareFreshStack(root, 0) : $e229cb5c8b2cd629$var$workInProgressRootPingedLanes |= pingedLanes, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes === $e229cb5c8b2cd629$var$workInProgressRootRenderLanes && ($e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes = 0));
    $e229cb5c8b2cd629$var$ensureRootIsScheduled(root);
}
function $e229cb5c8b2cd629$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $e229cb5c8b2cd629$var$claimNextRetryLane());
    boundaryFiber = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($e229cb5c8b2cd629$var$markRootUpdated$1(boundaryFiber, retryLane), $e229cb5c8b2cd629$var$ensureRootIsScheduled(boundaryFiber));
}
function $e229cb5c8b2cd629$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $e229cb5c8b2cd629$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $e229cb5c8b2cd629$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $e229cb5c8b2cd629$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $e229cb5c8b2cd629$var$scheduleCallback$1(priorityLevel, callback) {
    return $e229cb5c8b2cd629$var$scheduleCallback$3(priorityLevel, callback);
}
var $e229cb5c8b2cd629$var$firstScheduledRoot = null, $e229cb5c8b2cd629$var$lastScheduledRoot = null, $e229cb5c8b2cd629$var$didScheduleMicrotask = !1, $e229cb5c8b2cd629$var$mightHavePendingSyncWork = !1, $e229cb5c8b2cd629$var$isFlushingWork = !1, $e229cb5c8b2cd629$var$currentEventTransitionLane = 0;
function $e229cb5c8b2cd629$var$ensureRootIsScheduled(root) {
    root !== $e229cb5c8b2cd629$var$lastScheduledRoot && null === root.next && (null === $e229cb5c8b2cd629$var$lastScheduledRoot ? $e229cb5c8b2cd629$var$firstScheduledRoot = $e229cb5c8b2cd629$var$lastScheduledRoot = root : $e229cb5c8b2cd629$var$lastScheduledRoot = $e229cb5c8b2cd629$var$lastScheduledRoot.next = root);
    $e229cb5c8b2cd629$var$mightHavePendingSyncWork = !0;
    $e229cb5c8b2cd629$var$didScheduleMicrotask || ($e229cb5c8b2cd629$var$didScheduleMicrotask = !0, $e229cb5c8b2cd629$var$scheduleImmediateRootScheduleTask());
}
function $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$e229cb5c8b2cd629$var$isFlushingWork && $e229cb5c8b2cd629$var$mightHavePendingSyncWork) {
        $e229cb5c8b2cd629$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $e229cb5c8b2cd629$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $e229cb5c8b2cd629$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $e229cb5c8b2cd629$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $e229cb5c8b2cd629$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $e229cb5c8b2cd629$var$getNextLanes(root$170, root$170 === $e229cb5c8b2cd629$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $e229cb5c8b2cd629$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $e229cb5c8b2cd629$var$isFlushingWork = !1;
    }
}
function $e229cb5c8b2cd629$var$processRootScheduleInImmediateTask() {
    $e229cb5c8b2cd629$var$processRootScheduleInMicrotask();
}
function $e229cb5c8b2cd629$var$processRootScheduleInMicrotask() {
    $e229cb5c8b2cd629$var$mightHavePendingSyncWork = $e229cb5c8b2cd629$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $e229cb5c8b2cd629$var$currentEventTransitionLane && $e229cb5c8b2cd629$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $e229cb5c8b2cd629$var$currentEventTransitionLane);
    for(var currentTime = $e229cb5c8b2cd629$var$now(), prev = null, root = $e229cb5c8b2cd629$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $e229cb5c8b2cd629$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $e229cb5c8b2cd629$var$firstScheduledRoot = next : prev.next = next, null === next && ($e229cb5c8b2cd629$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $e229cb5c8b2cd629$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $e229cb5c8b2cd629$var$pendingEffectsStatus && 5 !== $e229cb5c8b2cd629$var$pendingEffectsStatus || $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $e229cb5c8b2cd629$var$currentEventTransitionLane && ($e229cb5c8b2cd629$var$currentEventTransitionLane = 0);
}
function $e229cb5c8b2cd629$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $e229cb5c8b2cd629$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $e229cb5c8b2cd629$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $e229cb5c8b2cd629$var$workInProgressRoot;
    suspendedLanes = $e229cb5c8b2cd629$var$workInProgressRootRenderLanes;
    suspendedLanes = $e229cb5c8b2cd629$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason || 9 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $e229cb5c8b2cd629$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $e229cb5c8b2cd629$var$cancelCallback$1(pingedLanes);
        switch($e229cb5c8b2cd629$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $e229cb5c8b2cd629$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $e229cb5c8b2cd629$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $e229cb5c8b2cd629$var$IdlePriority;
                break;
            default:
                suspendedLanes = $e229cb5c8b2cd629$var$NormalPriority$1;
        }
        pingedLanes = $e229cb5c8b2cd629$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $e229cb5c8b2cd629$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $e229cb5c8b2cd629$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $e229cb5c8b2cd629$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $e229cb5c8b2cd629$var$pendingEffectsStatus && 5 !== $e229cb5c8b2cd629$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($e229cb5c8b2cd629$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $e229cb5c8b2cd629$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $e229cb5c8b2cd629$var$getNextLanes(root, root === $e229cb5c8b2cd629$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $e229cb5c8b2cd629$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $e229cb5c8b2cd629$var$scheduleTaskForRootDuringMicrotask(root, $e229cb5c8b2cd629$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $e229cb5c8b2cd629$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $e229cb5c8b2cd629$var$performSyncWorkOnRoot(root, lanes) {
    if ($e229cb5c8b2cd629$var$flushPendingEffects()) return null;
    $e229cb5c8b2cd629$var$performWorkOnRoot(root, lanes, !0);
}
function $e229cb5c8b2cd629$var$scheduleImmediateRootScheduleTask() {
    $e229cb5c8b2cd629$var$scheduleMicrotask(function() {
        0 !== ($e229cb5c8b2cd629$var$executionContext & 6) ? $e229cb5c8b2cd629$var$scheduleCallback$3($e229cb5c8b2cd629$var$ImmediatePriority, $e229cb5c8b2cd629$var$processRootScheduleInImmediateTask) : $e229cb5c8b2cd629$var$processRootScheduleInMicrotask();
    });
}
function $e229cb5c8b2cd629$var$requestTransitionLane() {
    if (0 === $e229cb5c8b2cd629$var$currentEventTransitionLane) {
        var actionScopeLane = $e229cb5c8b2cd629$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $e229cb5c8b2cd629$var$nextTransitionUpdateLane, $e229cb5c8b2cd629$var$nextTransitionUpdateLane <<= 1, 0 === ($e229cb5c8b2cd629$var$nextTransitionUpdateLane & 261888) && ($e229cb5c8b2cd629$var$nextTransitionUpdateLane = 256));
        $e229cb5c8b2cd629$var$currentEventTransitionLane = actionScopeLane;
    }
    return $e229cb5c8b2cd629$var$currentEventTransitionLane;
}
function $e229cb5c8b2cd629$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $e229cb5c8b2cd629$var$sanitizeURL("" + actionProp);
}
function $e229cb5c8b2cd629$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $e229cb5c8b2cd629$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $e229cb5c8b2cd629$var$coerceFormActionProp((nativeEventTarget[$e229cb5c8b2cd629$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$e229cb5c8b2cd629$var$internalPropsKey] || null) ? $e229cb5c8b2cd629$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $e229cb5c8b2cd629$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $e229cb5c8b2cd629$var$currentEventTransitionLane) {
                                var formData = submitter ? $e229cb5c8b2cd629$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $e229cb5c8b2cd629$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $e229cb5c8b2cd629$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $e229cb5c8b2cd629$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $e229cb5c8b2cd629$var$i$jscomp$inline_1577 = 0; $e229cb5c8b2cd629$var$i$jscomp$inline_1577 < $e229cb5c8b2cd629$var$simpleEventPluginEvents.length; $e229cb5c8b2cd629$var$i$jscomp$inline_1577++){
    var $e229cb5c8b2cd629$var$eventName$jscomp$inline_1578 = $e229cb5c8b2cd629$var$simpleEventPluginEvents[$e229cb5c8b2cd629$var$i$jscomp$inline_1577], $e229cb5c8b2cd629$var$domEventName$jscomp$inline_1579 = $e229cb5c8b2cd629$var$eventName$jscomp$inline_1578.toLowerCase(), $e229cb5c8b2cd629$var$capitalizedEvent$jscomp$inline_1580 = $e229cb5c8b2cd629$var$eventName$jscomp$inline_1578[0].toUpperCase() + $e229cb5c8b2cd629$var$eventName$jscomp$inline_1578.slice(1);
    $e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$domEventName$jscomp$inline_1579, "on" + $e229cb5c8b2cd629$var$capitalizedEvent$jscomp$inline_1580);
}
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$ANIMATION_END, "onAnimationEnd");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$ANIMATION_ITERATION, "onAnimationIteration");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$ANIMATION_START, "onAnimationStart");
$e229cb5c8b2cd629$var$registerSimpleEvent("dblclick", "onDoubleClick");
$e229cb5c8b2cd629$var$registerSimpleEvent("focusin", "onFocus");
$e229cb5c8b2cd629$var$registerSimpleEvent("focusout", "onBlur");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$TRANSITION_RUN, "onTransitionRun");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$TRANSITION_START, "onTransitionStart");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$TRANSITION_CANCEL, "onTransitionCancel");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$TRANSITION_END, "onTransitionEnd");
$e229cb5c8b2cd629$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e229cb5c8b2cd629$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e229cb5c8b2cd629$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e229cb5c8b2cd629$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e229cb5c8b2cd629$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e229cb5c8b2cd629$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($e229cb5c8b2cd629$var$mediaEventTypes));
function $e229cb5c8b2cd629$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $e229cb5c8b2cd629$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $e229cb5c8b2cd629$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $e229cb5c8b2cd629$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$e229cb5c8b2cd629$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$e229cb5c8b2cd629$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($e229cb5c8b2cd629$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $e229cb5c8b2cd629$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $e229cb5c8b2cd629$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $e229cb5c8b2cd629$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $e229cb5c8b2cd629$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$e229cb5c8b2cd629$var$listeningMarker]) {
        rootContainerElement[$e229cb5c8b2cd629$var$listeningMarker] = !0;
        $e229cb5c8b2cd629$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($e229cb5c8b2cd629$var$nonDelegatedEvents.has(domEventName) || $e229cb5c8b2cd629$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $e229cb5c8b2cd629$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$e229cb5c8b2cd629$var$listeningMarker] || (ownerDocument[$e229cb5c8b2cd629$var$listeningMarker] = !0, $e229cb5c8b2cd629$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $e229cb5c8b2cd629$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($e229cb5c8b2cd629$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $e229cb5c8b2cd629$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $e229cb5c8b2cd629$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $e229cb5c8b2cd629$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$e229cb5c8b2cd629$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $e229cb5c8b2cd629$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $e229cb5c8b2cd629$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $e229cb5c8b2cd629$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $e229cb5c8b2cd629$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $e229cb5c8b2cd629$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $e229cb5c8b2cd629$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticTouchEvent;
                        break;
                    case $e229cb5c8b2cd629$var$ANIMATION_END:
                    case $e229cb5c8b2cd629$var$ANIMATION_ITERATION:
                    case $e229cb5c8b2cd629$var$ANIMATION_START:
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticAnimationEvent;
                        break;
                    case $e229cb5c8b2cd629$var$TRANSITION_END:
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $e229cb5c8b2cd629$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($e229cb5c8b2cd629$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $e229cb5c8b2cd629$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($e229cb5c8b2cd629$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$e229cb5c8b2cd629$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $e229cb5c8b2cd629$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $e229cb5c8b2cd629$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $e229cb5c8b2cd629$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $e229cb5c8b2cd629$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $e229cb5c8b2cd629$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $e229cb5c8b2cd629$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $e229cb5c8b2cd629$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $e229cb5c8b2cd629$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $e229cb5c8b2cd629$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $e229cb5c8b2cd629$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $e229cb5c8b2cd629$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForChangeEvent;
                else if ($e229cb5c8b2cd629$var$isTextInputElement(reactName)) {
                    if ($e229cb5c8b2cd629$var$isInputEventSupported) getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $e229cb5c8b2cd629$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $e229cb5c8b2cd629$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForChangeEvent) : getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $e229cb5c8b2cd629$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $e229cb5c8b2cd629$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $e229cb5c8b2cd629$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($e229cb5c8b2cd629$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $e229cb5c8b2cd629$var$activeElement = handleEventFunc, $e229cb5c8b2cd629$var$activeElementInst = targetInst, $e229cb5c8b2cd629$var$lastSelection = null;
                    break;
                case "focusout":
                    $e229cb5c8b2cd629$var$lastSelection = $e229cb5c8b2cd629$var$activeElementInst = $e229cb5c8b2cd629$var$activeElement = null;
                    break;
                case "mousedown":
                    $e229cb5c8b2cd629$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e229cb5c8b2cd629$var$mouseDown = !1;
                    $e229cb5c8b2cd629$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($e229cb5c8b2cd629$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $e229cb5c8b2cd629$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($e229cb5c8b2cd629$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $e229cb5c8b2cd629$var$isComposing ? $e229cb5c8b2cd629$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($e229cb5c8b2cd629$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($e229cb5c8b2cd629$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $e229cb5c8b2cd629$var$isComposing && (fallbackData = $e229cb5c8b2cd629$var$getData()) : ($e229cb5c8b2cd629$var$root = nativeEventTarget, $e229cb5c8b2cd629$var$startText = "value" in $e229cb5c8b2cd629$var$root ? $e229cb5c8b2cd629$var$root.value : $e229cb5c8b2cd629$var$root.textContent, $e229cb5c8b2cd629$var$isComposing = !0)), handleEventFunc = $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $e229cb5c8b2cd629$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $e229cb5c8b2cd629$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $e229cb5c8b2cd629$var$canUseTextInputEvent ? $e229cb5c8b2cd629$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $e229cb5c8b2cd629$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $e229cb5c8b2cd629$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $e229cb5c8b2cd629$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $e229cb5c8b2cd629$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $e229cb5c8b2cd629$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $e229cb5c8b2cd629$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($e229cb5c8b2cd629$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $e229cb5c8b2cd629$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($e229cb5c8b2cd629$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $e229cb5c8b2cd629$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $e229cb5c8b2cd629$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $e229cb5c8b2cd629$var$getListener(target, registrationName), null != stateNode && listeners.unshift($e229cb5c8b2cd629$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $e229cb5c8b2cd629$var$getListener(target, registrationName), null != stateNode && listeners.push($e229cb5c8b2cd629$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $e229cb5c8b2cd629$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $e229cb5c8b2cd629$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $e229cb5c8b2cd629$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($e229cb5c8b2cd629$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($e229cb5c8b2cd629$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $e229cb5c8b2cd629$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $e229cb5c8b2cd629$var$normalizeMarkupForTextOrAttribute(clientText);
    return $e229cb5c8b2cd629$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $e229cb5c8b2cd629$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $e229cb5c8b2cd629$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $e229cb5c8b2cd629$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $e229cb5c8b2cd629$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $e229cb5c8b2cd629$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $e229cb5c8b2cd629$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $e229cb5c8b2cd629$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $e229cb5c8b2cd629$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $e229cb5c8b2cd629$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $e229cb5c8b2cd629$var$setProp(domElement, tag, "name", props.name, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($e229cb5c8b2cd629$var$setProp(domElement, tag, "encType", props.encType, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "method", props.method, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $e229cb5c8b2cd629$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $e229cb5c8b2cd629$var$noop$1);
            break;
        case "onScroll":
            null != value && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $e229cb5c8b2cd629$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", domElement);
            $e229cb5c8b2cd629$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $e229cb5c8b2cd629$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $e229cb5c8b2cd629$var$aliases.get(key) || key, $e229cb5c8b2cd629$var$setValueForAttribute(domElement, key, value);
    }
}
function $e229cb5c8b2cd629$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $e229cb5c8b2cd629$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $e229cb5c8b2cd629$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $e229cb5c8b2cd629$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $e229cb5c8b2cd629$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$e229cb5c8b2cd629$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$e229cb5c8b2cd629$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $e229cb5c8b2cd629$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $e229cb5c8b2cd629$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                    default:
                        $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $e229cb5c8b2cd629$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $e229cb5c8b2cd629$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $e229cb5c8b2cd629$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $e229cb5c8b2cd629$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $e229cb5c8b2cd629$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $e229cb5c8b2cd629$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(91));
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $e229cb5c8b2cd629$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("cancel", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $e229cb5c8b2cd629$var$mediaEventTypes.length; hasSrc++)$e229cb5c8b2cd629$var$listenToNonDelegatedEvent($e229cb5c8b2cd629$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", domElement), $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($e229cb5c8b2cd629$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $e229cb5c8b2cd629$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $e229cb5c8b2cd629$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $e229cb5c8b2cd629$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $e229cb5c8b2cd629$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $e229cb5c8b2cd629$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $e229cb5c8b2cd629$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $e229cb5c8b2cd629$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $e229cb5c8b2cd629$var$updateOptions(domElement, !!lastProps, tag, !0) : $e229cb5c8b2cd629$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $e229cb5c8b2cd629$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $e229cb5c8b2cd629$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($e229cb5c8b2cd629$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $e229cb5c8b2cd629$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $e229cb5c8b2cd629$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $e229cb5c8b2cd629$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $e229cb5c8b2cd629$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $e229cb5c8b2cd629$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $e229cb5c8b2cd629$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $e229cb5c8b2cd629$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $e229cb5c8b2cd629$var$eventsEnabled = null, $e229cb5c8b2cd629$var$selectionInformation = null;
function $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $e229cb5c8b2cd629$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $e229cb5c8b2cd629$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $e229cb5c8b2cd629$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $e229cb5c8b2cd629$var$currentPopstateTransitionEvent = null;
function $e229cb5c8b2cd629$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $e229cb5c8b2cd629$var$currentPopstateTransitionEvent) return !1;
        $e229cb5c8b2cd629$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $e229cb5c8b2cd629$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $e229cb5c8b2cd629$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $e229cb5c8b2cd629$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $e229cb5c8b2cd629$var$localPromise = "function" === typeof Promise ? Promise : void 0, $e229cb5c8b2cd629$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e229cb5c8b2cd629$var$localPromise ? function(callback) {
    return $e229cb5c8b2cd629$var$localPromise.resolve(null).then(callback).catch($e229cb5c8b2cd629$var$handleErrorInNextTick);
} : $e229cb5c8b2cd629$var$scheduleTimeout;
function $e229cb5c8b2cd629$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $e229cb5c8b2cd629$var$isSingletonScope(type) {
    return "head" === type;
}
function $e229cb5c8b2cd629$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $e229cb5c8b2cd629$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $e229cb5c8b2cd629$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $e229cb5c8b2cd629$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$e229cb5c8b2cd629$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $e229cb5c8b2cd629$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $e229cb5c8b2cd629$var$retryIfBlockedOn(hydrationInstance);
}
function $e229cb5c8b2cd629$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $e229cb5c8b2cd629$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $e229cb5c8b2cd629$var$clearContainerSparingly(node);
                $e229cb5c8b2cd629$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $e229cb5c8b2cd629$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$e229cb5c8b2cd629$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $e229cb5c8b2cd629$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $e229cb5c8b2cd629$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $e229cb5c8b2cd629$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $e229cb5c8b2cd629$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $e229cb5c8b2cd629$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $e229cb5c8b2cd629$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $e229cb5c8b2cd629$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $e229cb5c8b2cd629$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $e229cb5c8b2cd629$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $e229cb5c8b2cd629$var$previousHydratableOnEnteringScopedSingleton = null;
function $e229cb5c8b2cd629$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $e229cb5c8b2cd629$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $e229cb5c8b2cd629$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $e229cb5c8b2cd629$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(451));
    }
}
function $e229cb5c8b2cd629$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $e229cb5c8b2cd629$var$detachDeletedInstance(instance);
}
var $e229cb5c8b2cd629$var$preloadPropsMap = new Map(), $e229cb5c8b2cd629$var$preconnectsSet = new Set();
function $e229cb5c8b2cd629$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $e229cb5c8b2cd629$var$previousDispatcher = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.d;
$e229cb5c8b2cd629$var$ReactDOMSharedInternals.d = {
    f: $e229cb5c8b2cd629$var$flushSyncWork,
    r: $e229cb5c8b2cd629$var$requestFormReset,
    D: $e229cb5c8b2cd629$var$prefetchDNS,
    C: $e229cb5c8b2cd629$var$preconnect,
    L: $e229cb5c8b2cd629$var$preload,
    m: $e229cb5c8b2cd629$var$preloadModule,
    X: $e229cb5c8b2cd629$var$preinitScript,
    S: $e229cb5c8b2cd629$var$preinitStyle,
    M: $e229cb5c8b2cd629$var$preinitModuleScript
};
function $e229cb5c8b2cd629$var$flushSyncWork() {
    var previousWasRendering = $e229cb5c8b2cd629$var$previousDispatcher.f(), wasRendering = $e229cb5c8b2cd629$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $e229cb5c8b2cd629$var$requestFormReset(form) {
    var formInst = $e229cb5c8b2cd629$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $e229cb5c8b2cd629$var$requestFormReset$1(formInst) : $e229cb5c8b2cd629$var$previousDispatcher.r(form);
}
var $e229cb5c8b2cd629$var$globalDocument = "undefined" === typeof document ? null : document;
function $e229cb5c8b2cd629$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $e229cb5c8b2cd629$var$preconnectsSet.has(limitedEscapedHref) || ($e229cb5c8b2cd629$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $e229cb5c8b2cd629$var$setInitialProperties(href, "link", rel), $e229cb5c8b2cd629$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $e229cb5c8b2cd629$var$prefetchDNS(href) {
    $e229cb5c8b2cd629$var$previousDispatcher.D(href);
    $e229cb5c8b2cd629$var$preconnectAs("dns-prefetch", href, null);
}
function $e229cb5c8b2cd629$var$preconnect(href, crossOrigin) {
    $e229cb5c8b2cd629$var$previousDispatcher.C(href, crossOrigin);
    $e229cb5c8b2cd629$var$preconnectAs("preconnect", href, crossOrigin);
}
function $e229cb5c8b2cd629$var$preload(href, as, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $e229cb5c8b2cd629$var$getStyleKey(href);
                break;
            case "script":
                key = $e229cb5c8b2cd629$var$getScriptKey(href);
        }
        $e229cb5c8b2cd629$var$preloadPropsMap.has(key) || (href = $e229cb5c8b2cd629$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $e229cb5c8b2cd629$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $e229cb5c8b2cd629$var$setInitialProperties(as, "link", href), $e229cb5c8b2cd629$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $e229cb5c8b2cd629$var$preloadModule(href, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.m(href, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $e229cb5c8b2cd629$var$getScriptKey(href);
        }
        if (!$e229cb5c8b2cd629$var$preloadPropsMap.has(key) && (href = $e229cb5c8b2cd629$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $e229cb5c8b2cd629$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $e229cb5c8b2cd629$var$setInitialProperties(as, "link", href);
            $e229cb5c8b2cd629$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $e229cb5c8b2cd629$var$preinitStyle(href, precedence, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $e229cb5c8b2cd629$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $e229cb5c8b2cd629$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $e229cb5c8b2cd629$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $e229cb5c8b2cd629$var$preloadPropsMap.get(key)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $e229cb5c8b2cd629$var$markNodeAsHoistable(link);
                $e229cb5c8b2cd629$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $e229cb5c8b2cd629$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $e229cb5c8b2cd629$var$preinitScript(src, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.X(src, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $e229cb5c8b2cd629$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $e229cb5c8b2cd629$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(key)), resource || (src = $e229cb5c8b2cd629$var$assign({
            src: src,
            async: !0
        }, options), (options = $e229cb5c8b2cd629$var$preloadPropsMap.get(key)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $e229cb5c8b2cd629$var$markNodeAsHoistable(resource), $e229cb5c8b2cd629$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $e229cb5c8b2cd629$var$preinitModuleScript(src, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.M(src, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $e229cb5c8b2cd629$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $e229cb5c8b2cd629$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(key)), resource || (src = $e229cb5c8b2cd629$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $e229cb5c8b2cd629$var$preloadPropsMap.get(key)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $e229cb5c8b2cd629$var$markNodeAsHoistable(resource), $e229cb5c8b2cd629$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $e229cb5c8b2cd629$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $e229cb5c8b2cd629$var$rootInstanceStackCursor.current) ? $e229cb5c8b2cd629$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $e229cb5c8b2cd629$var$getStyleKey(pendingProps.href), pendingProps = $e229cb5c8b2cd629$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $e229cb5c8b2cd629$var$getStyleKey(pendingProps.href);
                var styles$243 = $e229cb5c8b2cd629$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $e229cb5c8b2cd629$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $e229cb5c8b2cd629$var$preloadPropsMap.set(type, pendingProps), styles$243 || $e229cb5c8b2cd629$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $e229cb5c8b2cd629$var$getScriptKey(pendingProps), pendingProps = $e229cb5c8b2cd629$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(444, type));
    }
}
function $e229cb5c8b2cd629$var$getStyleKey(href) {
    return 'href="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $e229cb5c8b2cd629$var$stylesheetPropsFromRawProps(rawProps) {
    return $e229cb5c8b2cd629$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $e229cb5c8b2cd629$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $e229cb5c8b2cd629$var$setInitialProperties(key, "link", preloadProps), $e229cb5c8b2cd629$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $e229cb5c8b2cd629$var$getScriptKey(src) {
    return '[src="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $e229cb5c8b2cd629$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $e229cb5c8b2cd629$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $e229cb5c8b2cd629$var$markNodeAsHoistable(instance), instance;
            var styleProps = $e229cb5c8b2cd629$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $e229cb5c8b2cd629$var$markNodeAsHoistable(instance);
            $e229cb5c8b2cd629$var$setInitialProperties(instance, "style", styleProps);
            $e229cb5c8b2cd629$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $e229cb5c8b2cd629$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $e229cb5c8b2cd629$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $e229cb5c8b2cd629$var$stylesheetPropsFromRawProps(props);
            (styleProps = $e229cb5c8b2cd629$var$preloadPropsMap.get(styleProps)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $e229cb5c8b2cd629$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $e229cb5c8b2cd629$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $e229cb5c8b2cd629$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $e229cb5c8b2cd629$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $e229cb5c8b2cd629$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $e229cb5c8b2cd629$var$preloadPropsMap.get(instance$249)) instance = $e229cb5c8b2cd629$var$assign({}, props), $e229cb5c8b2cd629$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $e229cb5c8b2cd629$var$markNodeAsHoistable(styleProps);
            $e229cb5c8b2cd629$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $e229cb5c8b2cd629$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $e229cb5c8b2cd629$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $e229cb5c8b2cd629$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $e229cb5c8b2cd629$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $e229cb5c8b2cd629$var$tagCaches = null;
function $e229cb5c8b2cd629$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $e229cb5c8b2cd629$var$tagCaches) {
        var cache = new Map();
        var caches = $e229cb5c8b2cd629$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $e229cb5c8b2cd629$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$e229cb5c8b2cd629$var$internalHoistableMarker] || node[$e229cb5c8b2cd629$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $e229cb5c8b2cd629$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $e229cb5c8b2cd629$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $e229cb5c8b2cd629$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $e229cb5c8b2cd629$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $e229cb5c8b2cd629$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $e229cb5c8b2cd629$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $e229cb5c8b2cd629$var$stylesheetPropsFromRawProps(props);
            (key = $e229cb5c8b2cd629$var$preloadPropsMap.get(key)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $e229cb5c8b2cd629$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $e229cb5c8b2cd629$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $e229cb5c8b2cd629$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $e229cb5c8b2cd629$var$estimatedBytesWithinLimit = 0;
function $e229cb5c8b2cd629$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $e229cb5c8b2cd629$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $e229cb5c8b2cd629$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $e229cb5c8b2cd629$var$estimatedBytesWithinLimit && ($e229cb5c8b2cd629$var$estimatedBytesWithinLimit = 62500 * $e229cb5c8b2cd629$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $e229cb5c8b2cd629$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $e229cb5c8b2cd629$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $e229cb5c8b2cd629$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $e229cb5c8b2cd629$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $e229cb5c8b2cd629$var$precedencesByRoot = null;
function $e229cb5c8b2cd629$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $e229cb5c8b2cd629$var$precedencesByRoot = new Map(), resources.forEach($e229cb5c8b2cd629$var$insertStylesheetIntoRoot, state), $e229cb5c8b2cd629$var$precedencesByRoot = null, $e229cb5c8b2cd629$var$onUnsuspend.call(state));
}
function $e229cb5c8b2cd629$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $e229cb5c8b2cd629$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $e229cb5c8b2cd629$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $e229cb5c8b2cd629$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $e229cb5c8b2cd629$var$HostTransitionContext = {
    $$typeof: $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $e229cb5c8b2cd629$var$sharedNotPendingObject,
    _currentValue2: $e229cb5c8b2cd629$var$sharedNotPendingObject,
    _threadCount: 0
};
function $e229cb5c8b2cd629$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $e229cb5c8b2cd629$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e229cb5c8b2cd629$var$createLaneMap(0);
    this.hiddenUpdates = $e229cb5c8b2cd629$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $e229cb5c8b2cd629$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $e229cb5c8b2cd629$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $e229cb5c8b2cd629$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $e229cb5c8b2cd629$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $e229cb5c8b2cd629$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $e229cb5c8b2cd629$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $e229cb5c8b2cd629$var$emptyContextObject;
    parentComponent = $e229cb5c8b2cd629$var$emptyContextObject;
    return parentComponent;
}
function $e229cb5c8b2cd629$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $e229cb5c8b2cd629$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $e229cb5c8b2cd629$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $e229cb5c8b2cd629$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(element, rootFiber, lane), $e229cb5c8b2cd629$var$entangleTransitions(element, rootFiber, lane));
}
function $e229cb5c8b2cd629$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $e229cb5c8b2cd629$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $e229cb5c8b2cd629$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $e229cb5c8b2cd629$var$markRetryLaneImpl(fiber, retryLane);
}
function $e229cb5c8b2cd629$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $e229cb5c8b2cd629$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $e229cb5c8b2cd629$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $e229cb5c8b2cd629$var$requestUpdateLane();
        lane = $e229cb5c8b2cd629$var$getBumpedLaneForHydrationByLane(lane);
        var root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, lane);
        $e229cb5c8b2cd629$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $e229cb5c8b2cd629$var$_enabled = !0;
function $e229cb5c8b2cd629$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
    $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
    var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    try {
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2, $e229cb5c8b2cd629$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition;
    }
}
function $e229cb5c8b2cd629$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
    $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
    var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    try {
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 8, $e229cb5c8b2cd629$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition;
    }
}
function $e229cb5c8b2cd629$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($e229cb5c8b2cd629$var$_enabled) {
        var blockedOn = $e229cb5c8b2cd629$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $e229cb5c8b2cd629$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $e229cb5c8b2cd629$var$return_targetInst, targetContainer), $e229cb5c8b2cd629$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($e229cb5c8b2cd629$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($e229cb5c8b2cd629$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $e229cb5c8b2cd629$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $e229cb5c8b2cd629$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $e229cb5c8b2cd629$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $e229cb5c8b2cd629$var$ensureRootIsScheduled(fiber);
                                0 === ($e229cb5c8b2cd629$var$executionContext & 6) && ($e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime = $e229cb5c8b2cd629$var$now() + 500, $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, 2), $e229cb5c8b2cd629$var$flushSyncWork$1(), $e229cb5c8b2cd629$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $e229cb5c8b2cd629$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $e229cb5c8b2cd629$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $e229cb5c8b2cd629$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $e229cb5c8b2cd629$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $e229cb5c8b2cd629$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $e229cb5c8b2cd629$var$getEventTarget(nativeEvent);
    return $e229cb5c8b2cd629$var$findInstanceBlockingTarget(nativeEvent);
}
var $e229cb5c8b2cd629$var$return_targetInst = null;
function $e229cb5c8b2cd629$var$findInstanceBlockingTarget(targetNode) {
    $e229cb5c8b2cd629$var$return_targetInst = null;
    targetNode = $e229cb5c8b2cd629$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $e229cb5c8b2cd629$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $e229cb5c8b2cd629$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $e229cb5c8b2cd629$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $e229cb5c8b2cd629$var$return_targetInst = targetNode;
    return null;
}
function $e229cb5c8b2cd629$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($e229cb5c8b2cd629$var$getCurrentPriorityLevel()){
                case $e229cb5c8b2cd629$var$ImmediatePriority:
                    return 2;
                case $e229cb5c8b2cd629$var$UserBlockingPriority:
                    return 8;
                case $e229cb5c8b2cd629$var$NormalPriority$1:
                case $e229cb5c8b2cd629$var$LowPriority:
                    return 32;
                case $e229cb5c8b2cd629$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $e229cb5c8b2cd629$var$hasScheduledReplayAttempt = !1, $e229cb5c8b2cd629$var$queuedFocus = null, $e229cb5c8b2cd629$var$queuedDrag = null, $e229cb5c8b2cd629$var$queuedMouse = null, $e229cb5c8b2cd629$var$queuedPointers = new Map(), $e229cb5c8b2cd629$var$queuedPointerCaptures = new Map(), $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets = [], $e229cb5c8b2cd629$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $e229cb5c8b2cd629$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $e229cb5c8b2cd629$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $e229cb5c8b2cd629$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $e229cb5c8b2cd629$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $e229cb5c8b2cd629$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e229cb5c8b2cd629$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $e229cb5c8b2cd629$var$getInstanceFromNode(blockedOn), null !== blockedOn && $e229cb5c8b2cd629$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $e229cb5c8b2cd629$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $e229cb5c8b2cd629$var$queuedFocus = $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $e229cb5c8b2cd629$var$queuedDrag = $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $e229cb5c8b2cd629$var$queuedMouse = $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $e229cb5c8b2cd629$var$queuedPointers.set(pointerId, $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $e229cb5c8b2cd629$var$queuedPointerCaptures.set(pointerId, $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $e229cb5c8b2cd629$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $e229cb5c8b2cd629$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $e229cb5c8b2cd629$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $e229cb5c8b2cd629$var$runWithPriority(queuedTarget.priority, function() {
                        $e229cb5c8b2cd629$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $e229cb5c8b2cd629$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $e229cb5c8b2cd629$var$runWithPriority(queuedTarget.priority, function() {
                        $e229cb5c8b2cd629$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $e229cb5c8b2cd629$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $e229cb5c8b2cd629$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $e229cb5c8b2cd629$var$currentReplayingEvent = null;
        } else return targetContainers = $e229cb5c8b2cd629$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $e229cb5c8b2cd629$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $e229cb5c8b2cd629$var$replayUnblockedEvents() {
    $e229cb5c8b2cd629$var$hasScheduledReplayAttempt = !1;
    null !== $e229cb5c8b2cd629$var$queuedFocus && $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent($e229cb5c8b2cd629$var$queuedFocus) && ($e229cb5c8b2cd629$var$queuedFocus = null);
    null !== $e229cb5c8b2cd629$var$queuedDrag && $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent($e229cb5c8b2cd629$var$queuedDrag) && ($e229cb5c8b2cd629$var$queuedDrag = null);
    null !== $e229cb5c8b2cd629$var$queuedMouse && $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent($e229cb5c8b2cd629$var$queuedMouse) && ($e229cb5c8b2cd629$var$queuedMouse = null);
    $e229cb5c8b2cd629$var$queuedPointers.forEach($e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEventInMap);
    $e229cb5c8b2cd629$var$queuedPointerCaptures.forEach($e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEventInMap);
}
function $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $e229cb5c8b2cd629$var$hasScheduledReplayAttempt || ($e229cb5c8b2cd629$var$hasScheduledReplayAttempt = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $e229cb5c8b2cd629$var$replayUnblockedEvents)));
}
var $e229cb5c8b2cd629$var$lastScheduledReplayQueue = null;
function $e229cb5c8b2cd629$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $e229cb5c8b2cd629$var$lastScheduledReplayQueue !== formReplayingQueue && ($e229cb5c8b2cd629$var$lastScheduledReplayQueue = formReplayingQueue, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, function() {
        $e229cb5c8b2cd629$var$lastScheduledReplayQueue === formReplayingQueue && ($e229cb5c8b2cd629$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $e229cb5c8b2cd629$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $e229cb5c8b2cd629$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $e229cb5c8b2cd629$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $e229cb5c8b2cd629$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $e229cb5c8b2cd629$var$queuedFocus && $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked($e229cb5c8b2cd629$var$queuedFocus, unblocked);
    null !== $e229cb5c8b2cd629$var$queuedDrag && $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked($e229cb5c8b2cd629$var$queuedDrag, unblocked);
    null !== $e229cb5c8b2cd629$var$queuedMouse && $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked($e229cb5c8b2cd629$var$queuedMouse, unblocked);
    $e229cb5c8b2cd629$var$queuedPointers.forEach(unblock);
    $e229cb5c8b2cd629$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.length && (i = $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$e229cb5c8b2cd629$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$e229cb5c8b2cd629$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $e229cb5c8b2cd629$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$e229cb5c8b2cd629$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $e229cb5c8b2cd629$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $e229cb5c8b2cd629$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $e229cb5c8b2cd629$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $e229cb5c8b2cd629$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$e229cb5c8b2cd629$var$ReactDOMHydrationRoot.prototype.render = $e229cb5c8b2cd629$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(409));
    var current = root.current, lane = $e229cb5c8b2cd629$var$requestUpdateLane();
    $e229cb5c8b2cd629$var$updateContainerImpl(current, lane, children, root, null, null);
};
$e229cb5c8b2cd629$var$ReactDOMHydrationRoot.prototype.unmount = $e229cb5c8b2cd629$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $e229cb5c8b2cd629$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $e229cb5c8b2cd629$var$flushSyncWork$1();
        container[$e229cb5c8b2cd629$var$internalContainerInstanceKey] = null;
    }
};
function $e229cb5c8b2cd629$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$e229cb5c8b2cd629$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $e229cb5c8b2cd629$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets[i].priority; i++);
        $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $e229cb5c8b2cd629$var$attemptExplicitHydrationTarget(target);
    }
};
var $e229cb5c8b2cd629$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $bh6RR.version;
if ("19.2.7" !== $e229cb5c8b2cd629$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(527, $e229cb5c8b2cd629$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.7"));
$e229cb5c8b2cd629$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $e229cb5c8b2cd629$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $e229cb5c8b2cd629$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $e229cb5c8b2cd629$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.7",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $e229cb5c8b2cd629$var$ReactSharedInternals,
    reconcilerVersion: "19.2.7"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e229cb5c8b2cd629$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e229cb5c8b2cd629$var$hook$jscomp$inline_2348.isDisabled && $e229cb5c8b2cd629$var$hook$jscomp$inline_2348.supportsFiber) try {
        $e229cb5c8b2cd629$var$rendererID = $e229cb5c8b2cd629$var$hook$jscomp$inline_2348.inject($e229cb5c8b2cd629$var$internals$jscomp$inline_2347), $e229cb5c8b2cd629$var$injectedHook = $e229cb5c8b2cd629$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$e229cb5c8b2cd629$export$882461b6382ed46c = function(container, options) {
    if (!$e229cb5c8b2cd629$var$isValidContainer(container)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $e229cb5c8b2cd629$var$defaultOnUncaughtError, onCaughtError = $e229cb5c8b2cd629$var$defaultOnCaughtError, onRecoverableError = $e229cb5c8b2cd629$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $e229cb5c8b2cd629$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $e229cb5c8b2cd629$var$defaultOnDefaultTransitionIndicator);
    container[$e229cb5c8b2cd629$var$internalContainerInstanceKey] = options.current;
    $e229cb5c8b2cd629$var$listenToAllSupportedEvents(container);
    return new $e229cb5c8b2cd629$var$ReactDOMRoot(options);
};
$e229cb5c8b2cd629$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$e229cb5c8b2cd629$var$isValidContainer(container)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $e229cb5c8b2cd629$var$defaultOnUncaughtError, onCaughtError = $e229cb5c8b2cd629$var$defaultOnCaughtError, onRecoverableError = $e229cb5c8b2cd629$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $e229cb5c8b2cd629$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $e229cb5c8b2cd629$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $e229cb5c8b2cd629$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $e229cb5c8b2cd629$var$requestUpdateLane();
    isStrictMode = $e229cb5c8b2cd629$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $e229cb5c8b2cd629$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $e229cb5c8b2cd629$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $e229cb5c8b2cd629$var$markRootUpdated$1(initialChildren, options);
    $e229cb5c8b2cd629$var$ensureRootIsScheduled(initialChildren);
    container[$e229cb5c8b2cd629$var$internalContainerInstanceKey] = initialChildren.current;
    $e229cb5c8b2cd629$var$listenToAllSupportedEvents(container);
    return new $e229cb5c8b2cd629$var$ReactDOMHydrationRoot(initialChildren);
};
$e229cb5c8b2cd629$export$83d89fbfd8236492 = "19.2.7";

});
parcelRegister("4LCdk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4CW02"));

});
parcelRegister("4CW02", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $35e7b389374acc05$export$c4744153514ff05d; }, function (v) { return $35e7b389374acc05$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $35e7b389374acc05$export$3e506c1ccc9cc1a7; }, function (v) { return $35e7b389374acc05$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $35e7b389374acc05$export$e26fe2ed2fa76875; }, function (v) { return $35e7b389374acc05$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $35e7b389374acc05$export$502329bbf4b505b1; }, function (v) { return $35e7b389374acc05$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $35e7b389374acc05$export$6e3807111c4874c4; }, function (v) { return $35e7b389374acc05$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $35e7b389374acc05$export$c27134553091fb3a; }, function (v) { return $35e7b389374acc05$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $35e7b389374acc05$export$33ee1acdc04fd2a2; }, function (v) { return $35e7b389374acc05$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $35e7b389374acc05$export$b00a404bbd5edef2; }, function (v) { return $35e7b389374acc05$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $35e7b389374acc05$export$d66a1c1c77bd778b; }, function (v) { return $35e7b389374acc05$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $35e7b389374acc05$export$d3dfb8e4810cb555; }, function (v) { return $35e7b389374acc05$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $35e7b389374acc05$export$72fdf0e06517287b; }, function (v) { return $35e7b389374acc05$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $35e7b389374acc05$export$816d2913ae6b83b1; }, function (v) { return $35e7b389374acc05$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $35e7b389374acc05$export$61bcfe829111a1d0; }, function (v) { return $35e7b389374acc05$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $35e7b389374acc05$export$7ee8c9beb337bc3f; }, function (v) { return $35e7b389374acc05$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $35e7b389374acc05$export$b5836b71941fa3ed; }, function (v) { return $35e7b389374acc05$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $35e7b389374acc05$export$cf845f2c119da08a; }, function (v) { return $35e7b389374acc05$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $35e7b389374acc05$export$c4744153514ff05d;
var $35e7b389374acc05$export$3e506c1ccc9cc1a7;
var $35e7b389374acc05$export$e26fe2ed2fa76875;
var $35e7b389374acc05$export$502329bbf4b505b1;
var $35e7b389374acc05$export$6e3807111c4874c4;
var $35e7b389374acc05$export$c27134553091fb3a;
var $35e7b389374acc05$export$33ee1acdc04fd2a2;
var $35e7b389374acc05$export$b00a404bbd5edef2;
var $35e7b389374acc05$export$d66a1c1c77bd778b;
var $35e7b389374acc05$export$d3dfb8e4810cb555;
var $35e7b389374acc05$export$72fdf0e06517287b;
var $35e7b389374acc05$export$816d2913ae6b83b1;
var $35e7b389374acc05$export$61bcfe829111a1d0;
var $35e7b389374acc05$export$7ee8c9beb337bc3f;
var $35e7b389374acc05$export$b5836b71941fa3ed;
var $35e7b389374acc05$export$cf845f2c119da08a;
"use strict";
function $35e7b389374acc05$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $35e7b389374acc05$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $35e7b389374acc05$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $35e7b389374acc05$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $35e7b389374acc05$var$compare(left, last)) rightIndex < length && 0 > $35e7b389374acc05$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $35e7b389374acc05$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $35e7b389374acc05$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$35e7b389374acc05$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $35e7b389374acc05$var$localPerformance = performance;
    $35e7b389374acc05$export$c4744153514ff05d = function() {
        return $35e7b389374acc05$var$localPerformance.now();
    };
} else {
    var $35e7b389374acc05$var$localDate = Date, $35e7b389374acc05$var$initialTime = $35e7b389374acc05$var$localDate.now();
    $35e7b389374acc05$export$c4744153514ff05d = function() {
        return $35e7b389374acc05$var$localDate.now() - $35e7b389374acc05$var$initialTime;
    };
}
var $35e7b389374acc05$var$taskQueue = [], $35e7b389374acc05$var$timerQueue = [], $35e7b389374acc05$var$taskIdCounter = 1, $35e7b389374acc05$var$currentTask = null, $35e7b389374acc05$var$currentPriorityLevel = 3, $35e7b389374acc05$var$isPerformingWork = !1, $35e7b389374acc05$var$isHostCallbackScheduled = !1, $35e7b389374acc05$var$isHostTimeoutScheduled = !1, $35e7b389374acc05$var$needsPaint = !1, $35e7b389374acc05$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $35e7b389374acc05$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $35e7b389374acc05$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $35e7b389374acc05$var$advanceTimers(currentTime) {
    for(var timer = $35e7b389374acc05$var$peek($35e7b389374acc05$var$timerQueue); null !== timer;){
        if (null === timer.callback) $35e7b389374acc05$var$pop($35e7b389374acc05$var$timerQueue);
        else if (timer.startTime <= currentTime) $35e7b389374acc05$var$pop($35e7b389374acc05$var$timerQueue), timer.sortIndex = timer.expirationTime, $35e7b389374acc05$var$push($35e7b389374acc05$var$taskQueue, timer);
        else break;
        timer = $35e7b389374acc05$var$peek($35e7b389374acc05$var$timerQueue);
    }
}
function $35e7b389374acc05$var$handleTimeout(currentTime) {
    $35e7b389374acc05$var$isHostTimeoutScheduled = !1;
    $35e7b389374acc05$var$advanceTimers(currentTime);
    if (!$35e7b389374acc05$var$isHostCallbackScheduled) {
        if (null !== $35e7b389374acc05$var$peek($35e7b389374acc05$var$taskQueue)) $35e7b389374acc05$var$isHostCallbackScheduled = !0, $35e7b389374acc05$var$isMessageLoopRunning || ($35e7b389374acc05$var$isMessageLoopRunning = !0, $35e7b389374acc05$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $35e7b389374acc05$var$peek($35e7b389374acc05$var$timerQueue);
            null !== firstTimer && $35e7b389374acc05$var$requestHostTimeout($35e7b389374acc05$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $35e7b389374acc05$var$isMessageLoopRunning = !1, $35e7b389374acc05$var$taskTimeoutID = -1, $35e7b389374acc05$var$frameInterval = 5, $35e7b389374acc05$var$startTime = -1;
function $35e7b389374acc05$var$shouldYieldToHost() {
    return $35e7b389374acc05$var$needsPaint ? !0 : $35e7b389374acc05$export$c4744153514ff05d() - $35e7b389374acc05$var$startTime < $35e7b389374acc05$var$frameInterval ? !1 : !0;
}
function $35e7b389374acc05$var$performWorkUntilDeadline() {
    $35e7b389374acc05$var$needsPaint = !1;
    if ($35e7b389374acc05$var$isMessageLoopRunning) {
        var currentTime = $35e7b389374acc05$export$c4744153514ff05d();
        $35e7b389374acc05$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $35e7b389374acc05$var$isHostCallbackScheduled = !1;
                $35e7b389374acc05$var$isHostTimeoutScheduled && ($35e7b389374acc05$var$isHostTimeoutScheduled = !1, $35e7b389374acc05$var$localClearTimeout($35e7b389374acc05$var$taskTimeoutID), $35e7b389374acc05$var$taskTimeoutID = -1);
                $35e7b389374acc05$var$isPerformingWork = !0;
                var previousPriorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
                try {
                    b: {
                        $35e7b389374acc05$var$advanceTimers(currentTime);
                        for($35e7b389374acc05$var$currentTask = $35e7b389374acc05$var$peek($35e7b389374acc05$var$taskQueue); null !== $35e7b389374acc05$var$currentTask && !($35e7b389374acc05$var$currentTask.expirationTime > currentTime && $35e7b389374acc05$var$shouldYieldToHost());){
                            var callback = $35e7b389374acc05$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $35e7b389374acc05$var$currentTask.callback = null;
                                $35e7b389374acc05$var$currentPriorityLevel = $35e7b389374acc05$var$currentTask.priorityLevel;
                                var continuationCallback = callback($35e7b389374acc05$var$currentTask.expirationTime <= currentTime);
                                currentTime = $35e7b389374acc05$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $35e7b389374acc05$var$currentTask.callback = continuationCallback;
                                    $35e7b389374acc05$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $35e7b389374acc05$var$currentTask === $35e7b389374acc05$var$peek($35e7b389374acc05$var$taskQueue) && $35e7b389374acc05$var$pop($35e7b389374acc05$var$taskQueue);
                                $35e7b389374acc05$var$advanceTimers(currentTime);
                            } else $35e7b389374acc05$var$pop($35e7b389374acc05$var$taskQueue);
                            $35e7b389374acc05$var$currentTask = $35e7b389374acc05$var$peek($35e7b389374acc05$var$taskQueue);
                        }
                        if (null !== $35e7b389374acc05$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $35e7b389374acc05$var$peek($35e7b389374acc05$var$timerQueue);
                            null !== firstTimer && $35e7b389374acc05$var$requestHostTimeout($35e7b389374acc05$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $35e7b389374acc05$var$currentTask = null, $35e7b389374acc05$var$currentPriorityLevel = previousPriorityLevel, $35e7b389374acc05$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $35e7b389374acc05$var$schedulePerformWorkUntilDeadline() : $35e7b389374acc05$var$isMessageLoopRunning = !1;
        }
    }
}
var $35e7b389374acc05$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $35e7b389374acc05$var$localSetImmediate) $35e7b389374acc05$var$schedulePerformWorkUntilDeadline = function() {
    $35e7b389374acc05$var$localSetImmediate($35e7b389374acc05$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $35e7b389374acc05$var$channel = new MessageChannel(), $35e7b389374acc05$var$port = $35e7b389374acc05$var$channel.port2;
    $35e7b389374acc05$var$channel.port1.onmessage = $35e7b389374acc05$var$performWorkUntilDeadline;
    $35e7b389374acc05$var$schedulePerformWorkUntilDeadline = function() {
        $35e7b389374acc05$var$port.postMessage(null);
    };
} else $35e7b389374acc05$var$schedulePerformWorkUntilDeadline = function() {
    $35e7b389374acc05$var$localSetTimeout($35e7b389374acc05$var$performWorkUntilDeadline, 0);
};
function $35e7b389374acc05$var$requestHostTimeout(callback, ms) {
    $35e7b389374acc05$var$taskTimeoutID = $35e7b389374acc05$var$localSetTimeout(function() {
        callback($35e7b389374acc05$export$c4744153514ff05d());
    }, ms);
}
$35e7b389374acc05$export$3e506c1ccc9cc1a7 = 5;
$35e7b389374acc05$export$e26fe2ed2fa76875 = 1;
$35e7b389374acc05$export$502329bbf4b505b1 = 4;
$35e7b389374acc05$export$6e3807111c4874c4 = 3;
$35e7b389374acc05$export$c27134553091fb3a = null;
$35e7b389374acc05$export$33ee1acdc04fd2a2 = 2;
$35e7b389374acc05$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$35e7b389374acc05$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $35e7b389374acc05$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$35e7b389374acc05$export$d3dfb8e4810cb555 = function() {
    return $35e7b389374acc05$var$currentPriorityLevel;
};
$35e7b389374acc05$export$72fdf0e06517287b = function(eventHandler) {
    switch($35e7b389374acc05$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
    $35e7b389374acc05$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $35e7b389374acc05$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$35e7b389374acc05$export$816d2913ae6b83b1 = function() {
    $35e7b389374acc05$var$needsPaint = !0;
};
$35e7b389374acc05$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
    $35e7b389374acc05$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $35e7b389374acc05$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$35e7b389374acc05$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $35e7b389374acc05$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $35e7b389374acc05$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $35e7b389374acc05$var$push($35e7b389374acc05$var$timerQueue, priorityLevel), null === $35e7b389374acc05$var$peek($35e7b389374acc05$var$taskQueue) && priorityLevel === $35e7b389374acc05$var$peek($35e7b389374acc05$var$timerQueue) && ($35e7b389374acc05$var$isHostTimeoutScheduled ? ($35e7b389374acc05$var$localClearTimeout($35e7b389374acc05$var$taskTimeoutID), $35e7b389374acc05$var$taskTimeoutID = -1) : $35e7b389374acc05$var$isHostTimeoutScheduled = !0, $35e7b389374acc05$var$requestHostTimeout($35e7b389374acc05$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $35e7b389374acc05$var$push($35e7b389374acc05$var$taskQueue, priorityLevel), $35e7b389374acc05$var$isHostCallbackScheduled || $35e7b389374acc05$var$isPerformingWork || ($35e7b389374acc05$var$isHostCallbackScheduled = !0, $35e7b389374acc05$var$isMessageLoopRunning || ($35e7b389374acc05$var$isMessageLoopRunning = !0, $35e7b389374acc05$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$35e7b389374acc05$export$b5836b71941fa3ed = $35e7b389374acc05$var$shouldYieldToHost;
$35e7b389374acc05$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
        $35e7b389374acc05$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $35e7b389374acc05$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("6afFj", function(module, exports) {
'use strict';
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

module.exports = (parcelRequire("41dBC"));

});
parcelRegister("41dBC", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $2ed1cf3ec43ffc9d$export$69ce8ef3fe5cead0; }, function (v) { return $2ed1cf3ec43ffc9d$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $2ed1cf3ec43ffc9d$export$d39a5bbd09211389; }, function (v) { return $2ed1cf3ec43ffc9d$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $2ed1cf3ec43ffc9d$export$cd75ccfd720a3cd4; }, function (v) { return $2ed1cf3ec43ffc9d$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $2ed1cf3ec43ffc9d$export$a0816fa17a9e79be; }, function (v) { return $2ed1cf3ec43ffc9d$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $2ed1cf3ec43ffc9d$export$7292efcadded39f3; }, function (v) { return $2ed1cf3ec43ffc9d$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $2ed1cf3ec43ffc9d$export$da407abadb9b8f86; }, function (v) { return $2ed1cf3ec43ffc9d$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $2ed1cf3ec43ffc9d$export$314cfea32580671c; }, function (v) { return $2ed1cf3ec43ffc9d$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $2ed1cf3ec43ffc9d$export$513ccb98c53b8039; }, function (v) { return $2ed1cf3ec43ffc9d$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $2ed1cf3ec43ffc9d$export$dbca993bc2d264a; }, function (v) { return $2ed1cf3ec43ffc9d$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $2ed1cf3ec43ffc9d$export$4797a8006f0655d0; }, function (v) { return $2ed1cf3ec43ffc9d$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $2ed1cf3ec43ffc9d$export$c78a37762a8d58e1; }, function (v) { return $2ed1cf3ec43ffc9d$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $2ed1cf3ec43ffc9d$export$606f11b2eb45ecc6; }, function (v) { return $2ed1cf3ec43ffc9d$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $2ed1cf3ec43ffc9d$export$f7e8a0bf92324b1e; }, function (v) { return $2ed1cf3ec43ffc9d$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $2ed1cf3ec43ffc9d$export$83d89fbfd8236492; }, function (v) { return $2ed1cf3ec43ffc9d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2ed1cf3ec43ffc9d$export$69ce8ef3fe5cead0;
var $2ed1cf3ec43ffc9d$export$d39a5bbd09211389;
var $2ed1cf3ec43ffc9d$export$cd75ccfd720a3cd4;
var $2ed1cf3ec43ffc9d$export$a0816fa17a9e79be;
var $2ed1cf3ec43ffc9d$export$7292efcadded39f3;
var $2ed1cf3ec43ffc9d$export$da407abadb9b8f86;
var $2ed1cf3ec43ffc9d$export$314cfea32580671c;
var $2ed1cf3ec43ffc9d$export$513ccb98c53b8039;
var $2ed1cf3ec43ffc9d$export$dbca993bc2d264a;
var $2ed1cf3ec43ffc9d$export$4797a8006f0655d0;
var $2ed1cf3ec43ffc9d$export$c78a37762a8d58e1;
var $2ed1cf3ec43ffc9d$export$606f11b2eb45ecc6;
var $2ed1cf3ec43ffc9d$export$f7e8a0bf92324b1e;
var $2ed1cf3ec43ffc9d$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
function $2ed1cf3ec43ffc9d$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $2ed1cf3ec43ffc9d$var$noop() {}
var $2ed1cf3ec43ffc9d$var$Internals = {
    d: {
        f: $2ed1cf3ec43ffc9d$var$noop,
        r: function() {
            throw Error($2ed1cf3ec43ffc9d$var$formatProdErrorMessage(522));
        },
        D: $2ed1cf3ec43ffc9d$var$noop,
        C: $2ed1cf3ec43ffc9d$var$noop,
        L: $2ed1cf3ec43ffc9d$var$noop,
        m: $2ed1cf3ec43ffc9d$var$noop,
        X: $2ed1cf3ec43ffc9d$var$noop,
        S: $2ed1cf3ec43ffc9d$var$noop,
        M: $2ed1cf3ec43ffc9d$var$noop
    },
    p: 0,
    findDOMNode: null
}, $2ed1cf3ec43ffc9d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $2ed1cf3ec43ffc9d$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $2ed1cf3ec43ffc9d$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $2ed1cf3ec43ffc9d$var$ReactSharedInternals = $bh6RR.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$2ed1cf3ec43ffc9d$export$69ce8ef3fe5cead0 = $2ed1cf3ec43ffc9d$var$Internals;
$2ed1cf3ec43ffc9d$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($2ed1cf3ec43ffc9d$var$formatProdErrorMessage(299));
    return $2ed1cf3ec43ffc9d$var$createPortal$1(children, container, null, key);
};
$2ed1cf3ec43ffc9d$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $2ed1cf3ec43ffc9d$var$ReactSharedInternals.T, previousUpdatePriority = $2ed1cf3ec43ffc9d$var$Internals.p;
    try {
        if ($2ed1cf3ec43ffc9d$var$ReactSharedInternals.T = null, $2ed1cf3ec43ffc9d$var$Internals.p = 2, fn) return fn();
    } finally{
        $2ed1cf3ec43ffc9d$var$ReactSharedInternals.T = previousTransition, $2ed1cf3ec43ffc9d$var$Internals.p = previousUpdatePriority, $2ed1cf3ec43ffc9d$var$Internals.d.f();
    }
};
$2ed1cf3ec43ffc9d$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $2ed1cf3ec43ffc9d$var$Internals.d.C(href, options));
};
$2ed1cf3ec43ffc9d$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $2ed1cf3ec43ffc9d$var$Internals.d.D(href);
};
$2ed1cf3ec43ffc9d$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $2ed1cf3ec43ffc9d$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $2ed1cf3ec43ffc9d$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$2ed1cf3ec43ffc9d$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $2ed1cf3ec43ffc9d$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $2ed1cf3ec43ffc9d$var$Internals.d.M(href);
    }
};
$2ed1cf3ec43ffc9d$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(as, options.crossOrigin);
        $2ed1cf3ec43ffc9d$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$2ed1cf3ec43ffc9d$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $2ed1cf3ec43ffc9d$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $2ed1cf3ec43ffc9d$var$Internals.d.m(href);
    }
};
$2ed1cf3ec43ffc9d$export$4797a8006f0655d0 = function(form) {
    $2ed1cf3ec43ffc9d$var$Internals.d.r(form);
};
$2ed1cf3ec43ffc9d$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$2ed1cf3ec43ffc9d$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $2ed1cf3ec43ffc9d$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$2ed1cf3ec43ffc9d$export$f7e8a0bf92324b1e = function() {
    return $2ed1cf3ec43ffc9d$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$2ed1cf3ec43ffc9d$export$83d89fbfd8236492 = "19.2.7";

});



parcelRegister("gggdZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("5E0NG")).default; });

var $5E0NG = parcelRequire("5E0NG");

});
parcelRegister("5E0NG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63b1d0acf055f536$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $11hmc = parcelRequire("11hmc");
const $63b1d0acf055f536$var$Spinner = ()=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        "data-testid": "spinner",
        className: $11hmc.spinner
    });
};
var $63b1d0acf055f536$export$2e2bcd8739ae039 = $63b1d0acf055f536$var$Spinner;

});
parcelRegister("11hmc", function(module, exports) {

$parcel$export(module.exports, "load", function () { return $0be3592ebfc9324a$export$11e63f7b0f3d9900; }, function (v) { return $0be3592ebfc9324a$export$11e63f7b0f3d9900 = v; });
$parcel$export(module.exports, "spinner", function () { return $0be3592ebfc9324a$export$641374ffb95bc399; }, function (v) { return $0be3592ebfc9324a$export$641374ffb95bc399 = v; });
var $0be3592ebfc9324a$export$11e63f7b0f3d9900;
var $0be3592ebfc9324a$export$641374ffb95bc399;
$0be3592ebfc9324a$export$11e63f7b0f3d9900 = `ZLzsgq_load`;
$0be3592ebfc9324a$export$11e63f7b0f3d9900;
$0be3592ebfc9324a$export$641374ffb95bc399 = `ZLzsgq_spinner`;

});



parcelRegister("bC0hQ", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7jkLd"))($parcel$resolve("lA1BH")),
    $parcel$import("3Mnm8")
]).then(()=>parcelRequire('hVJg2'));

});
parcelRegister("7jkLd", function(module, exports) {
"use strict";

var $boLNp = parcelRequire("boLNp");
module.exports = $boLNp(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("boLNp", function(module, exports) {
"use strict";
var $84c702df89f2997b$var$cachedBundles = {};
var $84c702df89f2997b$var$cachedPreloads = {};
var $84c702df89f2997b$var$cachedPrefetches = {};
function $84c702df89f2997b$var$getCache(type) {
    switch(type){
        case 'preload':
            return $84c702df89f2997b$var$cachedPreloads;
        case 'prefetch':
            return $84c702df89f2997b$var$cachedPrefetches;
        default:
            return $84c702df89f2997b$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $84c702df89f2997b$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $c6b69ec680bd2ca4$exports = {};
$parcel$extendImportMap({
    "3Mnm8": "Resume.f625c39c.js",
    "lA1BH": "Resume.475ed377.css"
});


var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");
var $6fc264ec92100d3a$exports = {};
'use strict';
function $6fc264ec92100d3a$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6fc264ec92100d3a$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6fc264ec92100d3a$var$checkDCE();

$6fc264ec92100d3a$exports = (parcelRequire("jpRqs"));



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
/**
 * react-router v7.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");
var $98602bd11beb292b$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-6CSD65Y2.mjs"
});
var $98602bd11beb292b$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $98602bd11beb292b$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $98602bd11beb292b$var$__typeError("Cannot " + msg);
var $98602bd11beb292b$var$__privateGet = (obj, member, getter)=>($98602bd11beb292b$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $98602bd11beb292b$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $98602bd11beb292b$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $98602bd11beb292b$var$__privateSet = (obj, member, value, setter)=>($98602bd11beb292b$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/history.ts
var $98602bd11beb292b$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($98602bd11beb292b$export$e19cd5f9376f8cee || {});
var $98602bd11beb292b$var$PopStateEventType = "popstate";
function $98602bd11beb292b$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $98602bd11beb292b$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $98602bd11beb292b$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $98602bd11beb292b$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $98602bd11beb292b$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $98602bd11beb292b$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $98602bd11beb292b$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $98602bd11beb292b$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $98602bd11beb292b$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $98602bd11beb292b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $98602bd11beb292b$export$fe53371bee54353d(to);
    }
    return $98602bd11beb292b$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $98602bd11beb292b$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $98602bd11beb292b$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $98602bd11beb292b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $98602bd11beb292b$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $98602bd11beb292b$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $98602bd11beb292b$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $98602bd11beb292b$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $98602bd11beb292b$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $98602bd11beb292b$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $98602bd11beb292b$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $98602bd11beb292b$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $98602bd11beb292b$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $98602bd11beb292b$var$createKey(),
        mask: mask
    };
    return location;
}
function $98602bd11beb292b$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $98602bd11beb292b$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $98602bd11beb292b$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $98602bd11beb292b$var$isLocation(to) ? to : $98602bd11beb292b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $98602bd11beb292b$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $98602bd11beb292b$var$isLocation(to) ? to : $98602bd11beb292b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $98602bd11beb292b$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $98602bd11beb292b$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($98602bd11beb292b$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($98602bd11beb292b$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $98602bd11beb292b$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $98602bd11beb292b$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $98602bd11beb292b$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $98602bd11beb292b$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $98602bd11beb292b$var$_map;
var $98602bd11beb292b$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $98602bd11beb292b$var$__privateAdd(this, $98602bd11beb292b$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($98602bd11beb292b$var$__privateGet(this, $98602bd11beb292b$var$_map).has(context)) return $98602bd11beb292b$var$__privateGet(this, $98602bd11beb292b$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $98602bd11beb292b$var$__privateGet(this, $98602bd11beb292b$var$_map).set(context, value);
    }
};
$98602bd11beb292b$var$_map = new WeakMap();
var $98602bd11beb292b$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $98602bd11beb292b$var$isUnsupportedLazyRouteObjectKey(key) {
    return $98602bd11beb292b$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $98602bd11beb292b$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $98602bd11beb292b$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $98602bd11beb292b$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $98602bd11beb292b$var$isIndexRoute(route) {
    return route.index === true;
}
function $98602bd11beb292b$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $98602bd11beb292b$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $98602bd11beb292b$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($98602bd11beb292b$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $98602bd11beb292b$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $98602bd11beb292b$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $98602bd11beb292b$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $98602bd11beb292b$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $98602bd11beb292b$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $98602bd11beb292b$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $98602bd11beb292b$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $98602bd11beb292b$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $98602bd11beb292b$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $98602bd11beb292b$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $98602bd11beb292b$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $98602bd11beb292b$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $98602bd11beb292b$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $98602bd11beb292b$var$flattenAndRankRoutes(routes) {
    let branches = $98602bd11beb292b$var$flattenRoutes(routes);
    $98602bd11beb292b$var$rankRouteBranches(branches);
    return branches;
}
function $98602bd11beb292b$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $98602bd11beb292b$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $98602bd11beb292b$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $98602bd11beb292b$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $98602bd11beb292b$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $98602bd11beb292b$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $98602bd11beb292b$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $98602bd11beb292b$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $98602bd11beb292b$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $98602bd11beb292b$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $98602bd11beb292b$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $98602bd11beb292b$var$paramRe = /^:[\w-]+$/;
var $98602bd11beb292b$var$dynamicSegmentValue = 3;
var $98602bd11beb292b$var$indexRouteValue = 2;
var $98602bd11beb292b$var$emptySegmentValue = 1;
var $98602bd11beb292b$var$staticSegmentValue = 10;
var $98602bd11beb292b$var$splatPenalty = -2;
var $98602bd11beb292b$var$isSplat = (s)=>s === "*";
function $98602bd11beb292b$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($98602bd11beb292b$var$isSplat)) initialScore += $98602bd11beb292b$var$splatPenalty;
    if (index) initialScore += $98602bd11beb292b$var$indexRouteValue;
    return segments.filter((s)=>!$98602bd11beb292b$var$isSplat(s)).reduce((score, segment)=>score + ($98602bd11beb292b$var$paramRe.test(segment) ? $98602bd11beb292b$var$dynamicSegmentValue : segment === "" ? $98602bd11beb292b$var$emptySegmentValue : $98602bd11beb292b$var$staticSegmentValue), initialScore);
}
function $98602bd11beb292b$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $98602bd11beb292b$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $98602bd11beb292b$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $98602bd11beb292b$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $98602bd11beb292b$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $98602bd11beb292b$var$normalizePathname($98602bd11beb292b$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $98602bd11beb292b$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $98602bd11beb292b$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $98602bd11beb292b$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $98602bd11beb292b$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $98602bd11beb292b$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $98602bd11beb292b$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $98602bd11beb292b$var$compilePath(path, caseSensitive = false, end = true) {
    $98602bd11beb292b$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $98602bd11beb292b$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $98602bd11beb292b$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $98602bd11beb292b$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $98602bd11beb292b$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $98602bd11beb292b$var$joinPaths([
        basename,
        pathname
    ]);
}
var $98602bd11beb292b$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $98602bd11beb292b$var$isAbsoluteUrl = (url)=>$98602bd11beb292b$var$ABSOLUTE_URL_REGEX.test(url);
function $98602bd11beb292b$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $98602bd11beb292b$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $98602bd11beb292b$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $98602bd11beb292b$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $98602bd11beb292b$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $98602bd11beb292b$var$normalizeSearch(search),
        hash: $98602bd11beb292b$var$normalizeHash(hash)
    };
}
function $98602bd11beb292b$var$resolvePathname(relativePath, fromPathname) {
    let segments = $98602bd11beb292b$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $98602bd11beb292b$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $98602bd11beb292b$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $98602bd11beb292b$var$getResolveToMatches(matches) {
    let pathMatches = $98602bd11beb292b$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $98602bd11beb292b$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $98602bd11beb292b$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $98602bd11beb292b$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $98602bd11beb292b$var$getInvalidPathError("?", "pathname", "search", to));
        $98602bd11beb292b$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $98602bd11beb292b$var$getInvalidPathError("#", "pathname", "hash", to));
        $98602bd11beb292b$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $98602bd11beb292b$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $98602bd11beb292b$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $98602bd11beb292b$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
var $98602bd11beb292b$var$joinPaths = (paths)=>$98602bd11beb292b$var$removeDoubleSlashes(paths.join("/"));
var $98602bd11beb292b$var$removeTrailingSlash = (path)=>path.replace(/\/+$/, "");
var $98602bd11beb292b$var$normalizePathname = (pathname)=>$98602bd11beb292b$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $98602bd11beb292b$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $98602bd11beb292b$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $98602bd11beb292b$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $98602bd11beb292b$export$4051a07651545597(data2, init) {
    return new $98602bd11beb292b$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $98602bd11beb292b$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $98602bd11beb292b$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $98602bd11beb292b$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $98602bd11beb292b$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $98602bd11beb292b$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $98602bd11beb292b$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $98602bd11beb292b$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $98602bd11beb292b$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $98602bd11beb292b$var$joinPaths(parts) || "/";
}
var $98602bd11beb292b$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $98602bd11beb292b$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$98602bd11beb292b$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($98602bd11beb292b$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = $98602bd11beb292b$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $98602bd11beb292b$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $98602bd11beb292b$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $98602bd11beb292b$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $98602bd11beb292b$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $98602bd11beb292b$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$98602bd11beb292b$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $98602bd11beb292b$var$wrapImpl(aggregated[key], original, (...args)=>$98602bd11beb292b$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$98602bd11beb292b$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$98602bd11beb292b$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $98602bd11beb292b$var$wrapImpl(aggregated.middleware, original, (...args)=>$98602bd11beb292b$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$98602bd11beb292b$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $98602bd11beb292b$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$98602bd11beb292b$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $98602bd11beb292b$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $98602bd11beb292b$export$fe53371bee54353d(to) : ".",
                ...$98602bd11beb292b$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$98602bd11beb292b$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$98602bd11beb292b$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $98602bd11beb292b$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$98602bd11beb292b$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$98602bd11beb292b$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $98602bd11beb292b$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $98602bd11beb292b$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $98602bd11beb292b$var$getReadonlyRequest(request),
            context: context != null ? $98602bd11beb292b$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $98602bd11beb292b$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $98602bd11beb292b$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $98602bd11beb292b$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $98602bd11beb292b$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $98602bd11beb292b$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $98602bd11beb292b$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $98602bd11beb292b$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $98602bd11beb292b$var$getReadonlyContext(context)
    };
}
function $98602bd11beb292b$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $98602bd11beb292b$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $98602bd11beb292b$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $98602bd11beb292b$var$getReadonlyContext(context) {
    if ($98602bd11beb292b$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $98602bd11beb292b$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $98602bd11beb292b$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $98602bd11beb292b$var$objectProtoNames;
}
// lib/router/router.ts
var $98602bd11beb292b$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $98602bd11beb292b$var$validMutationMethods = new Set($98602bd11beb292b$var$validMutationMethodsArr);
var $98602bd11beb292b$var$validRequestMethodsArr = [
    "GET",
    ...$98602bd11beb292b$var$validMutationMethodsArr
];
var $98602bd11beb292b$var$validRequestMethods = new Set($98602bd11beb292b$var$validRequestMethodsArr);
var $98602bd11beb292b$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $98602bd11beb292b$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $98602bd11beb292b$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $98602bd11beb292b$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $98602bd11beb292b$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $98602bd11beb292b$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $98602bd11beb292b$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $98602bd11beb292b$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $98602bd11beb292b$var$_routes, $98602bd11beb292b$var$_branches, $98602bd11beb292b$var$_hmrRoutes, $98602bd11beb292b$var$_hmrBranches;
var $98602bd11beb292b$var$DataRoutes = class {
    constructor(routes){
        $98602bd11beb292b$var$__privateAdd(this, $98602bd11beb292b$var$_routes);
        $98602bd11beb292b$var$__privateAdd(this, $98602bd11beb292b$var$_branches);
        $98602bd11beb292b$var$__privateAdd(this, $98602bd11beb292b$var$_hmrRoutes);
        $98602bd11beb292b$var$__privateAdd(this, $98602bd11beb292b$var$_hmrBranches);
        $98602bd11beb292b$var$__privateSet(this, $98602bd11beb292b$var$_routes, routes);
        $98602bd11beb292b$var$__privateSet(this, $98602bd11beb292b$var$_branches, $98602bd11beb292b$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $98602bd11beb292b$var$__privateGet(this, $98602bd11beb292b$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $98602bd11beb292b$var$__privateGet(this, $98602bd11beb292b$var$_hmrRoutes) ?? $98602bd11beb292b$var$__privateGet(this, $98602bd11beb292b$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $98602bd11beb292b$var$__privateGet(this, $98602bd11beb292b$var$_hmrBranches) ?? $98602bd11beb292b$var$__privateGet(this, $98602bd11beb292b$var$_branches);
    }
    get hasHMRRoutes() {
        return $98602bd11beb292b$var$__privateGet(this, $98602bd11beb292b$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $98602bd11beb292b$var$__privateSet(this, $98602bd11beb292b$var$_routes, routes);
        $98602bd11beb292b$var$__privateSet(this, $98602bd11beb292b$var$_branches, $98602bd11beb292b$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $98602bd11beb292b$var$__privateSet(this, $98602bd11beb292b$var$_hmrRoutes, routes);
        $98602bd11beb292b$var$__privateSet(this, $98602bd11beb292b$var$_hmrBranches, $98602bd11beb292b$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($98602bd11beb292b$var$__privateGet(this, $98602bd11beb292b$var$_hmrRoutes)) {
            $98602bd11beb292b$var$__privateSet(this, $98602bd11beb292b$var$_routes, $98602bd11beb292b$var$__privateGet(this, $98602bd11beb292b$var$_hmrRoutes));
            $98602bd11beb292b$var$__privateSet(this, $98602bd11beb292b$var$_branches, $98602bd11beb292b$var$__privateGet(this, $98602bd11beb292b$var$_hmrBranches));
            $98602bd11beb292b$var$__privateSet(this, $98602bd11beb292b$var$_hmrRoutes, void 0);
            $98602bd11beb292b$var$__privateSet(this, $98602bd11beb292b$var$_hmrBranches, void 0);
        }
    }
};
$98602bd11beb292b$var$_routes = new WeakMap();
$98602bd11beb292b$var$_branches = new WeakMap();
$98602bd11beb292b$var$_hmrRoutes = new WeakMap();
$98602bd11beb292b$var$_hmrBranches = new WeakMap();
function $98602bd11beb292b$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $98602bd11beb292b$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $98602bd11beb292b$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$98602bd11beb292b$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $98602bd11beb292b$var$DataRoutes($98602bd11beb292b$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $98602bd11beb292b$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $98602bd11beb292b$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $98602bd11beb292b$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $98602bd11beb292b$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$98602bd11beb292b$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $98602bd11beb292b$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $98602bd11beb292b$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $98602bd11beb292b$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $98602bd11beb292b$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $98602bd11beb292b$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$98602bd11beb292b$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $98602bd11beb292b$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $98602bd11beb292b$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $98602bd11beb292b$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $98602bd11beb292b$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $98602bd11beb292b$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $98602bd11beb292b$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $98602bd11beb292b$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $98602bd11beb292b$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $98602bd11beb292b$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $98602bd11beb292b$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $98602bd11beb292b$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $98602bd11beb292b$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $98602bd11beb292b$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $98602bd11beb292b$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $98602bd11beb292b$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $98602bd11beb292b$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $98602bd11beb292b$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $98602bd11beb292b$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $98602bd11beb292b$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $98602bd11beb292b$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($98602bd11beb292b$var$isErrorResult(result) && $98602bd11beb292b$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $98602bd11beb292b$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $98602bd11beb292b$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$98602bd11beb292b$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $98602bd11beb292b$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $98602bd11beb292b$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $98602bd11beb292b$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $98602bd11beb292b$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $98602bd11beb292b$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $98602bd11beb292b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($98602bd11beb292b$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $98602bd11beb292b$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($98602bd11beb292b$var$isErrorResult(result)) {
            let boundaryMatch = $98602bd11beb292b$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $98602bd11beb292b$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $98602bd11beb292b$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $98602bd11beb292b$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $98602bd11beb292b$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $98602bd11beb292b$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $98602bd11beb292b$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$98602bd11beb292b$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $98602bd11beb292b$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $98602bd11beb292b$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $98602bd11beb292b$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$98602bd11beb292b$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $98602bd11beb292b$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $98602bd11beb292b$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $98602bd11beb292b$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $98602bd11beb292b$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $98602bd11beb292b$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $98602bd11beb292b$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $98602bd11beb292b$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $98602bd11beb292b$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $98602bd11beb292b$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $98602bd11beb292b$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $98602bd11beb292b$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $98602bd11beb292b$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $98602bd11beb292b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($98602bd11beb292b$var$isRedirectResult(actionResult) || $98602bd11beb292b$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $98602bd11beb292b$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($98602bd11beb292b$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $98602bd11beb292b$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $98602bd11beb292b$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($98602bd11beb292b$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $98602bd11beb292b$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $98602bd11beb292b$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $98602bd11beb292b$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $98602bd11beb292b$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $98602bd11beb292b$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $98602bd11beb292b$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $98602bd11beb292b$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $98602bd11beb292b$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $98602bd11beb292b$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $98602bd11beb292b$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $98602bd11beb292b$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $98602bd11beb292b$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $98602bd11beb292b$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $98602bd11beb292b$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $98602bd11beb292b$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $98602bd11beb292b$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $98602bd11beb292b$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $98602bd11beb292b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $98602bd11beb292b$var$getDoneFetcher(void 0));
            return;
        }
        if ($98602bd11beb292b$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $98602bd11beb292b$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($98602bd11beb292b$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $98602bd11beb292b$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $98602bd11beb292b$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $98602bd11beb292b$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $98602bd11beb292b$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($98602bd11beb292b$var$isAbsoluteUrl(location)) {
                const url = $98602bd11beb292b$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $98602bd11beb292b$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $98602bd11beb292b$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($98602bd11beb292b$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $98602bd11beb292b$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $98602bd11beb292b$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $98602bd11beb292b$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$98602bd11beb292b$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($98602bd11beb292b$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $98602bd11beb292b$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $98602bd11beb292b$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $98602bd11beb292b$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $98602bd11beb292b$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $98602bd11beb292b$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $98602bd11beb292b$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $98602bd11beb292b$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $98602bd11beb292b$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $98602bd11beb292b$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $98602bd11beb292b$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $98602bd11beb292b$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $98602bd11beb292b$export$386d57f03f0b2883;
        $98602bd11beb292b$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $98602bd11beb292b$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $98602bd11beb292b$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $98602bd11beb292b$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $98602bd11beb292b$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$98602bd11beb292b$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $98602bd11beb292b$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $98602bd11beb292b$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $98602bd11beb292b$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $98602bd11beb292b$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $98602bd11beb292b$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $98602bd11beb292b$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($98602bd11beb292b$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $98602bd11beb292b$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $98602bd11beb292b$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $98602bd11beb292b$export$3336b097a6fbc59a(routes, opts) {
    $98602bd11beb292b$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $98602bd11beb292b$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$98602bd11beb292b$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $98602bd11beb292b$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $98602bd11beb292b$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $98602bd11beb292b$var$defaultNormalizePath;
        let method = request.method;
        let location = $98602bd11beb292b$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $98602bd11beb292b$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $98602bd11beb292b$export$b8d3e69d4b3eff04();
        if (!$98602bd11beb292b$var$isValidMethod(method) && method !== "HEAD") {
            let error = $98602bd11beb292b$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $98602bd11beb292b$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $98602bd11beb292b$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $98602bd11beb292b$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $98602bd11beb292b$export$f5708dca728d7177(requestContext instanceof $98602bd11beb292b$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $98602bd11beb292b$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $98602bd11beb292b$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $98602bd11beb292b$var$createDataFunctionUrl(request, location),
                    pattern: $98602bd11beb292b$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($98602bd11beb292b$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($98602bd11beb292b$export$6e80290866a84dd4(error)) return error;
                    if ($98602bd11beb292b$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $98602bd11beb292b$export$f2680fa305b734ca(error.status, error.statusText, await $98602bd11beb292b$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($98602bd11beb292b$export$e0163cfdf7bc9cfa(error)) error = $98602bd11beb292b$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $98602bd11beb292b$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $98602bd11beb292b$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $98602bd11beb292b$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $98602bd11beb292b$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $98602bd11beb292b$export$f5708dca728d7177($98602bd11beb292b$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($98602bd11beb292b$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($98602bd11beb292b$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $98602bd11beb292b$var$defaultNormalizePath;
        let method = request.method;
        let location = $98602bd11beb292b$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $98602bd11beb292b$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $98602bd11beb292b$export$b8d3e69d4b3eff04();
        if (!$98602bd11beb292b$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $98602bd11beb292b$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $98602bd11beb292b$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $98602bd11beb292b$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $98602bd11beb292b$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $98602bd11beb292b$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $98602bd11beb292b$export$f5708dca728d7177(requestContext instanceof $98602bd11beb292b$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $98602bd11beb292b$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $98602bd11beb292b$var$runServerMiddlewarePipeline({
                request: request,
                url: $98602bd11beb292b$var$createDataFunctionUrl(request, location),
                pattern: $98602bd11beb292b$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $98602bd11beb292b$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($98602bd11beb292b$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($98602bd11beb292b$var$dataWithResponseInitToResponse(error));
                if ($98602bd11beb292b$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($98602bd11beb292b$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $98602bd11beb292b$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($98602bd11beb292b$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $98602bd11beb292b$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $98602bd11beb292b$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($98602bd11beb292b$var$isDataStrategyResult(e) && $98602bd11beb292b$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($98602bd11beb292b$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $98602bd11beb292b$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $98602bd11beb292b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $98602bd11beb292b$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($98602bd11beb292b$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($98602bd11beb292b$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($98602bd11beb292b$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $98602bd11beb292b$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $98602bd11beb292b$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($98602bd11beb292b$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $98602bd11beb292b$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $98602bd11beb292b$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $98602bd11beb292b$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $98602bd11beb292b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $98602bd11beb292b$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $98602bd11beb292b$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $98602bd11beb292b$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $98602bd11beb292b$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $98602bd11beb292b$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $98602bd11beb292b$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $98602bd11beb292b$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $98602bd11beb292b$var$callDataStrategyImpl(dataStrategy || $98602bd11beb292b$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($98602bd11beb292b$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $98602bd11beb292b$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($98602bd11beb292b$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($98602bd11beb292b$export$e0163cfdf7bc9cfa(result.result)) throw $98602bd11beb292b$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $98602bd11beb292b$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $98602bd11beb292b$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $98602bd11beb292b$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $98602bd11beb292b$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $98602bd11beb292b$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $98602bd11beb292b$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $98602bd11beb292b$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $98602bd11beb292b$var$resolveTo(to ? to : ".", $98602bd11beb292b$var$getResolveToMatches(contextualMatches), $98602bd11beb292b$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $98602bd11beb292b$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $98602bd11beb292b$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $98602bd11beb292b$export$fe53371bee54353d(path);
}
function $98602bd11beb292b$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$98602bd11beb292b$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$98602bd11beb292b$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $98602bd11beb292b$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $98602bd11beb292b$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $98602bd11beb292b$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$98602bd11beb292b$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$98602bd11beb292b$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $98602bd11beb292b$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $98602bd11beb292b$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $98602bd11beb292b$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $98602bd11beb292b$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $98602bd11beb292b$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($98602bd11beb292b$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $98602bd11beb292b$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $98602bd11beb292b$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $98602bd11beb292b$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $98602bd11beb292b$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $98602bd11beb292b$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $98602bd11beb292b$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $98602bd11beb292b$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$98602bd11beb292b$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $98602bd11beb292b$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($98602bd11beb292b$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $98602bd11beb292b$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($98602bd11beb292b$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $98602bd11beb292b$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $98602bd11beb292b$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $98602bd11beb292b$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $98602bd11beb292b$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $98602bd11beb292b$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $98602bd11beb292b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $98602bd11beb292b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($98602bd11beb292b$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $98602bd11beb292b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $98602bd11beb292b$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $98602bd11beb292b$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$98602bd11beb292b$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $98602bd11beb292b$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $98602bd11beb292b$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $98602bd11beb292b$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $98602bd11beb292b$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $98602bd11beb292b$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$98602bd11beb292b$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $98602bd11beb292b$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $98602bd11beb292b$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $98602bd11beb292b$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$98602bd11beb292b$var$isSameRoute(aChild, bChild))) ?? false;
}
var $98602bd11beb292b$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $98602bd11beb292b$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $98602bd11beb292b$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $98602bd11beb292b$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $98602bd11beb292b$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $98602bd11beb292b$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $98602bd11beb292b$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $98602bd11beb292b$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $98602bd11beb292b$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $98602bd11beb292b$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $98602bd11beb292b$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $98602bd11beb292b$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $98602bd11beb292b$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $98602bd11beb292b$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $98602bd11beb292b$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $98602bd11beb292b$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $98602bd11beb292b$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $98602bd11beb292b$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $98602bd11beb292b$var$isNonNullable(value) {
    return value !== void 0;
}
function $98602bd11beb292b$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $98602bd11beb292b$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($98602bd11beb292b$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $98602bd11beb292b$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $98602bd11beb292b$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $98602bd11beb292b$var$defaultDataStrategy(args);
    return $98602bd11beb292b$var$runClientMiddlewarePipeline(args, ()=>$98602bd11beb292b$var$defaultDataStrategy(args));
}
function $98602bd11beb292b$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $98602bd11beb292b$var$runMiddlewarePipeline(args, handler, processResult, $98602bd11beb292b$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $98602bd11beb292b$export$e0163cfdf7bc9cfa(result) ? $98602bd11beb292b$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $98602bd11beb292b$var$runClientMiddlewarePipeline(args, handler) {
    return $98602bd11beb292b$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($98602bd11beb292b$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $98602bd11beb292b$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $98602bd11beb292b$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $98602bd11beb292b$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $98602bd11beb292b$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $98602bd11beb292b$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $98602bd11beb292b$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $98602bd11beb292b$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $98602bd11beb292b$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $98602bd11beb292b$var$loadLazyRoute(match.route, $98602bd11beb292b$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $98602bd11beb292b$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $98602bd11beb292b$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $98602bd11beb292b$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $98602bd11beb292b$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $98602bd11beb292b$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$98602bd11beb292b$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($98602bd11beb292b$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $98602bd11beb292b$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $98602bd11beb292b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $98602bd11beb292b$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $98602bd11beb292b$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $98602bd11beb292b$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $98602bd11beb292b$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $98602bd11beb292b$var$createDataFunctionUrl(request, path),
        pattern: $98602bd11beb292b$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $98602bd11beb292b$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $98602bd11beb292b$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $98602bd11beb292b$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $98602bd11beb292b$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $98602bd11beb292b$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $98602bd11beb292b$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $98602bd11beb292b$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $98602bd11beb292b$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($98602bd11beb292b$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $98602bd11beb292b$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $98602bd11beb292b$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($98602bd11beb292b$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $98602bd11beb292b$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $98602bd11beb292b$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $98602bd11beb292b$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($98602bd11beb292b$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $98602bd11beb292b$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $98602bd11beb292b$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$98602bd11beb292b$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $98602bd11beb292b$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $98602bd11beb292b$export$30ab200a1a0a2def = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $98602bd11beb292b$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($98602bd11beb292b$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if ($98602bd11beb292b$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $98602bd11beb292b$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $98602bd11beb292b$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($98602bd11beb292b$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $98602bd11beb292b$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($98602bd11beb292b$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $98602bd11beb292b$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $98602bd11beb292b$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $98602bd11beb292b$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $98602bd11beb292b$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $98602bd11beb292b$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $98602bd11beb292b$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $98602bd11beb292b$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $98602bd11beb292b$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $98602bd11beb292b$export$f5708dca728d7177(!$98602bd11beb292b$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($98602bd11beb292b$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $98602bd11beb292b$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $98602bd11beb292b$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $98602bd11beb292b$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $98602bd11beb292b$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $98602bd11beb292b$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $98602bd11beb292b$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($98602bd11beb292b$var$isErrorResult(result)) {
            let boundaryMatch = $98602bd11beb292b$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($98602bd11beb292b$var$isRedirectResult(result)) $98602bd11beb292b$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $98602bd11beb292b$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $98602bd11beb292b$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $98602bd11beb292b$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $98602bd11beb292b$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $98602bd11beb292b$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $98602bd11beb292b$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $98602bd11beb292b$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $98602bd11beb292b$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $98602bd11beb292b$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $98602bd11beb292b$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($98602bd11beb292b$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $98602bd11beb292b$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $98602bd11beb292b$export$8ccf933b0513f8d0(path) : path;
    return $98602bd11beb292b$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $98602bd11beb292b$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $98602bd11beb292b$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $98602bd11beb292b$var$dataWithResponseInitToErrorResponse(data2) {
    return new $98602bd11beb292b$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $98602bd11beb292b$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $98602bd11beb292b$var$isDataStrategyResult(value));
}
function $98602bd11beb292b$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $98602bd11beb292b$var$isRedirectDataStrategyResult(result) {
    return $98602bd11beb292b$export$3f1eb41d9a6a6a27(result.result) && $98602bd11beb292b$var$redirectStatusCodes.has(result.result.status);
}
function $98602bd11beb292b$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $98602bd11beb292b$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $98602bd11beb292b$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $98602bd11beb292b$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $98602bd11beb292b$export$794b2760043cf8cd(statusCode) {
    return $98602bd11beb292b$var$redirectStatusCodes.has(statusCode);
}
function $98602bd11beb292b$export$6e80290866a84dd4(result) {
    return $98602bd11beb292b$export$3f1eb41d9a6a6a27(result) && $98602bd11beb292b$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $98602bd11beb292b$var$isValidMethod(method) {
    return $98602bd11beb292b$var$validRequestMethods.has(method.toUpperCase());
}
function $98602bd11beb292b$export$cbae47800eb95bc3(method) {
    return $98602bd11beb292b$var$validMutationMethods.has(method.toUpperCase());
}
function $98602bd11beb292b$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $98602bd11beb292b$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $98602bd11beb292b$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $98602bd11beb292b$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $98602bd11beb292b$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $98602bd11beb292b$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $98602bd11beb292b$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $98602bd11beb292b$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $98602bd11beb292b$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $98602bd11beb292b$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $98602bd11beb292b$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $98602bd11beb292b$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($98602bd11beb292b$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $98602bd11beb292b$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($98602bd11beb292b$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $98602bd11beb292b$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $98602bd11beb292b$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $98602bd11beb292b$export$2eeee58951ff3c1c = $bh6RR.createContext(null);
$98602bd11beb292b$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $98602bd11beb292b$export$315e3ffb01f217 = $bh6RR.createContext(null);
$98602bd11beb292b$export$315e3ffb01f217.displayName = "DataRouterState";
var $98602bd11beb292b$export$717f757c655223f1 = $bh6RR.createContext(false);
function $98602bd11beb292b$var$useIsRSCRouterContext() {
    return $bh6RR.useContext($98602bd11beb292b$export$717f757c655223f1);
}
var $98602bd11beb292b$export$3681f408decb40d1 = $bh6RR.createContext({
    isTransitioning: false
});
$98602bd11beb292b$export$3681f408decb40d1.displayName = "ViewTransition";
var $98602bd11beb292b$export$cb3f1df1bef00a39 = $bh6RR.createContext(/* @__PURE__ */ new Map());
$98602bd11beb292b$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $98602bd11beb292b$var$AwaitContext = $bh6RR.createContext(null);
$98602bd11beb292b$var$AwaitContext.displayName = "Await";
var $98602bd11beb292b$export$2666c20e15407622 = (props)=>$bh6RR.createElement($98602bd11beb292b$var$AwaitContext.Provider, props);
var $98602bd11beb292b$export$3044ab7fdabeaee6 = $bh6RR.createContext(null);
$98602bd11beb292b$export$3044ab7fdabeaee6.displayName = "Navigation";
var $98602bd11beb292b$export$e6a44b110a0c44d3 = $bh6RR.createContext(null);
$98602bd11beb292b$export$e6a44b110a0c44d3.displayName = "Location";
var $98602bd11beb292b$export$aac280ed165a4397 = $bh6RR.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$98602bd11beb292b$export$aac280ed165a4397.displayName = "Route";
var $98602bd11beb292b$var$RouteErrorContext = $bh6RR.createContext(null);
$98602bd11beb292b$var$RouteErrorContext.displayName = "RouteError";
var $98602bd11beb292b$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $98602bd11beb292b$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $98602bd11beb292b$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $98602bd11beb292b$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $98602bd11beb292b$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$98602bd11beb292b$var$ERROR_DIGEST_BASE}:${$98602bd11beb292b$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $98602bd11beb292b$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$98602bd11beb292b$var$ERROR_DIGEST_BASE}:${$98602bd11beb292b$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $98602bd11beb292b$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $98602bd11beb292b$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $98602bd11beb292b$export$f5708dca728d7177($98602bd11beb292b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $bh6RR.useContext($98602bd11beb292b$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $98602bd11beb292b$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $98602bd11beb292b$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $98602bd11beb292b$export$9c954a9d03d32f4a() {
    return $bh6RR.useContext($98602bd11beb292b$export$e6a44b110a0c44d3) != null;
}
function $98602bd11beb292b$export$45d76561a5302f2b() {
    $98602bd11beb292b$export$f5708dca728d7177($98602bd11beb292b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $bh6RR.useContext($98602bd11beb292b$export$e6a44b110a0c44d3).location;
}
function $98602bd11beb292b$export$1b3f31771c5d07c() {
    return $bh6RR.useContext($98602bd11beb292b$export$e6a44b110a0c44d3).navigationType;
}
function $98602bd11beb292b$export$6c330e8992e8a295(pattern) {
    $98602bd11beb292b$export$f5708dca728d7177($98602bd11beb292b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $98602bd11beb292b$export$45d76561a5302f2b();
    return $bh6RR.useMemo(()=>$98602bd11beb292b$export$81336c211d5ff295(pattern, $98602bd11beb292b$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $98602bd11beb292b$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $98602bd11beb292b$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $bh6RR.useContext($98602bd11beb292b$export$3044ab7fdabeaee6).static;
    if (!isStatic) $bh6RR.useLayoutEffect(cb);
}
function $98602bd11beb292b$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $bh6RR.useContext($98602bd11beb292b$export$aac280ed165a4397);
    return isDataRoute ? $98602bd11beb292b$var$useNavigateStable() : $98602bd11beb292b$var$useNavigateUnstable();
}
function $98602bd11beb292b$var$useNavigateUnstable() {
    $98602bd11beb292b$export$f5708dca728d7177($98602bd11beb292b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $bh6RR.useContext($98602bd11beb292b$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $bh6RR.useContext($98602bd11beb292b$export$3044ab7fdabeaee6);
    let { matches: matches } = $bh6RR.useContext($98602bd11beb292b$export$aac280ed165a4397);
    let { pathname: locationPathname } = $98602bd11beb292b$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($98602bd11beb292b$var$getResolveToMatches(matches));
    let activeRef = $bh6RR.useRef(false);
    $98602bd11beb292b$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback((to, options = {})=>{
        $98602bd11beb292b$var$warning(activeRef.current, $98602bd11beb292b$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $98602bd11beb292b$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $98602bd11beb292b$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $98602bd11beb292b$var$OutletContext = $bh6RR.createContext(null);
function $98602bd11beb292b$export$4138103a3ae699cc() {
    return $bh6RR.useContext($98602bd11beb292b$var$OutletContext);
}
function $98602bd11beb292b$export$a3be3530d8e40d0b(context) {
    let outlet = $bh6RR.useContext($98602bd11beb292b$export$aac280ed165a4397).outlet;
    return $bh6RR.useMemo(()=>outlet && /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $98602bd11beb292b$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $bh6RR.useContext($98602bd11beb292b$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $98602bd11beb292b$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $bh6RR.useContext($98602bd11beb292b$export$aac280ed165a4397);
    let { pathname: locationPathname } = $98602bd11beb292b$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($98602bd11beb292b$var$getResolveToMatches(matches));
    return $bh6RR.useMemo(()=>$98602bd11beb292b$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $98602bd11beb292b$export$5d3fca4a98652595(routes, locationArg) {
    return $98602bd11beb292b$var$useRoutesImpl(routes, locationArg);
}
function $98602bd11beb292b$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $98602bd11beb292b$export$f5708dca728d7177($98602bd11beb292b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $bh6RR.useContext($98602bd11beb292b$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $bh6RR.useContext($98602bd11beb292b$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($98602bd11beb292b$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $98602bd11beb292b$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $98602bd11beb292b$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $98602bd11beb292b$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $98602bd11beb292b$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $98602bd11beb292b$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($98602bd11beb292b$export$945fecf35a8ef089) {
        $98602bd11beb292b$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $98602bd11beb292b$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $98602bd11beb292b$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $98602bd11beb292b$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $98602bd11beb292b$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $98602bd11beb292b$var$DefaultErrorComponent() {
    let error = $98602bd11beb292b$export$ed527bf60f6e05f2();
    let message = $98602bd11beb292b$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($98602bd11beb292b$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, /* @__PURE__ */ $bh6RR.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $bh6RR.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $bh6RR.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $bh6RR.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, /* @__PURE__ */ $bh6RR.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $bh6RR.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $bh6RR.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $98602bd11beb292b$var$defaultErrorElement = /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$DefaultErrorComponent, null);
var $98602bd11beb292b$var$RenderErrorBoundary = class extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $98602bd11beb292b$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$98602bd11beb292b$var$RenderErrorBoundary.contextType = $98602bd11beb292b$export$717f757c655223f1;
var $98602bd11beb292b$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $98602bd11beb292b$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $bh6RR.useContext($98602bd11beb292b$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $98602bd11beb292b$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $98602bd11beb292b$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $98602bd11beb292b$var$parseToInfo(redirect2.location, basename);
            if ($98602bd11beb292b$var$isBrowser && !$98602bd11beb292b$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = parsed.absoluteURL || parsed.to;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $98602bd11beb292b$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $bh6RR.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${parsed.absoluteURL || parsed.to}`
            });
        }
    }
    return children;
}
function $98602bd11beb292b$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $bh6RR.useContext($98602bd11beb292b$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $98602bd11beb292b$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $98602bd11beb292b$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $98602bd11beb292b$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $98602bd11beb292b$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $98602bd11beb292b$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $bh6RR.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $98602bd11beb292b$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $98602bd11beb292b$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext($98602bd11beb292b$export$2eeee58951ff3c1c);
    $98602bd11beb292b$export$f5708dca728d7177(ctx, $98602bd11beb292b$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $98602bd11beb292b$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext($98602bd11beb292b$export$315e3ffb01f217);
    $98602bd11beb292b$export$f5708dca728d7177(state, $98602bd11beb292b$var$getDataRouterConsoleError(hookName));
    return state;
}
function $98602bd11beb292b$var$useRouteContext(hookName) {
    let route = $bh6RR.useContext($98602bd11beb292b$export$aac280ed165a4397);
    $98602bd11beb292b$export$f5708dca728d7177(route, $98602bd11beb292b$var$getDataRouterConsoleError(hookName));
    return route;
}
function $98602bd11beb292b$var$useCurrentRouteId(hookName) {
    let route = $98602bd11beb292b$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $98602bd11beb292b$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $98602bd11beb292b$var$useRouteId() {
    return $98602bd11beb292b$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $98602bd11beb292b$export$d0fd4b7106de2769() {
    let state = $98602bd11beb292b$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $bh6RR.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $98602bd11beb292b$export$600dc272ed516c15() {
    let dataRouterContext = $98602bd11beb292b$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $98602bd11beb292b$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $bh6RR.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $bh6RR.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $98602bd11beb292b$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $98602bd11beb292b$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $bh6RR.useMemo(()=>matches.map((m)=>$98602bd11beb292b$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $98602bd11beb292b$export$1448a5050d252c4d() {
    let state = $98602bd11beb292b$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $98602bd11beb292b$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $98602bd11beb292b$export$fd5d37484eab868d(routeId) {
    let state = $98602bd11beb292b$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $98602bd11beb292b$export$fdc00f3f26066d5e() {
    let state = $98602bd11beb292b$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $98602bd11beb292b$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $98602bd11beb292b$export$ed527bf60f6e05f2() {
    let error = $bh6RR.useContext($98602bd11beb292b$var$RouteErrorContext);
    let state = $98602bd11beb292b$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $98602bd11beb292b$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $98602bd11beb292b$export$78a72ddb39bdd145() {
    let value = $bh6RR.useContext($98602bd11beb292b$var$AwaitContext);
    return value?._data;
}
function $98602bd11beb292b$export$17f53340677d5831() {
    let value = $bh6RR.useContext($98602bd11beb292b$var$AwaitContext);
    return value?._error;
}
var $98602bd11beb292b$var$blockerId = 0;
function $98602bd11beb292b$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $98602bd11beb292b$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $98602bd11beb292b$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $bh6RR.useState("");
    let blockerFunction = $bh6RR.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $98602bd11beb292b$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $98602bd11beb292b$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $bh6RR.useEffect(()=>{
        let key = String(++$98602bd11beb292b$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $bh6RR.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $98602bd11beb292b$export$386d57f03f0b2883;
}
function $98602bd11beb292b$var$useNavigateStable() {
    let { router: router } = $98602bd11beb292b$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $98602bd11beb292b$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $bh6RR.useRef(false);
    $98602bd11beb292b$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(async (to, options = {})=>{
        $98602bd11beb292b$var$warning(activeRef.current, $98602bd11beb292b$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $98602bd11beb292b$var$alreadyWarned = {};
function $98602bd11beb292b$var$warningOnce(key, cond, message) {
    if (!cond && !$98602bd11beb292b$var$alreadyWarned[key]) {
        $98602bd11beb292b$var$alreadyWarned[key] = true;
        $98602bd11beb292b$var$warning(false, message);
    }
}
function $98602bd11beb292b$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $98602bd11beb292b$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $98602bd11beb292b$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $98602bd11beb292b$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $98602bd11beb292b$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $98602bd11beb292b$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $bh6RR.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$98602bd11beb292b$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $bh6RR.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$98602bd11beb292b$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $bh6RR.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $98602bd11beb292b$var$alreadyWarned2 = {};
function $98602bd11beb292b$export$5b28268982f175ba(condition, message) {
    if (!condition && !$98602bd11beb292b$var$alreadyWarned2[message]) {
        $98602bd11beb292b$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $98602bd11beb292b$var$USE_OPTIMISTIC = "useOptimistic";
var $98602bd11beb292b$var$useOptimisticImpl = $bh6RR[$98602bd11beb292b$var$USE_OPTIMISTIC];
var $98602bd11beb292b$var$stableUseOptimisticSetter = ()=>void 0;
function $98602bd11beb292b$var$useOptimisticSafe(val) {
    if ($98602bd11beb292b$var$useOptimisticImpl) return $98602bd11beb292b$var$useOptimisticImpl(val);
    else return [
        val,
        $98602bd11beb292b$var$stableUseOptimisticSetter
    ];
}
function $98602bd11beb292b$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($98602bd11beb292b$export$945fecf35a8ef089) {
            if (route.element) $98602bd11beb292b$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $bh6RR.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($98602bd11beb292b$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $98602bd11beb292b$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $bh6RR.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($98602bd11beb292b$export$945fecf35a8ef089) {
            if (route.errorElement) $98602bd11beb292b$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $bh6RR.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $98602bd11beb292b$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $98602bd11beb292b$export$f30f7e456d254e83(routes, opts) {
    return $98602bd11beb292b$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $98602bd11beb292b$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $98602bd11beb292b$export$e2fd2c03906469db,
        mapRouteProperties: $98602bd11beb292b$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $98602bd11beb292b$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $98602bd11beb292b$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $98602bd11beb292b$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $bh6RR.useState(router.state);
    let [state, setOptimisticState] = $98602bd11beb292b$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $bh6RR.useState();
    let [vtContext, setVtContext] = $bh6RR.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $bh6RR.useState();
    let [transition, setTransition] = $bh6RR.useState();
    let [interruption, setInterruption] = $bh6RR.useState();
    let fetcherData = $bh6RR.useRef(/* @__PURE__ */ new Map());
    let setState = $bh6RR.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $98602bd11beb292b$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $98602bd11beb292b$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $98602bd11beb292b$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $bh6RR.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$98602bd11beb292b$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $bh6RR.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $98602bd11beb292b$var$Deferred());
    }, [
        vtContext
    ]);
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $bh6RR.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$98602bd11beb292b$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $bh6RR.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $98602bd11beb292b$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $98602bd11beb292b$var$MemoizedDataRoutes = $bh6RR.memo($98602bd11beb292b$var$DataRoutes2);
function $98602bd11beb292b$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $98602bd11beb292b$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $98602bd11beb292b$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = $98602bd11beb292b$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let setState = $bh6RR.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $bh6RR.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $98602bd11beb292b$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $98602bd11beb292b$export$f5708dca728d7177($98602bd11beb292b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $bh6RR.useContext($98602bd11beb292b$export$3044ab7fdabeaee6);
    $98602bd11beb292b$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $bh6RR.useContext($98602bd11beb292b$export$aac280ed165a4397);
    let { pathname: locationPathname } = $98602bd11beb292b$export$45d76561a5302f2b();
    let navigate = $98602bd11beb292b$export$9770f232ac06a008();
    let path = $98602bd11beb292b$var$resolveTo(to, $98602bd11beb292b$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $bh6RR.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $98602bd11beb292b$export$910ae8079b2c2852(props) {
    return $98602bd11beb292b$export$a3be3530d8e40d0b(props.context);
}
function $98602bd11beb292b$export$e7b0ac011bb776c6(props) {
    $98602bd11beb292b$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $98602bd11beb292b$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $98602bd11beb292b$export$f5708dca728d7177(!$98602bd11beb292b$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $bh6RR.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $98602bd11beb292b$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $bh6RR.useMemo(()=>{
        let trailingPathname = $98602bd11beb292b$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $98602bd11beb292b$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $98602bd11beb292b$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $98602bd11beb292b$export$5d3fca4a98652595($98602bd11beb292b$export$16da398f5434bdec(children), location);
}
function $98602bd11beb292b$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $bh6RR.useContext($98602bd11beb292b$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $bh6RR.useContext($98602bd11beb292b$export$315e3ffb01f217);
    let onError = $bh6RR.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $98602bd11beb292b$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$ResolveAwait, null, children));
}
var $98602bd11beb292b$var$AwaitErrorBoundary = class extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $98602bd11beb292b$var$ResolveAwait({ children: children }) {
    let data2 = $98602bd11beb292b$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, toRender);
}
function $98602bd11beb292b$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $bh6RR.Children.forEach(children, (element, index)=>{
        if (!$bh6RR.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $bh6RR.Fragment) {
            routes.push.apply(routes, $98602bd11beb292b$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $98602bd11beb292b$export$f5708dca728d7177(element.type === $98602bd11beb292b$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $98602bd11beb292b$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $98602bd11beb292b$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $98602bd11beb292b$export$9b5b6d122dea0c88 = $98602bd11beb292b$export$16da398f5434bdec;
function $98602bd11beb292b$export$daf73786167a7f72(matches) {
    return $98602bd11beb292b$var$_renderMatches(matches);
}
function $98602bd11beb292b$var$useRouteComponentProps() {
    return {
        params: $98602bd11beb292b$export$99eaa27ddbbb95ef(),
        loaderData: $98602bd11beb292b$export$1448a5050d252c4d(),
        actionData: $98602bd11beb292b$export$fdc00f3f26066d5e(),
        matches: $98602bd11beb292b$export$2378eb7f5ff86053()
    };
}
function $98602bd11beb292b$export$6c4f3826290c37af({ children: children }) {
    const props = $98602bd11beb292b$var$useRouteComponentProps();
    return $bh6RR.cloneElement(children, props);
}
function $98602bd11beb292b$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $98602bd11beb292b$var$useRouteComponentProps();
        return $bh6RR.createElement(Component4, props);
    };
}
function $98602bd11beb292b$var$useHydrateFallbackProps() {
    return {
        params: $98602bd11beb292b$export$99eaa27ddbbb95ef(),
        loaderData: $98602bd11beb292b$export$1448a5050d252c4d(),
        actionData: $98602bd11beb292b$export$fdc00f3f26066d5e()
    };
}
function $98602bd11beb292b$export$f8cff34f39c1932a({ children: children }) {
    const props = $98602bd11beb292b$var$useHydrateFallbackProps();
    return $bh6RR.cloneElement(children, props);
}
function $98602bd11beb292b$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $98602bd11beb292b$var$useHydrateFallbackProps();
        return $bh6RR.createElement(HydrateFallback, props);
    };
}
function $98602bd11beb292b$var$useErrorBoundaryProps() {
    return {
        params: $98602bd11beb292b$export$99eaa27ddbbb95ef(),
        loaderData: $98602bd11beb292b$export$1448a5050d252c4d(),
        actionData: $98602bd11beb292b$export$fdc00f3f26066d5e(),
        error: $98602bd11beb292b$export$ed527bf60f6e05f2()
    };
}
function $98602bd11beb292b$export$e5afde5c4b6d747b({ children: children }) {
    const props = $98602bd11beb292b$var$useErrorBoundaryProps();
    return $bh6RR.cloneElement(children, props);
}
function $98602bd11beb292b$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $98602bd11beb292b$var$useErrorBoundaryProps();
        return $bh6RR.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $98602bd11beb292b$var$defaultMethod = "get";
var $98602bd11beb292b$var$defaultEncType = "application/x-www-form-urlencoded";
function $98602bd11beb292b$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $98602bd11beb292b$var$isButtonElement(object) {
    return $98602bd11beb292b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $98602bd11beb292b$var$isFormElement(object) {
    return $98602bd11beb292b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $98602bd11beb292b$var$isInputElement(object) {
    return $98602bd11beb292b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $98602bd11beb292b$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $98602bd11beb292b$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$98602bd11beb292b$var$isModifiedEvent(event);
}
function $98602bd11beb292b$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $98602bd11beb292b$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $98602bd11beb292b$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $98602bd11beb292b$var$_formDataSupportsSubmitter = null;
function $98602bd11beb292b$var$isFormDataSubmitterSupported() {
    if ($98602bd11beb292b$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $98602bd11beb292b$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $98602bd11beb292b$var$_formDataSupportsSubmitter = true;
    }
    return $98602bd11beb292b$var$_formDataSupportsSubmitter;
}
var $98602bd11beb292b$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $98602bd11beb292b$var$getFormEncType(encType) {
    if (encType != null && !$98602bd11beb292b$var$supportedFormEncTypes.has(encType)) {
        $98602bd11beb292b$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$98602bd11beb292b$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $98602bd11beb292b$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($98602bd11beb292b$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $98602bd11beb292b$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $98602bd11beb292b$var$defaultMethod;
        encType = $98602bd11beb292b$var$getFormEncType(target.getAttribute("enctype")) || $98602bd11beb292b$var$defaultEncType;
        formData = new FormData(target);
    } else if ($98602bd11beb292b$var$isButtonElement(target) || $98602bd11beb292b$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $98602bd11beb292b$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $98602bd11beb292b$var$defaultMethod;
        encType = $98602bd11beb292b$var$getFormEncType(target.getAttribute("formenctype")) || $98602bd11beb292b$var$getFormEncType(form.getAttribute("enctype")) || $98602bd11beb292b$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$98602bd11beb292b$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($98602bd11beb292b$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $98602bd11beb292b$var$defaultMethod;
        action = null;
        encType = $98602bd11beb292b$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $98602bd11beb292b$var$HOLE = -1;
var $98602bd11beb292b$var$NAN = -2;
var $98602bd11beb292b$var$NEGATIVE_INFINITY = -3;
var $98602bd11beb292b$var$NEGATIVE_ZERO = -4;
var $98602bd11beb292b$var$NULL = -5;
var $98602bd11beb292b$var$POSITIVE_INFINITY = -6;
var $98602bd11beb292b$var$UNDEFINED = -7;
var $98602bd11beb292b$var$TYPE_BIGINT = "B";
var $98602bd11beb292b$var$TYPE_DATE = "D";
var $98602bd11beb292b$var$TYPE_ERROR = "E";
var $98602bd11beb292b$var$TYPE_MAP = "M";
var $98602bd11beb292b$var$TYPE_NULL_OBJECT = "N";
var $98602bd11beb292b$var$TYPE_PROMISE = "P";
var $98602bd11beb292b$var$TYPE_REGEXP = "R";
var $98602bd11beb292b$var$TYPE_SET = "S";
var $98602bd11beb292b$var$TYPE_SYMBOL = "Y";
var $98602bd11beb292b$var$TYPE_URL = "U";
var $98602bd11beb292b$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $98602bd11beb292b$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $98602bd11beb292b$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $98602bd11beb292b$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $98602bd11beb292b$var$TIME_LIMIT_MS = 1;
var $98602bd11beb292b$var$getNow = ()=>Date.now();
var $98602bd11beb292b$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $98602bd11beb292b$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $98602bd11beb292b$var$UNDEFINED;
    if (input === null) return $98602bd11beb292b$var$NULL;
    if (Number.isNaN(input)) return $98602bd11beb292b$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $98602bd11beb292b$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $98602bd11beb292b$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $98602bd11beb292b$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $98602bd11beb292b$var$stringify.call(this, stack);
    return index;
}
async function $98602bd11beb292b$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $98602bd11beb292b$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $98602bd11beb292b$var$UNDEFINED;
        if (value === null) return $98602bd11beb292b$var$NULL;
        if (Number.isNaN(value)) return $98602bd11beb292b$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $98602bd11beb292b$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $98602bd11beb292b$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $98602bd11beb292b$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $98602bd11beb292b$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $98602bd11beb292b$var$TIME_LIMIT_MS) {
            await $98602bd11beb292b$var$yieldToMain();
            lastYieldTime = $98602bd11beb292b$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$98602bd11beb292b$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$98602bd11beb292b$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$98602bd11beb292b$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $98602bd11beb292b$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$98602bd11beb292b$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$98602bd11beb292b$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$98602bd11beb292b$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$98602bd11beb292b$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$98602bd11beb292b$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$98602bd11beb292b$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$98602bd11beb292b$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$98602bd11beb292b$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$98602bd11beb292b$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$98602bd11beb292b$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($98602bd11beb292b$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $98602bd11beb292b$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $98602bd11beb292b$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $98602bd11beb292b$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $98602bd11beb292b$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $98602bd11beb292b$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $98602bd11beb292b$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $98602bd11beb292b$var$hydrate.call(this, startIndex);
}
function $98602bd11beb292b$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $98602bd11beb292b$var$UNDEFINED:
                set(void 0);
                continue;
            case $98602bd11beb292b$var$NULL:
                set(null);
                continue;
            case $98602bd11beb292b$var$NAN:
                set(NaN);
                continue;
            case $98602bd11beb292b$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $98602bd11beb292b$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $98602bd11beb292b$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $98602bd11beb292b$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $98602bd11beb292b$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $98602bd11beb292b$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $98602bd11beb292b$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $98602bd11beb292b$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $98602bd11beb292b$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $98602bd11beb292b$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $98602bd11beb292b$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $98602bd11beb292b$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $98602bd11beb292b$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $98602bd11beb292b$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $98602bd11beb292b$var$globalObj && $98602bd11beb292b$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $98602bd11beb292b$var$globalObj && typeof $98602bd11beb292b$var$globalObj[errorType] === "function" ? new $98602bd11beb292b$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $98602bd11beb292b$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $98602bd11beb292b$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $98602bd11beb292b$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $98602bd11beb292b$var$Deferred2();
    const reader = readable.pipeThrough($98602bd11beb292b$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $98602bd11beb292b$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $98602bd11beb292b$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $98602bd11beb292b$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $98602bd11beb292b$var$unflatten.call(this, line)
    };
}
async function $98602bd11beb292b$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $98602bd11beb292b$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $98602bd11beb292b$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $98602bd11beb292b$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $98602bd11beb292b$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $98602bd11beb292b$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $98602bd11beb292b$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $98602bd11beb292b$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$98602bd11beb292b$var$TYPE_PROMISE}${deferredId}:[["${$98602bd11beb292b$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$98602bd11beb292b$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$98602bd11beb292b$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $98602bd11beb292b$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$98602bd11beb292b$var$TYPE_ERROR}${deferredId}:[["${$98602bd11beb292b$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$98602bd11beb292b$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$98602bd11beb292b$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $98602bd11beb292b$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $98602bd11beb292b$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $98602bd11beb292b$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $98602bd11beb292b$export$4cf11838cdc2a8a8(html) {
    return html.replace($98602bd11beb292b$var$ESCAPE_REGEX, (match)=>$98602bd11beb292b$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $98602bd11beb292b$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $98602bd11beb292b$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $98602bd11beb292b$var$SingleFetchNoResultError = class extends Error {
};
var $98602bd11beb292b$export$ae9272e641ead836 = 202;
var $98602bd11beb292b$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $98602bd11beb292b$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $bh6RR.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$98602bd11beb292b$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, scriptTag, /* @__PURE__ */ $bh6RR.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, scriptTag, /* @__PURE__ */ $bh6RR.createElement($bh6RR.Suspense, null, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $98602bd11beb292b$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $98602bd11beb292b$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $98602bd11beb292b$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $98602bd11beb292b$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $98602bd11beb292b$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $98602bd11beb292b$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $98602bd11beb292b$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $98602bd11beb292b$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $98602bd11beb292b$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $98602bd11beb292b$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $98602bd11beb292b$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $98602bd11beb292b$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($98602bd11beb292b$export$3f1eb41d9a6a6a27(result.result) || $98602bd11beb292b$export$972111febbeef05b(result.result) || $98602bd11beb292b$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $98602bd11beb292b$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $98602bd11beb292b$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $98602bd11beb292b$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $98602bd11beb292b$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$98602bd11beb292b$var$createDeferred2());
    let singleFetchDfd = $98602bd11beb292b$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $98602bd11beb292b$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $98602bd11beb292b$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $98602bd11beb292b$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $98602bd11beb292b$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $98602bd11beb292b$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $98602bd11beb292b$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $98602bd11beb292b$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $98602bd11beb292b$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $98602bd11beb292b$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $98602bd11beb292b$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $98602bd11beb292b$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$98602bd11beb292b$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$98602bd11beb292b$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $98602bd11beb292b$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $98602bd11beb292b$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $98602bd11beb292b$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $98602bd11beb292b$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $98602bd11beb292b$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $98602bd11beb292b$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($98602bd11beb292b$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $98602bd11beb292b$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $98602bd11beb292b$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($98602bd11beb292b$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$98602bd11beb292b$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $98602bd11beb292b$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $98602bd11beb292b$export$4023ad4ecd4126a2(body, global) {
    return $98602bd11beb292b$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $98602bd11beb292b$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $98602bd11beb292b$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$98602bd11beb292b$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $98602bd11beb292b$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $98602bd11beb292b$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $98602bd11beb292b$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $98602bd11beb292b$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $98602bd11beb292b$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $98602bd11beb292b$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $98602bd11beb292b$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $98602bd11beb292b$var$getModuleLinkHrefs(matches, manifest);
    return $98602bd11beb292b$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $98602bd11beb292b$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $98602bd11beb292b$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $98602bd11beb292b$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($98602bd11beb292b$var$prefetchStyleLink));
}
async function $98602bd11beb292b$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$98602bd11beb292b$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$98602bd11beb292b$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$98602bd11beb292b$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($98602bd11beb292b$var$prefetchStyleLink));
}
async function $98602bd11beb292b$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $98602bd11beb292b$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $98602bd11beb292b$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $98602bd11beb292b$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $98602bd11beb292b$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $98602bd11beb292b$var$dedupeLinkDescriptors(links.flat(1).filter($98602bd11beb292b$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $98602bd11beb292b$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $98602bd11beb292b$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $98602bd11beb292b$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $98602bd11beb292b$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $98602bd11beb292b$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $98602bd11beb292b$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$98602bd11beb292b$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($98602bd11beb292b$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $98602bd11beb292b$var$_isPreloadSupported;
function $98602bd11beb292b$var$isPreloadSupported() {
    if ($98602bd11beb292b$var$_isPreloadSupported !== void 0) return $98602bd11beb292b$var$_isPreloadSupported;
    let el = document.createElement("link");
    $98602bd11beb292b$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $98602bd11beb292b$var$_isPreloadSupported;
}
function $98602bd11beb292b$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $98602bd11beb292b$export$945fecf35a8ef089 ? /* @__PURE__ */ $bh6RR.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $98602bd11beb292b$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $98602bd11beb292b$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $98602bd11beb292b$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $98602bd11beb292b$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$RemixRootDefaultErrorBoundary, {
            error: $98602bd11beb292b$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $bh6RR.createElement(routeModule.Layout, null, /* @__PURE__ */ $bh6RR.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $bh6RR.createElement(routeModule.Layout, null, /* @__PURE__ */ $bh6RR.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $bh6RR.createElement(routeModule.Layout, null, /* @__PURE__ */ $bh6RR.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $98602bd11beb292b$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $98602bd11beb292b$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $98602bd11beb292b$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$98602bd11beb292b$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $98602bd11beb292b$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $98602bd11beb292b$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $98602bd11beb292b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $98602bd11beb292b$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $98602bd11beb292b$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $98602bd11beb292b$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $98602bd11beb292b$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $98602bd11beb292b$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $98602bd11beb292b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $98602bd11beb292b$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $98602bd11beb292b$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $98602bd11beb292b$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $98602bd11beb292b$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$98602bd11beb292b$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $98602bd11beb292b$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $98602bd11beb292b$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $98602bd11beb292b$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $98602bd11beb292b$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $98602bd11beb292b$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $98602bd11beb292b$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $98602bd11beb292b$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $98602bd11beb292b$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $98602bd11beb292b$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $98602bd11beb292b$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $98602bd11beb292b$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $98602bd11beb292b$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $98602bd11beb292b$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $98602bd11beb292b$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $98602bd11beb292b$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $98602bd11beb292b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $98602bd11beb292b$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $98602bd11beb292b$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $98602bd11beb292b$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $98602bd11beb292b$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $98602bd11beb292b$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $98602bd11beb292b$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $98602bd11beb292b$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $98602bd11beb292b$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $98602bd11beb292b$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $98602bd11beb292b$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $98602bd11beb292b$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $98602bd11beb292b$var$nextPaths = /* @__PURE__ */ new Set();
var $98602bd11beb292b$var$discoveredPathsMaxSize = 1e3;
var $98602bd11beb292b$var$discoveredPaths = /* @__PURE__ */ new Set();
var $98602bd11beb292b$export$b5915cf27fa06b9f = 7680;
function $98602bd11beb292b$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $98602bd11beb292b$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $98602bd11beb292b$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $98602bd11beb292b$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$98602bd11beb292b$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($98602bd11beb292b$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $98602bd11beb292b$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $98602bd11beb292b$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $98602bd11beb292b$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $bh6RR.useEffect(()=>{
        if (!$98602bd11beb292b$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$98602bd11beb292b$var$discoveredPaths.has(pathname)) $98602bd11beb292b$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($98602bd11beb292b$var$nextPaths.keys()).filter((path)=>{
                if ($98602bd11beb292b$var$discoveredPaths.has(path)) {
                    $98602bd11beb292b$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $98602bd11beb292b$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $98602bd11beb292b$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $98602bd11beb292b$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $98602bd11beb292b$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $98602bd11beb292b$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $98602bd11beb292b$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($98602bd11beb292b$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $98602bd11beb292b$export$b5915cf27fa06b9f) {
        $98602bd11beb292b$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($98602bd11beb292b$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($98602bd11beb292b$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($98602bd11beb292b$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$98602bd11beb292b$var$addToFifoQueue(p, $98602bd11beb292b$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $98602bd11beb292b$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $98602bd11beb292b$var$addToFifoQueue(path, queue) {
    if (queue.size >= $98602bd11beb292b$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $98602bd11beb292b$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $98602bd11beb292b$var$useDataRouterContext2() {
    let context = $bh6RR.useContext($98602bd11beb292b$export$2eeee58951ff3c1c);
    $98602bd11beb292b$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $98602bd11beb292b$var$useDataRouterStateContext() {
    let context = $bh6RR.useContext($98602bd11beb292b$export$315e3ffb01f217);
    $98602bd11beb292b$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $98602bd11beb292b$export$208d6a3bc3aa62bd = $bh6RR.createContext(void 0);
$98602bd11beb292b$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $98602bd11beb292b$var$useFrameworkContext() {
    let context = $bh6RR.useContext($98602bd11beb292b$export$208d6a3bc3aa62bd);
    $98602bd11beb292b$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $98602bd11beb292b$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $bh6RR.useContext($98602bd11beb292b$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $bh6RR.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $bh6RR.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $bh6RR.useRef(null);
    $bh6RR.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $bh6RR.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $98602bd11beb292b$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $98602bd11beb292b$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $98602bd11beb292b$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $98602bd11beb292b$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $98602bd11beb292b$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $98602bd11beb292b$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $98602bd11beb292b$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$98602bd11beb292b$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $98602bd11beb292b$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $98602bd11beb292b$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $98602bd11beb292b$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $98602bd11beb292b$var$useDataRouterStateContext();
    let matches = $98602bd11beb292b$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $bh6RR.useMemo(()=>$98602bd11beb292b$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $bh6RR.createElement("style", {
        [$98602bd11beb292b$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $bh6RR.createElement("link", {
        [$98602bd11beb292b$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$98602bd11beb292b$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $bh6RR.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $98602bd11beb292b$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $98602bd11beb292b$var$useIsRSCRouterContext();
    let { router: router } = $98602bd11beb292b$var$useDataRouterContext2();
    let matches = $bh6RR.useMemo(()=>$98602bd11beb292b$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (rsc) return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $98602bd11beb292b$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $98602bd11beb292b$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $bh6RR.useState([]);
    $bh6RR.useEffect(()=>{
        let interrupted = false;
        $98602bd11beb292b$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $98602bd11beb292b$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $98602bd11beb292b$export$45d76561a5302f2b();
    let { future: future } = $98602bd11beb292b$var$useFrameworkContext();
    let { basename: basename } = $98602bd11beb292b$var$useDataRouterContext2();
    let dataHrefs = $bh6RR.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $98602bd11beb292b$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $bh6RR.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $98602bd11beb292b$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $98602bd11beb292b$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $98602bd11beb292b$var$useFrameworkContext();
    let { basename: basename } = $98602bd11beb292b$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $98602bd11beb292b$var$useDataRouterStateContext();
    let newMatchesForData = $bh6RR.useMemo(()=>$98602bd11beb292b$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $bh6RR.useMemo(()=>$98602bd11beb292b$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $bh6RR.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $98602bd11beb292b$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $bh6RR.useMemo(()=>$98602bd11beb292b$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $98602bd11beb292b$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $bh6RR.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $bh6RR.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $bh6RR.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $98602bd11beb292b$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $98602bd11beb292b$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $98602bd11beb292b$var$useDataRouterStateContext();
    let location = $98602bd11beb292b$export$45d76561a5302f2b();
    let _matches = $98602bd11beb292b$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$98602bd11beb292b$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $bh6RR.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $bh6RR.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $bh6RR.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $bh6RR.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $98602bd11beb292b$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $bh6RR.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $98602bd11beb292b$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $98602bd11beb292b$var$isHydrated = false;
function $98602bd11beb292b$export$3be068dde909e563() {
    $98602bd11beb292b$var$isHydrated = true;
}
function $98602bd11beb292b$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $98602bd11beb292b$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $98602bd11beb292b$var$useDataRouterContext2();
    let { matches: routerMatches } = $98602bd11beb292b$var$useDataRouterStateContext();
    let isRSCRouterContext = $98602bd11beb292b$var$useIsRSCRouterContext();
    let enableFogOfWar = $98602bd11beb292b$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $98602bd11beb292b$var$getActiveMatches(routerMatches, null, isSpaMode);
    $bh6RR.useEffect(()=>{
        $98602bd11beb292b$export$3be068dde909e563();
    }, []);
    let initialScripts = $bh6RR.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $98602bd11beb292b$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($98602bd11beb292b$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, /* @__PURE__ */ $bh6RR.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $bh6RR.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $98602bd11beb292b$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($98602bd11beb292b$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $98602bd11beb292b$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $98602bd11beb292b$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $bh6RR.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $bh6RR.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $bh6RR.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $bh6RR.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $98602bd11beb292b$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $98602bd11beb292b$export$32e57f52df4b6e34 = class extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $98602bd11beb292b$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $bh6RR.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($98602bd11beb292b$export$972111febbeef05b(error)) return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $bh6RR.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $98602bd11beb292b$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $bh6RR.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $bh6RR.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $98602bd11beb292b$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $98602bd11beb292b$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $bh6RR.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $bh6RR.createElement("head", null, /* @__PURE__ */ $bh6RR.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $bh6RR.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $bh6RR.createElement("title", null, title)), /* @__PURE__ */ $bh6RR.createElement("body", null, /* @__PURE__ */ $bh6RR.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$ff0bf87698939488, null) : null)));
}
var $98602bd11beb292b$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($98602bd11beb292b$var$isBrowser2) window.__reactRouterVersion = "7.17.0";
} catch (e) {}
function $98602bd11beb292b$export$1f3f55432a00e06d(routes, opts) {
    return $98602bd11beb292b$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $98602bd11beb292b$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $98602bd11beb292b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $98602bd11beb292b$export$9269a41d8c4635e,
        hydrationRouteProperties: $98602bd11beb292b$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $98602bd11beb292b$export$1ba7ed8a3a7b3765(routes, opts) {
    return $98602bd11beb292b$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $98602bd11beb292b$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $98602bd11beb292b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $98602bd11beb292b$export$9269a41d8c4635e,
        hydrationRouteProperties: $98602bd11beb292b$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $98602bd11beb292b$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $98602bd11beb292b$var$deserializeErrors(state.errors)
    };
    return state;
}
function $98602bd11beb292b$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $98602bd11beb292b$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $98602bd11beb292b$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = $98602bd11beb292b$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let setState = $bh6RR.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $bh6RR.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $98602bd11beb292b$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = $98602bd11beb292b$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let setState = $bh6RR.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $bh6RR.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $98602bd11beb292b$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let setState = $bh6RR.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $bh6RR.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$98602bd11beb292b$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $98602bd11beb292b$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $98602bd11beb292b$export$a6c7ac8248d6e38a = $bh6RR.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $bh6RR.useContext($98602bd11beb292b$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $98602bd11beb292b$var$ABSOLUTE_URL_REGEX2.test(to);
    let parsed = $98602bd11beb292b$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $98602bd11beb292b$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $98602bd11beb292b$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $98602bd11beb292b$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $98602bd11beb292b$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $98602bd11beb292b$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $98602bd11beb292b$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $bh6RR.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $98602bd11beb292b$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, link, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$98602bd11beb292b$export$a6c7ac8248d6e38a.displayName = "Link";
var $98602bd11beb292b$export$b0d92dbee9b5b60d = $bh6RR.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $98602bd11beb292b$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $98602bd11beb292b$export$45d76561a5302f2b();
    let routerState = $bh6RR.useContext($98602bd11beb292b$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $bh6RR.useContext($98602bd11beb292b$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $98602bd11beb292b$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $98602bd11beb292b$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$98602bd11beb292b$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $98602bd11beb292b$export$a7fed597f4b8afd8 = $bh6RR.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $98602bd11beb292b$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $bh6RR.useContext($98602bd11beb292b$export$3044ab7fdabeaee6);
    let submit = $98602bd11beb292b$export$47c85c6e3a081d3();
    let formAction = $98602bd11beb292b$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $98602bd11beb292b$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $bh6RR.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $bh6RR.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$98602bd11beb292b$export$a7fed597f4b8afd8.displayName = "Form";
function $98602bd11beb292b$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $bh6RR.useContext($98602bd11beb292b$export$208d6a3bc3aa62bd);
    let { basename: basename } = $bh6RR.useContext($98602bd11beb292b$export$3044ab7fdabeaee6);
    let location = $98602bd11beb292b$export$45d76561a5302f2b();
    let matches = $98602bd11beb292b$export$2378eb7f5ff86053();
    $98602bd11beb292b$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $bh6RR.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $98602bd11beb292b$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $bh6RR.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$98602bd11beb292b$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $98602bd11beb292b$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$98602bd11beb292b$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$98602bd11beb292b$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $98602bd11beb292b$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $98602bd11beb292b$var$useDataRouterContext3(hookName) {
    let ctx = $bh6RR.useContext($98602bd11beb292b$export$2eeee58951ff3c1c);
    $98602bd11beb292b$export$f5708dca728d7177(ctx, $98602bd11beb292b$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $98602bd11beb292b$var$useDataRouterState2(hookName) {
    let state = $bh6RR.useContext($98602bd11beb292b$export$315e3ffb01f217);
    $98602bd11beb292b$export$f5708dca728d7177(state, $98602bd11beb292b$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $98602bd11beb292b$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $98602bd11beb292b$export$9770f232ac06a008();
    let location = $98602bd11beb292b$export$45d76561a5302f2b();
    let path = $98602bd11beb292b$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $bh6RR.useCallback((event)=>{
        if ($98602bd11beb292b$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $98602bd11beb292b$export$fe53371bee54353d(location) === $98602bd11beb292b$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $bh6RR.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $98602bd11beb292b$export$f1a78c17382fe22a(defaultInit) {
    $98602bd11beb292b$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $bh6RR.useRef($98602bd11beb292b$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $bh6RR.useRef(false);
    let location = $98602bd11beb292b$export$45d76561a5302f2b();
    let searchParams = $bh6RR.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $98602bd11beb292b$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $98602bd11beb292b$export$9770f232ac06a008();
    let setSearchParams = $bh6RR.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $98602bd11beb292b$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $98602bd11beb292b$var$fetcherId = 0;
var $98602bd11beb292b$var$getUniqueFetcherId = ()=>`__${String(++$98602bd11beb292b$var$fetcherId)}__`;
function $98602bd11beb292b$export$47c85c6e3a081d3() {
    let { router: router } = $98602bd11beb292b$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $bh6RR.useContext($98602bd11beb292b$export$3044ab7fdabeaee6);
    let currentRouteId = $98602bd11beb292b$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $bh6RR.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $98602bd11beb292b$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $98602bd11beb292b$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $98602bd11beb292b$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $bh6RR.useContext($98602bd11beb292b$export$3044ab7fdabeaee6);
    let routeContext = $bh6RR.useContext($98602bd11beb292b$export$aac280ed165a4397);
    $98602bd11beb292b$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$98602bd11beb292b$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $98602bd11beb292b$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $98602bd11beb292b$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $98602bd11beb292b$export$fe53371bee54353d(path);
}
function $98602bd11beb292b$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $98602bd11beb292b$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $98602bd11beb292b$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $bh6RR.useContext($98602bd11beb292b$export$cb3f1df1bef00a39);
    let route = $bh6RR.useContext($98602bd11beb292b$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $98602bd11beb292b$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $98602bd11beb292b$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $98602bd11beb292b$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $bh6RR.useId();
    let [fetcherKey, setFetcherKey] = $bh6RR.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $bh6RR.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $bh6RR.useCallback(async (href, opts)=>{
        $98602bd11beb292b$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $98602bd11beb292b$export$47c85c6e3a081d3();
    let submit = $bh6RR.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $bh6RR.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $bh6RR.useMemo(()=>{
        let FetcherForm2 = $bh6RR.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $98602bd11beb292b$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $bh6RR.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $98602bd11beb292b$export$fa996778a3a31087() {
    let state = $98602bd11beb292b$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $bh6RR.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $98602bd11beb292b$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $98602bd11beb292b$var$savedScrollPositions = {};
function $98602bd11beb292b$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $98602bd11beb292b$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $98602bd11beb292b$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $98602bd11beb292b$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $98602bd11beb292b$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $bh6RR.useContext($98602bd11beb292b$export$3044ab7fdabeaee6);
    let location = $98602bd11beb292b$export$45d76561a5302f2b();
    let matches = $98602bd11beb292b$export$2378eb7f5ff86053();
    let navigation = $98602bd11beb292b$export$d0fd4b7106de2769();
    $bh6RR.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $98602bd11beb292b$var$usePageHide($bh6RR.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $98602bd11beb292b$var$getScrollRestorationKey(location, matches, basename, getKey);
            $98602bd11beb292b$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $98602bd11beb292b$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($98602bd11beb292b$var$savedScrollPositions));
        } catch (error) {
            $98602bd11beb292b$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $bh6RR.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $98602bd11beb292b$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $98602bd11beb292b$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $bh6RR.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($98602bd11beb292b$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$98602bd11beb292b$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $bh6RR.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $98602bd11beb292b$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $98602bd11beb292b$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $98602bd11beb292b$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $98602bd11beb292b$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $98602bd11beb292b$export$b273b3273281a049(when);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $98602bd11beb292b$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $bh6RR.useContext($98602bd11beb292b$export$3681f408decb40d1);
    $98602bd11beb292b$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $98602bd11beb292b$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $98602bd11beb292b$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $98602bd11beb292b$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $98602bd11beb292b$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $98602bd11beb292b$export$81336c211d5ff295(path.pathname, nextPath) != null || $98602bd11beb292b$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $98602bd11beb292b$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $98602bd11beb292b$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $98602bd11beb292b$var$getStatelessNavigator();
    return /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $98602bd11beb292b$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $98602bd11beb292b$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $98602bd11beb292b$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $98602bd11beb292b$var$serializeErrors(context.errors)
        };
        let json = $98602bd11beb292b$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $bh6RR.createElement($98602bd11beb292b$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $bh6RR.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $98602bd11beb292b$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($98602bd11beb292b$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $98602bd11beb292b$var$getStatelessNavigator() {
    return {
        createHref: $98602bd11beb292b$var$createHref,
        encodeLocation: $98602bd11beb292b$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $98602bd11beb292b$export$69163f0b72ec60d9(routes, opts) {
    return $98602bd11beb292b$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $98602bd11beb292b$export$9269a41d8c4635e
    });
}
function $98602bd11beb292b$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $98602bd11beb292b$export$87cb1a9238dc3fba(routes, $98602bd11beb292b$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $98602bd11beb292b$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $98602bd11beb292b$var$createHref,
        encodeLocation: $98602bd11beb292b$var$encodeLocation,
        getFetcher () {
            return $98602bd11beb292b$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $98602bd11beb292b$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $98602bd11beb292b$var$createHref(to) {
    return typeof to === "string" ? to : $98602bd11beb292b$export$fe53371bee54353d(to);
}
function $98602bd11beb292b$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $98602bd11beb292b$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $98602bd11beb292b$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $98602bd11beb292b$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");
const $f6271c11b4093765$var$Header = (props)=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        "data-testid": "header",
        style: {
            textAlign: 'center'
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)("h1", {
            children: props.children
        })
    });
};
var $f6271c11b4093765$export$2e2bcd8739ae039 = $f6271c11b4093765$var$Header;





var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");
var $9f5a7d73bb2a9c50$export$adb608be33961c98;
$9f5a7d73bb2a9c50$export$adb608be33961c98 = `_7lECra_footer`;


const $1fa184cd0ea1168a$var$Footer = (props)=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        "data-testid": "footer",
        className: $9f5a7d73bb2a9c50$export$adb608be33961c98,
        children: props.children
    });
};
var $1fa184cd0ea1168a$export$2e2bcd8739ae039 = $1fa184cd0ea1168a$var$Footer;




parcelRequire("gggdZ");
var $5E0NG = parcelRequire("5E0NG");

const $36fdfd15ce5f504a$var$Resume = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("bC0hQ")));
const $36fdfd15ce5f504a$var$router = (0, $98602bd11beb292b$export$1f3f55432a00e06d)([
    {
        path: '/',
        element: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $f6271c11b4093765$export$2e2bcd8739ae039), {
                    children: "justin-shepard.net"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $98602bd11beb292b$export$a6c7ac8248d6e38a), {
                    to: "resume",
                    children: "Resume"
                })
            ]
        })
    },
    {
        path: '/resume',
        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bh6RR.Suspense), {
            fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5E0NG.default), {}),
            children: /*#__PURE__*/ (0, $ih19M.jsx)($36fdfd15ce5f504a$var$Resume, {})
        })
    }
]);
const $36fdfd15ce5f504a$var$App = ()=>{
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $98602bd11beb292b$export$323e4fc2fa4753fb), {
                router: $36fdfd15ce5f504a$var$router
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1fa184cd0ea1168a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                    href: "https://github.com/gyrfalcon/justin-shepard.net",
                    target: "_blank",
                    rel: "noreferrer",
                    children: "GitHub"
                })
            })
        ]
    });
};
var $36fdfd15ce5f504a$export$2e2bcd8739ae039 = $36fdfd15ce5f504a$var$App;




const $343c6f933afb1bf3$var$rootElement = document.getElementById('root');
if ($343c6f933afb1bf3$var$rootElement) (0, $6fc264ec92100d3a$exports.createRoot)($343c6f933afb1bf3$var$rootElement).render(/*#__PURE__*/ (0, $ih19M.jsx)((0, $36fdfd15ce5f504a$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=justin-shepard.net.dc1e4272.js.map
